var xr = Object.defineProperty;
var Lr = (e, r, s) => r in e ? xr(e, r, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[r] = s;
var te = (e, r, s) => Lr(e, typeof r != "symbol" ? r + "" : r, s);
import { createContext as le, useReducer as de, useEffect as ce, useCallback as x, useContext as lr } from "react";
import { jsx as Y } from "react/jsx-runtime";
function dr(e, r) {
  return function() {
    return e.apply(r, arguments);
  };
}
const { toString: Nr } = Object.prototype, { getPrototypeOf: qe } = Object, Ie = /* @__PURE__ */ ((e) => (r) => {
  const s = Nr.call(r);
  return e[s] || (e[s] = s.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), re = (e) => (e = e.toLowerCase(), (r) => Ie(r) === e), Pe = (e) => (r) => typeof r === e, { isArray: Se } = Array, Oe = Pe("undefined");
function fr(e) {
  return e !== null && !Oe(e) && e.constructor !== null && !Oe(e.constructor) && X(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const cr = re("ArrayBuffer");
function Br(e) {
  let r;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? r = ArrayBuffer.isView(e) : r = e && e.buffer && cr(e.buffer), r;
}
const Fr = Pe("string"), X = Pe("function"), ir = Pe("number"), Ae = (e) => e !== null && typeof e == "object", kr = (e) => e === !0 || e === !1, ve = (e) => {
  if (Ie(e) !== "object")
    return !1;
  const r = qe(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Mr = re("Date"), jr = re("File"), Gr = re("Blob"), $r = re("FileList"), qr = (e) => Ae(e) && X(e.pipe), Kr = (e) => {
  let r;
  return e && (typeof FormData == "function" && e instanceof FormData || X(e.append) && ((r = Ie(e)) === "formdata" || // detect form-data instance
  r === "object" && X(e.toString) && e.toString() === "[object FormData]"));
}, Qr = re("URLSearchParams"), [zr, Jr, Wr, Zr] = ["ReadableStream", "Request", "Response", "Headers"].map(re), Xr = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Te(e, r, { allOwnKeys: s = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let t, n;
  if (typeof e != "object" && (e = [e]), Se(e))
    for (t = 0, n = e.length; t < n; t++)
      r.call(null, e[t], t, e);
  else {
    const a = s ? Object.getOwnPropertyNames(e) : Object.keys(e), o = a.length;
    let l;
    for (t = 0; t < o; t++)
      l = a[t], r.call(null, e[l], l, e);
  }
}
function pr(e, r) {
  r = r.toLowerCase();
  const s = Object.keys(e);
  let t = s.length, n;
  for (; t-- > 0; )
    if (n = s[t], r === n.toLowerCase())
      return n;
  return null;
}
const pe = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, hr = (e) => !Oe(e) && e !== pe;
function fe() {
  const { caseless: e } = hr(this) && this || {}, r = {}, s = (t, n) => {
    const a = e && pr(r, n) || n;
    ve(r[a]) && ve(t) ? r[a] = fe(r[a], t) : ve(t) ? r[a] = fe({}, t) : Se(t) ? r[a] = t.slice() : r[a] = t;
  };
  for (let t = 0, n = arguments.length; t < n; t++)
    arguments[t] && Te(arguments[t], s);
  return r;
}
const Yr = (e, r, s, { allOwnKeys: t } = {}) => (Te(r, (n, a) => {
  s && X(n) ? e[a] = dr(n, s) : e[a] = n;
}, { allOwnKeys: t }), e), et = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), rt = (e, r, s, t) => {
  e.prototype = Object.create(r.prototype, t), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: r.prototype
  }), s && Object.assign(e.prototype, s);
}, tt = (e, r, s, t) => {
  let n, a, o;
  const l = {};
  if (r = r || {}, e == null) return r;
  do {
    for (n = Object.getOwnPropertyNames(e), a = n.length; a-- > 0; )
      o = n[a], (!t || t(o, e, r)) && !l[o] && (r[o] = e[o], l[o] = !0);
    e = s !== !1 && qe(e);
  } while (e && (!s || s(e, r)) && e !== Object.prototype);
  return r;
}, at = (e, r, s) => {
  e = String(e), (s === void 0 || s > e.length) && (s = e.length), s -= r.length;
  const t = e.indexOf(r, s);
  return t !== -1 && t === s;
}, st = (e) => {
  if (!e) return null;
  if (Se(e)) return e;
  let r = e.length;
  if (!ir(r)) return null;
  const s = new Array(r);
  for (; r-- > 0; )
    s[r] = e[r];
  return s;
}, nt = /* @__PURE__ */ ((e) => (r) => e && r instanceof e)(typeof Uint8Array < "u" && qe(Uint8Array)), ot = (e, r) => {
  const t = (e && e[Symbol.iterator]).call(e);
  let n;
  for (; (n = t.next()) && !n.done; ) {
    const a = n.value;
    r.call(e, a[0], a[1]);
  }
}, lt = (e, r) => {
  let s;
  const t = [];
  for (; (s = e.exec(r)) !== null; )
    t.push(s);
  return t;
}, dt = re("HTMLFormElement"), ct = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(s, t, n) {
    return t.toUpperCase() + n;
  }
), ze = (({ hasOwnProperty: e }) => (r, s) => e.call(r, s))(Object.prototype), it = re("RegExp"), ur = (e, r) => {
  const s = Object.getOwnPropertyDescriptors(e), t = {};
  Te(s, (n, a) => {
    let o;
    (o = r(n, a, e)) !== !1 && (t[a] = o || n);
  }), Object.defineProperties(e, t);
}, pt = (e) => {
  ur(e, (r, s) => {
    if (X(e) && ["arguments", "caller", "callee"].indexOf(s) !== -1)
      return !1;
    const t = e[s];
    if (X(t)) {
      if (r.enumerable = !1, "writable" in r) {
        r.writable = !1;
        return;
      }
      r.set || (r.set = () => {
        throw Error("Can not rewrite read-only method '" + s + "'");
      });
    }
  });
}, ht = (e, r) => {
  const s = {}, t = (n) => {
    n.forEach((a) => {
      s[a] = !0;
    });
  };
  return Se(e) ? t(e) : t(String(e).split(r)), s;
}, ut = () => {
}, mt = (e, r) => e != null && Number.isFinite(e = +e) ? e : r;
function Rt(e) {
  return !!(e && X(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const St = (e) => {
  const r = new Array(10), s = (t, n) => {
    if (Ae(t)) {
      if (r.indexOf(t) >= 0)
        return;
      if (!("toJSON" in t)) {
        r[n] = t;
        const a = Se(t) ? [] : {};
        return Te(t, (o, l) => {
          const d = s(o, n + 1);
          !Oe(d) && (a[l] = d);
        }), r[n] = void 0, a;
      }
    }
    return t;
  };
  return s(e, 0);
}, yt = re("AsyncFunction"), Et = (e) => e && (Ae(e) || X(e)) && X(e.then) && X(e.catch), mr = ((e, r) => e ? setImmediate : r ? ((s, t) => (pe.addEventListener("message", ({ source: n, data: a }) => {
  n === pe && a === s && t.length && t.shift()();
}, !1), (n) => {
  t.push(n), pe.postMessage(s, "*");
}))(`axios@${Math.random()}`, []) : (s) => setTimeout(s))(
  typeof setImmediate == "function",
  X(pe.postMessage)
), Ot = typeof queueMicrotask < "u" ? queueMicrotask.bind(pe) : typeof process < "u" && process.nextTick || mr, m = {
  isArray: Se,
  isArrayBuffer: cr,
  isBuffer: fr,
  isFormData: Kr,
  isArrayBufferView: Br,
  isString: Fr,
  isNumber: ir,
  isBoolean: kr,
  isObject: Ae,
  isPlainObject: ve,
  isReadableStream: zr,
  isRequest: Jr,
  isResponse: Wr,
  isHeaders: Zr,
  isUndefined: Oe,
  isDate: Mr,
  isFile: jr,
  isBlob: Gr,
  isRegExp: it,
  isFunction: X,
  isStream: qr,
  isURLSearchParams: Qr,
  isTypedArray: nt,
  isFileList: $r,
  forEach: Te,
  merge: fe,
  extend: Yr,
  trim: Xr,
  stripBOM: et,
  inherits: rt,
  toFlatObject: tt,
  kindOf: Ie,
  kindOfTest: re,
  endsWith: at,
  toArray: st,
  forEachEntry: ot,
  matchAll: lt,
  isHTMLForm: dt,
  hasOwnProperty: ze,
  hasOwnProp: ze,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ur,
  freezeMethods: pt,
  toObjectSet: ht,
  toCamelCase: ct,
  noop: ut,
  toFiniteNumber: mt,
  findKey: pr,
  global: pe,
  isContextDefined: hr,
  isSpecCompliantForm: Rt,
  toJSONObject: St,
  isAsyncFn: yt,
  isThenable: Et,
  setImmediate: mr,
  asap: Ot
};
function L(e, r, s, t, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", r && (this.code = r), s && (this.config = s), t && (this.request = t), n && (this.response = n, this.status = n.status ? n.status : null);
}
m.inherits(L, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: m.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Rr = L.prototype, Sr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Sr[e] = { value: e };
});
Object.defineProperties(L, Sr);
Object.defineProperty(Rr, "isAxiosError", { value: !0 });
L.from = (e, r, s, t, n, a) => {
  const o = Object.create(Rr);
  return m.toFlatObject(e, o, function(d) {
    return d !== Error.prototype;
  }, (l) => l !== "isAxiosError"), L.call(o, e.message, r, s, t, n), o.cause = e, o.name = e.name, a && Object.assign(o, a), o;
};
const Tt = null;
function Be(e) {
  return m.isPlainObject(e) || m.isArray(e);
}
function yr(e) {
  return m.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Je(e, r, s) {
  return e ? e.concat(r).map(function(n, a) {
    return n = yr(n), !s && a ? "[" + n + "]" : n;
  }).join(s ? "." : "") : r;
}
function _t(e) {
  return m.isArray(e) && !e.some(Be);
}
const vt = m.toFlatObject(m, {}, null, function(r) {
  return /^is[A-Z]/.test(r);
});
function Ce(e, r, s) {
  if (!m.isObject(e))
    throw new TypeError("target must be an object");
  r = r || new FormData(), s = m.toFlatObject(s, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(I, V) {
    return !m.isUndefined(V[I]);
  });
  const t = s.metaTokens, n = s.visitor || i, a = s.dots, o = s.indexes, d = (s.Blob || typeof Blob < "u" && Blob) && m.isSpecCompliantForm(r);
  if (!m.isFunction(n))
    throw new TypeError("visitor must be a function");
  function c(H) {
    if (H === null) return "";
    if (m.isDate(H))
      return H.toISOString();
    if (!d && m.isBlob(H))
      throw new L("Blob is not supported. Use a Buffer instead.");
    return m.isArrayBuffer(H) || m.isTypedArray(H) ? d && typeof Blob == "function" ? new Blob([H]) : Buffer.from(H) : H;
  }
  function i(H, I, V) {
    let w = H;
    if (H && !V && typeof H == "object") {
      if (m.endsWith(I, "{}"))
        I = t ? I : I.slice(0, -2), H = JSON.stringify(H);
      else if (m.isArray(H) && _t(H) || (m.isFileList(H) || m.endsWith(I, "[]")) && (w = m.toArray(H)))
        return I = yr(I), w.forEach(function(k, z) {
          !(m.isUndefined(k) || k === null) && r.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Je([I], z, a) : o === null ? I : I + "[]",
            c(k)
          );
        }), !1;
    }
    return Be(H) ? !0 : (r.append(Je(V, I, a), c(H)), !1);
  }
  const p = [], u = Object.assign(vt, {
    defaultVisitor: i,
    convertValue: c,
    isVisitable: Be
  });
  function b(H, I) {
    if (!m.isUndefined(H)) {
      if (p.indexOf(H) !== -1)
        throw Error("Circular reference detected in " + I.join("."));
      p.push(H), m.forEach(H, function(w, A) {
        (!(m.isUndefined(w) || w === null) && n.call(
          r,
          w,
          m.isString(A) ? A.trim() : A,
          I,
          u
        )) === !0 && b(w, I ? I.concat(A) : [A]);
      }), p.pop();
    }
  }
  if (!m.isObject(e))
    throw new TypeError("data must be an object");
  return b(e), r;
}
function We(e) {
  const r = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(t) {
    return r[t];
  });
}
function Ke(e, r) {
  this._pairs = [], e && Ce(e, this, r);
}
const Er = Ke.prototype;
Er.append = function(r, s) {
  this._pairs.push([r, s]);
};
Er.toString = function(r) {
  const s = r ? function(t) {
    return r.call(this, t, We);
  } : We;
  return this._pairs.map(function(n) {
    return s(n[0]) + "=" + s(n[1]);
  }, "").join("&");
};
function Vt(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Or(e, r, s) {
  if (!r)
    return e;
  const t = s && s.encode || Vt;
  m.isFunction(s) && (s = {
    serialize: s
  });
  const n = s && s.serialize;
  let a;
  if (n ? a = n(r, s) : a = m.isURLSearchParams(r) ? r.toString() : new Ke(r, s).toString(t), a) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class Ze {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(r, s, t) {
    return this.handlers.push({
      fulfilled: r,
      rejected: s,
      synchronous: t ? t.synchronous : !1,
      runWhen: t ? t.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(r) {
    this.handlers[r] && (this.handlers[r] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(r) {
    m.forEach(this.handlers, function(t) {
      t !== null && r(t);
    });
  }
}
const Tr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Ht = typeof URLSearchParams < "u" ? URLSearchParams : Ke, gt = typeof FormData < "u" ? FormData : null, wt = typeof Blob < "u" ? Blob : null, bt = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ht,
    FormData: gt,
    Blob: wt
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Qe = typeof window < "u" && typeof document < "u", Fe = typeof navigator == "object" && navigator || void 0, It = Qe && (!Fe || ["ReactNative", "NativeScript", "NS"].indexOf(Fe.product) < 0), Pt = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", At = Qe && window.location.href || "http://localhost", Ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Qe,
  hasStandardBrowserEnv: It,
  hasStandardBrowserWebWorkerEnv: Pt,
  navigator: Fe,
  origin: At
}, Symbol.toStringTag, { value: "Module" })), J = {
  ...Ct,
  ...bt
};
function Ut(e, r) {
  return Ce(e, new J.classes.URLSearchParams(), Object.assign({
    visitor: function(s, t, n, a) {
      return J.isNode && m.isBuffer(s) ? (this.append(t, s.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, r));
}
function Dt(e) {
  return m.matchAll(/\w+|\[(\w*)]/g, e).map((r) => r[0] === "[]" ? "" : r[1] || r[0]);
}
function xt(e) {
  const r = {}, s = Object.keys(e);
  let t;
  const n = s.length;
  let a;
  for (t = 0; t < n; t++)
    a = s[t], r[a] = e[a];
  return r;
}
function _r(e) {
  function r(s, t, n, a) {
    let o = s[a++];
    if (o === "__proto__") return !0;
    const l = Number.isFinite(+o), d = a >= s.length;
    return o = !o && m.isArray(n) ? n.length : o, d ? (m.hasOwnProp(n, o) ? n[o] = [n[o], t] : n[o] = t, !l) : ((!n[o] || !m.isObject(n[o])) && (n[o] = []), r(s, t, n[o], a) && m.isArray(n[o]) && (n[o] = xt(n[o])), !l);
  }
  if (m.isFormData(e) && m.isFunction(e.entries)) {
    const s = {};
    return m.forEachEntry(e, (t, n) => {
      r(Dt(t), n, s, 0);
    }), s;
  }
  return null;
}
function Lt(e, r, s) {
  if (m.isString(e))
    try {
      return (r || JSON.parse)(e), m.trim(e);
    } catch (t) {
      if (t.name !== "SyntaxError")
        throw t;
    }
  return (s || JSON.stringify)(e);
}
const _e = {
  transitional: Tr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(r, s) {
    const t = s.getContentType() || "", n = t.indexOf("application/json") > -1, a = m.isObject(r);
    if (a && m.isHTMLForm(r) && (r = new FormData(r)), m.isFormData(r))
      return n ? JSON.stringify(_r(r)) : r;
    if (m.isArrayBuffer(r) || m.isBuffer(r) || m.isStream(r) || m.isFile(r) || m.isBlob(r) || m.isReadableStream(r))
      return r;
    if (m.isArrayBufferView(r))
      return r.buffer;
    if (m.isURLSearchParams(r))
      return s.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), r.toString();
    let l;
    if (a) {
      if (t.indexOf("application/x-www-form-urlencoded") > -1)
        return Ut(r, this.formSerializer).toString();
      if ((l = m.isFileList(r)) || t.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return Ce(
          l ? { "files[]": r } : r,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return a || n ? (s.setContentType("application/json", !1), Lt(r)) : r;
  }],
  transformResponse: [function(r) {
    const s = this.transitional || _e.transitional, t = s && s.forcedJSONParsing, n = this.responseType === "json";
    if (m.isResponse(r) || m.isReadableStream(r))
      return r;
    if (r && m.isString(r) && (t && !this.responseType || n)) {
      const o = !(s && s.silentJSONParsing) && n;
      try {
        return JSON.parse(r);
      } catch (l) {
        if (o)
          throw l.name === "SyntaxError" ? L.from(l, L.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return r;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: J.classes.FormData,
    Blob: J.classes.Blob
  },
  validateStatus: function(r) {
    return r >= 200 && r < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
m.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  _e.headers[e] = {};
});
const Nt = m.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ft = (e) => {
  const r = {};
  let s, t, n;
  return e && e.split(`
`).forEach(function(o) {
    n = o.indexOf(":"), s = o.substring(0, n).trim().toLowerCase(), t = o.substring(n + 1).trim(), !(!s || r[s] && Nt[s]) && (s === "set-cookie" ? r[s] ? r[s].push(t) : r[s] = [t] : r[s] = r[s] ? r[s] + ", " + t : t);
  }), r;
}, Xe = Symbol("internals");
function Ee(e) {
  return e && String(e).trim().toLowerCase();
}
function Ve(e) {
  return e === !1 || e == null ? e : m.isArray(e) ? e.map(Ve) : String(e);
}
function Bt(e) {
  const r = /* @__PURE__ */ Object.create(null), s = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let t;
  for (; t = s.exec(e); )
    r[t[1]] = t[2];
  return r;
}
const Ft = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function xe(e, r, s, t, n) {
  if (m.isFunction(t))
    return t.call(this, r, s);
  if (n && (r = s), !!m.isString(r)) {
    if (m.isString(t))
      return r.indexOf(t) !== -1;
    if (m.isRegExp(t))
      return t.test(r);
  }
}
function kt(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (r, s, t) => s.toUpperCase() + t);
}
function Mt(e, r) {
  const s = m.toCamelCase(" " + r);
  ["get", "set", "has"].forEach((t) => {
    Object.defineProperty(e, t + s, {
      value: function(n, a, o) {
        return this[t].call(this, r, n, a, o);
      },
      configurable: !0
    });
  });
}
let Z = class {
  constructor(r) {
    r && this.set(r);
  }
  set(r, s, t) {
    const n = this;
    function a(l, d, c) {
      const i = Ee(d);
      if (!i)
        throw new Error("header name must be a non-empty string");
      const p = m.findKey(n, i);
      (!p || n[p] === void 0 || c === !0 || c === void 0 && n[p] !== !1) && (n[p || d] = Ve(l));
    }
    const o = (l, d) => m.forEach(l, (c, i) => a(c, i, d));
    if (m.isPlainObject(r) || r instanceof this.constructor)
      o(r, s);
    else if (m.isString(r) && (r = r.trim()) && !Ft(r))
      o(ft(r), s);
    else if (m.isHeaders(r))
      for (const [l, d] of r.entries())
        a(d, l, t);
    else
      r != null && a(s, r, t);
    return this;
  }
  get(r, s) {
    if (r = Ee(r), r) {
      const t = m.findKey(this, r);
      if (t) {
        const n = this[t];
        if (!s)
          return n;
        if (s === !0)
          return Bt(n);
        if (m.isFunction(s))
          return s.call(this, n, t);
        if (m.isRegExp(s))
          return s.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(r, s) {
    if (r = Ee(r), r) {
      const t = m.findKey(this, r);
      return !!(t && this[t] !== void 0 && (!s || xe(this, this[t], t, s)));
    }
    return !1;
  }
  delete(r, s) {
    const t = this;
    let n = !1;
    function a(o) {
      if (o = Ee(o), o) {
        const l = m.findKey(t, o);
        l && (!s || xe(t, t[l], l, s)) && (delete t[l], n = !0);
      }
    }
    return m.isArray(r) ? r.forEach(a) : a(r), n;
  }
  clear(r) {
    const s = Object.keys(this);
    let t = s.length, n = !1;
    for (; t--; ) {
      const a = s[t];
      (!r || xe(this, this[a], a, r, !0)) && (delete this[a], n = !0);
    }
    return n;
  }
  normalize(r) {
    const s = this, t = {};
    return m.forEach(this, (n, a) => {
      const o = m.findKey(t, a);
      if (o) {
        s[o] = Ve(n), delete s[a];
        return;
      }
      const l = r ? kt(a) : String(a).trim();
      l !== a && delete s[a], s[l] = Ve(n), t[l] = !0;
    }), this;
  }
  concat(...r) {
    return this.constructor.concat(this, ...r);
  }
  toJSON(r) {
    const s = /* @__PURE__ */ Object.create(null);
    return m.forEach(this, (t, n) => {
      t != null && t !== !1 && (s[n] = r && m.isArray(t) ? t.join(", ") : t);
    }), s;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([r, s]) => r + ": " + s).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(r) {
    return r instanceof this ? r : new this(r);
  }
  static concat(r, ...s) {
    const t = new this(r);
    return s.forEach((n) => t.set(n)), t;
  }
  static accessor(r) {
    const t = (this[Xe] = this[Xe] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function a(o) {
      const l = Ee(o);
      t[l] || (Mt(n, o), t[l] = !0);
    }
    return m.isArray(r) ? r.forEach(a) : a(r), this;
  }
};
Z.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
m.reduceDescriptors(Z.prototype, ({ value: e }, r) => {
  let s = r[0].toUpperCase() + r.slice(1);
  return {
    get: () => e,
    set(t) {
      this[s] = t;
    }
  };
});
m.freezeMethods(Z);
function Le(e, r) {
  const s = this || _e, t = r || s, n = Z.from(t.headers);
  let a = t.data;
  return m.forEach(e, function(l) {
    a = l.call(s, a, n.normalize(), r ? r.status : void 0);
  }), n.normalize(), a;
}
function vr(e) {
  return !!(e && e.__CANCEL__);
}
function ye(e, r, s) {
  L.call(this, e ?? "canceled", L.ERR_CANCELED, r, s), this.name = "CanceledError";
}
m.inherits(ye, L, {
  __CANCEL__: !0
});
function Vr(e, r, s) {
  const t = s.config.validateStatus;
  !s.status || !t || t(s.status) ? e(s) : r(new L(
    "Request failed with status code " + s.status,
    [L.ERR_BAD_REQUEST, L.ERR_BAD_RESPONSE][Math.floor(s.status / 100) - 4],
    s.config,
    s.request,
    s
  ));
}
function jt(e) {
  const r = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return r && r[1] || "";
}
function Gt(e, r) {
  e = e || 10;
  const s = new Array(e), t = new Array(e);
  let n = 0, a = 0, o;
  return r = r !== void 0 ? r : 1e3, function(d) {
    const c = Date.now(), i = t[a];
    o || (o = c), s[n] = d, t[n] = c;
    let p = a, u = 0;
    for (; p !== n; )
      u += s[p++], p = p % e;
    if (n = (n + 1) % e, n === a && (a = (a + 1) % e), c - o < r)
      return;
    const b = i && c - i;
    return b ? Math.round(u * 1e3 / b) : void 0;
  };
}
function $t(e, r) {
  let s = 0, t = 1e3 / r, n, a;
  const o = (c, i = Date.now()) => {
    s = i, n = null, a && (clearTimeout(a), a = null), e.apply(null, c);
  };
  return [(...c) => {
    const i = Date.now(), p = i - s;
    p >= t ? o(c, i) : (n = c, a || (a = setTimeout(() => {
      a = null, o(n);
    }, t - p)));
  }, () => n && o(n)];
}
const we = (e, r, s = 3) => {
  let t = 0;
  const n = Gt(50, 250);
  return $t((a) => {
    const o = a.loaded, l = a.lengthComputable ? a.total : void 0, d = o - t, c = n(d), i = o <= l;
    t = o;
    const p = {
      loaded: o,
      total: l,
      progress: l ? o / l : void 0,
      bytes: d,
      rate: c || void 0,
      estimated: c && l && i ? (l - o) / c : void 0,
      event: a,
      lengthComputable: l != null,
      [r ? "download" : "upload"]: !0
    };
    e(p);
  }, s);
}, Ye = (e, r) => {
  const s = e != null;
  return [(t) => r[0]({
    lengthComputable: s,
    total: e,
    loaded: t
  }), r[1]];
}, er = (e) => (...r) => m.asap(() => e(...r)), qt = J.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, r) => (s) => (s = new URL(s, J.origin), e.protocol === s.protocol && e.host === s.host && (r || e.port === s.port)))(
  new URL(J.origin),
  J.navigator && /(msie|trident)/i.test(J.navigator.userAgent)
) : () => !0, Kt = J.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, r, s, t, n, a) {
      const o = [e + "=" + encodeURIComponent(r)];
      m.isNumber(s) && o.push("expires=" + new Date(s).toGMTString()), m.isString(t) && o.push("path=" + t), m.isString(n) && o.push("domain=" + n), a === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const r = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return r ? decodeURIComponent(r[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Qt(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function zt(e, r) {
  return r ? e.replace(/\/?\/$/, "") + "/" + r.replace(/^\/+/, "") : e;
}
function Hr(e, r, s) {
  let t = !Qt(r);
  return e && t || s == !1 ? zt(e, r) : r;
}
const rr = (e) => e instanceof Z ? { ...e } : e;
function ue(e, r) {
  r = r || {};
  const s = {};
  function t(c, i, p, u) {
    return m.isPlainObject(c) && m.isPlainObject(i) ? m.merge.call({ caseless: u }, c, i) : m.isPlainObject(i) ? m.merge({}, i) : m.isArray(i) ? i.slice() : i;
  }
  function n(c, i, p, u) {
    if (m.isUndefined(i)) {
      if (!m.isUndefined(c))
        return t(void 0, c, p, u);
    } else return t(c, i, p, u);
  }
  function a(c, i) {
    if (!m.isUndefined(i))
      return t(void 0, i);
  }
  function o(c, i) {
    if (m.isUndefined(i)) {
      if (!m.isUndefined(c))
        return t(void 0, c);
    } else return t(void 0, i);
  }
  function l(c, i, p) {
    if (p in r)
      return t(c, i);
    if (p in e)
      return t(void 0, c);
  }
  const d = {
    url: a,
    method: a,
    data: a,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: l,
    headers: (c, i, p) => n(rr(c), rr(i), p, !0)
  };
  return m.forEach(Object.keys(Object.assign({}, e, r)), function(i) {
    const p = d[i] || n, u = p(e[i], r[i], i);
    m.isUndefined(u) && p !== l || (s[i] = u);
  }), s;
}
const gr = (e) => {
  const r = ue({}, e);
  let { data: s, withXSRFToken: t, xsrfHeaderName: n, xsrfCookieName: a, headers: o, auth: l } = r;
  r.headers = o = Z.from(o), r.url = Or(Hr(r.baseURL, r.url, r.allowAbsoluteUrls), e.params, e.paramsSerializer), l && o.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  );
  let d;
  if (m.isFormData(s)) {
    if (J.hasStandardBrowserEnv || J.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((d = o.getContentType()) !== !1) {
      const [c, ...i] = d ? d.split(";").map((p) => p.trim()).filter(Boolean) : [];
      o.setContentType([c || "multipart/form-data", ...i].join("; "));
    }
  }
  if (J.hasStandardBrowserEnv && (t && m.isFunction(t) && (t = t(r)), t || t !== !1 && qt(r.url))) {
    const c = n && a && Kt.read(a);
    c && o.set(n, c);
  }
  return r;
}, Jt = typeof XMLHttpRequest < "u", Wt = Jt && function(e) {
  return new Promise(function(s, t) {
    const n = gr(e);
    let a = n.data;
    const o = Z.from(n.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: c } = n, i, p, u, b, H;
    function I() {
      b && b(), H && H(), n.cancelToken && n.cancelToken.unsubscribe(i), n.signal && n.signal.removeEventListener("abort", i);
    }
    let V = new XMLHttpRequest();
    V.open(n.method.toUpperCase(), n.url, !0), V.timeout = n.timeout;
    function w() {
      if (!V)
        return;
      const k = Z.from(
        "getAllResponseHeaders" in V && V.getAllResponseHeaders()
      ), v = {
        data: !l || l === "text" || l === "json" ? V.responseText : V.response,
        status: V.status,
        statusText: V.statusText,
        headers: k,
        config: e,
        request: V
      };
      Vr(function(C) {
        s(C), I();
      }, function(C) {
        t(C), I();
      }, v), V = null;
    }
    "onloadend" in V ? V.onloadend = w : V.onreadystatechange = function() {
      !V || V.readyState !== 4 || V.status === 0 && !(V.responseURL && V.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, V.onabort = function() {
      V && (t(new L("Request aborted", L.ECONNABORTED, e, V)), V = null);
    }, V.onerror = function() {
      t(new L("Network Error", L.ERR_NETWORK, e, V)), V = null;
    }, V.ontimeout = function() {
      let z = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const v = n.transitional || Tr;
      n.timeoutErrorMessage && (z = n.timeoutErrorMessage), t(new L(
        z,
        v.clarifyTimeoutError ? L.ETIMEDOUT : L.ECONNABORTED,
        e,
        V
      )), V = null;
    }, a === void 0 && o.setContentType(null), "setRequestHeader" in V && m.forEach(o.toJSON(), function(z, v) {
      V.setRequestHeader(v, z);
    }), m.isUndefined(n.withCredentials) || (V.withCredentials = !!n.withCredentials), l && l !== "json" && (V.responseType = n.responseType), c && ([u, H] = we(c, !0), V.addEventListener("progress", u)), d && V.upload && ([p, b] = we(d), V.upload.addEventListener("progress", p), V.upload.addEventListener("loadend", b)), (n.cancelToken || n.signal) && (i = (k) => {
      V && (t(!k || k.type ? new ye(null, e, V) : k), V.abort(), V = null);
    }, n.cancelToken && n.cancelToken.subscribe(i), n.signal && (n.signal.aborted ? i() : n.signal.addEventListener("abort", i)));
    const A = jt(n.url);
    if (A && J.protocols.indexOf(A) === -1) {
      t(new L("Unsupported protocol " + A + ":", L.ERR_BAD_REQUEST, e));
      return;
    }
    V.send(a || null);
  });
}, Zt = (e, r) => {
  const { length: s } = e = e ? e.filter(Boolean) : [];
  if (r || s) {
    let t = new AbortController(), n;
    const a = function(c) {
      if (!n) {
        n = !0, l();
        const i = c instanceof Error ? c : this.reason;
        t.abort(i instanceof L ? i : new ye(i instanceof Error ? i.message : i));
      }
    };
    let o = r && setTimeout(() => {
      o = null, a(new L(`timeout ${r} of ms exceeded`, L.ETIMEDOUT));
    }, r);
    const l = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(a) : c.removeEventListener("abort", a);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", a));
    const { signal: d } = t;
    return d.unsubscribe = () => m.asap(l), d;
  }
}, Xt = function* (e, r) {
  let s = e.byteLength;
  if (s < r) {
    yield e;
    return;
  }
  let t = 0, n;
  for (; t < s; )
    n = t + r, yield e.slice(t, n), t = n;
}, Yt = async function* (e, r) {
  for await (const s of ea(e))
    yield* Xt(s, r);
}, ea = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const r = e.getReader();
  try {
    for (; ; ) {
      const { done: s, value: t } = await r.read();
      if (s)
        break;
      yield t;
    }
  } finally {
    await r.cancel();
  }
}, tr = (e, r, s, t) => {
  const n = Yt(e, r);
  let a = 0, o, l = (d) => {
    o || (o = !0, t && t(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: c, value: i } = await n.next();
        if (c) {
          l(), d.close();
          return;
        }
        let p = i.byteLength;
        if (s) {
          let u = a += p;
          s(u);
        }
        d.enqueue(new Uint8Array(i));
      } catch (c) {
        throw l(c), c;
      }
    },
    cancel(d) {
      return l(d), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, Ue = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", wr = Ue && typeof ReadableStream == "function", ra = Ue && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (r) => e.encode(r))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), br = (e, ...r) => {
  try {
    return !!e(...r);
  } catch {
    return !1;
  }
}, ta = wr && br(() => {
  let e = !1;
  const r = new Request(J.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !r;
}), ar = 64 * 1024, ke = wr && br(() => m.isReadableStream(new Response("").body)), be = {
  stream: ke && ((e) => e.body)
};
Ue && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((r) => {
    !be[r] && (be[r] = m.isFunction(e[r]) ? (s) => s[r]() : (s, t) => {
      throw new L(`Response type '${r}' is not supported`, L.ERR_NOT_SUPPORT, t);
    });
  });
})(new Response());
const aa = async (e) => {
  if (e == null)
    return 0;
  if (m.isBlob(e))
    return e.size;
  if (m.isSpecCompliantForm(e))
    return (await new Request(J.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (m.isArrayBufferView(e) || m.isArrayBuffer(e))
    return e.byteLength;
  if (m.isURLSearchParams(e) && (e = e + ""), m.isString(e))
    return (await ra(e)).byteLength;
}, sa = async (e, r) => {
  const s = m.toFiniteNumber(e.getContentLength());
  return s ?? aa(r);
}, na = Ue && (async (e) => {
  let {
    url: r,
    method: s,
    data: t,
    signal: n,
    cancelToken: a,
    timeout: o,
    onDownloadProgress: l,
    onUploadProgress: d,
    responseType: c,
    headers: i,
    withCredentials: p = "same-origin",
    fetchOptions: u
  } = gr(e);
  c = c ? (c + "").toLowerCase() : "text";
  let b = Zt([n, a && a.toAbortSignal()], o), H;
  const I = b && b.unsubscribe && (() => {
    b.unsubscribe();
  });
  let V;
  try {
    if (d && ta && s !== "get" && s !== "head" && (V = await sa(i, t)) !== 0) {
      let v = new Request(r, {
        method: "POST",
        body: t,
        duplex: "half"
      }), D;
      if (m.isFormData(t) && (D = v.headers.get("content-type")) && i.setContentType(D), v.body) {
        const [C, M] = Ye(
          V,
          we(er(d))
        );
        t = tr(v.body, ar, C, M);
      }
    }
    m.isString(p) || (p = p ? "include" : "omit");
    const w = "credentials" in Request.prototype;
    H = new Request(r, {
      ...u,
      signal: b,
      method: s.toUpperCase(),
      headers: i.normalize().toJSON(),
      body: t,
      duplex: "half",
      credentials: w ? p : void 0
    });
    let A = await fetch(H);
    const k = ke && (c === "stream" || c === "response");
    if (ke && (l || k && I)) {
      const v = {};
      ["status", "statusText", "headers"].forEach((Re) => {
        v[Re] = A[Re];
      });
      const D = m.toFiniteNumber(A.headers.get("content-length")), [C, M] = l && Ye(
        D,
        we(er(l), !0)
      ) || [];
      A = new Response(
        tr(A.body, ar, C, () => {
          M && M(), I && I();
        }),
        v
      );
    }
    c = c || "text";
    let z = await be[m.findKey(be, c) || "text"](A, e);
    return !k && I && I(), await new Promise((v, D) => {
      Vr(v, D, {
        data: z,
        headers: Z.from(A.headers),
        status: A.status,
        statusText: A.statusText,
        config: e,
        request: H
      });
    });
  } catch (w) {
    throw I && I(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new L("Network Error", L.ERR_NETWORK, e, H),
      {
        cause: w.cause || w
      }
    ) : L.from(w, w && w.code, e, H);
  }
}), Me = {
  http: Tt,
  xhr: Wt,
  fetch: na
};
m.forEach(Me, (e, r) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: r });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: r });
  }
});
const sr = (e) => `- ${e}`, oa = (e) => m.isFunction(e) || e === null || e === !1, Ir = {
  getAdapter: (e) => {
    e = m.isArray(e) ? e : [e];
    const { length: r } = e;
    let s, t;
    const n = {};
    for (let a = 0; a < r; a++) {
      s = e[a];
      let o;
      if (t = s, !oa(s) && (t = Me[(o = String(s)).toLowerCase()], t === void 0))
        throw new L(`Unknown adapter '${o}'`);
      if (t)
        break;
      n[o || "#" + a] = t;
    }
    if (!t) {
      const a = Object.entries(n).map(
        ([l, d]) => `adapter ${l} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = r ? a.length > 1 ? `since :
` + a.map(sr).join(`
`) : " " + sr(a[0]) : "as no adapter specified";
      throw new L(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return t;
  },
  adapters: Me
};
function Ne(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ye(null, e);
}
function nr(e) {
  return Ne(e), e.headers = Z.from(e.headers), e.data = Le.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ir.getAdapter(e.adapter || _e.adapter)(e).then(function(t) {
    return Ne(e), t.data = Le.call(
      e,
      e.transformResponse,
      t
    ), t.headers = Z.from(t.headers), t;
  }, function(t) {
    return vr(t) || (Ne(e), t && t.response && (t.response.data = Le.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = Z.from(t.response.headers))), Promise.reject(t);
  });
}
const Pr = "1.8.3", De = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, r) => {
  De[e] = function(t) {
    return typeof t === e || "a" + (r < 1 ? "n " : " ") + e;
  };
});
const or = {};
De.transitional = function(r, s, t) {
  function n(a, o) {
    return "[Axios v" + Pr + "] Transitional option '" + a + "'" + o + (t ? ". " + t : "");
  }
  return (a, o, l) => {
    if (r === !1)
      throw new L(
        n(o, " has been removed" + (s ? " in " + s : "")),
        L.ERR_DEPRECATED
      );
    return s && !or[o] && (or[o] = !0, console.warn(
      n(
        o,
        " has been deprecated since v" + s + " and will be removed in the near future"
      )
    )), r ? r(a, o, l) : !0;
  };
};
De.spelling = function(r) {
  return (s, t) => (console.warn(`${t} is likely a misspelling of ${r}`), !0);
};
function la(e, r, s) {
  if (typeof e != "object")
    throw new L("options must be an object", L.ERR_BAD_OPTION_VALUE);
  const t = Object.keys(e);
  let n = t.length;
  for (; n-- > 0; ) {
    const a = t[n], o = r[a];
    if (o) {
      const l = e[a], d = l === void 0 || o(l, a, e);
      if (d !== !0)
        throw new L("option " + a + " must be " + d, L.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (s !== !0)
      throw new L("Unknown option " + a, L.ERR_BAD_OPTION);
  }
}
const He = {
  assertOptions: la,
  validators: De
}, ae = He.validators;
let he = class {
  constructor(r) {
    this.defaults = r, this.interceptors = {
      request: new Ze(),
      response: new Ze()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(r, s) {
    try {
      return await this._request(r, s);
    } catch (t) {
      if (t instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const a = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          t.stack ? a && !String(t.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (t.stack += `
` + a) : t.stack = a;
        } catch {
        }
      }
      throw t;
    }
  }
  _request(r, s) {
    typeof r == "string" ? (s = s || {}, s.url = r) : s = r || {}, s = ue(this.defaults, s);
    const { transitional: t, paramsSerializer: n, headers: a } = s;
    t !== void 0 && He.assertOptions(t, {
      silentJSONParsing: ae.transitional(ae.boolean),
      forcedJSONParsing: ae.transitional(ae.boolean),
      clarifyTimeoutError: ae.transitional(ae.boolean)
    }, !1), n != null && (m.isFunction(n) ? s.paramsSerializer = {
      serialize: n
    } : He.assertOptions(n, {
      encode: ae.function,
      serialize: ae.function
    }, !0)), s.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? s.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : s.allowAbsoluteUrls = !0), He.assertOptions(s, {
      baseUrl: ae.spelling("baseURL"),
      withXsrfToken: ae.spelling("withXSRFToken")
    }, !0), s.method = (s.method || this.defaults.method || "get").toLowerCase();
    let o = a && m.merge(
      a.common,
      a[s.method]
    );
    a && m.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (H) => {
        delete a[H];
      }
    ), s.headers = Z.concat(o, a);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(I) {
      typeof I.runWhen == "function" && I.runWhen(s) === !1 || (d = d && I.synchronous, l.unshift(I.fulfilled, I.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(I) {
      c.push(I.fulfilled, I.rejected);
    });
    let i, p = 0, u;
    if (!d) {
      const H = [nr.bind(this), void 0];
      for (H.unshift.apply(H, l), H.push.apply(H, c), u = H.length, i = Promise.resolve(s); p < u; )
        i = i.then(H[p++], H[p++]);
      return i;
    }
    u = l.length;
    let b = s;
    for (p = 0; p < u; ) {
      const H = l[p++], I = l[p++];
      try {
        b = H(b);
      } catch (V) {
        I.call(this, V);
        break;
      }
    }
    try {
      i = nr.call(this, b);
    } catch (H) {
      return Promise.reject(H);
    }
    for (p = 0, u = c.length; p < u; )
      i = i.then(c[p++], c[p++]);
    return i;
  }
  getUri(r) {
    r = ue(this.defaults, r);
    const s = Hr(r.baseURL, r.url, r.allowAbsoluteUrls);
    return Or(s, r.params, r.paramsSerializer);
  }
};
m.forEach(["delete", "get", "head", "options"], function(r) {
  he.prototype[r] = function(s, t) {
    return this.request(ue(t || {}, {
      method: r,
      url: s,
      data: (t || {}).data
    }));
  };
});
m.forEach(["post", "put", "patch"], function(r) {
  function s(t) {
    return function(a, o, l) {
      return this.request(ue(l || {}, {
        method: r,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: o
      }));
    };
  }
  he.prototype[r] = s(), he.prototype[r + "Form"] = s(!0);
});
let da = class Ar {
  constructor(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    let s;
    this.promise = new Promise(function(a) {
      s = a;
    });
    const t = this;
    this.promise.then((n) => {
      if (!t._listeners) return;
      let a = t._listeners.length;
      for (; a-- > 0; )
        t._listeners[a](n);
      t._listeners = null;
    }), this.promise.then = (n) => {
      let a;
      const o = new Promise((l) => {
        t.subscribe(l), a = l;
      }).then(n);
      return o.cancel = function() {
        t.unsubscribe(a);
      }, o;
    }, r(function(a, o, l) {
      t.reason || (t.reason = new ye(a, o, l), s(t.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(r) {
    if (this.reason) {
      r(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(r) : this._listeners = [r];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(r) {
    if (!this._listeners)
      return;
    const s = this._listeners.indexOf(r);
    s !== -1 && this._listeners.splice(s, 1);
  }
  toAbortSignal() {
    const r = new AbortController(), s = (t) => {
      r.abort(t);
    };
    return this.subscribe(s), r.signal.unsubscribe = () => this.unsubscribe(s), r.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let r;
    return {
      token: new Ar(function(n) {
        r = n;
      }),
      cancel: r
    };
  }
};
function ca(e) {
  return function(s) {
    return e.apply(null, s);
  };
}
function ia(e) {
  return m.isObject(e) && e.isAxiosError === !0;
}
const je = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(je).forEach(([e, r]) => {
  je[r] = e;
});
function Cr(e) {
  const r = new he(e), s = dr(he.prototype.request, r);
  return m.extend(s, he.prototype, r, { allOwnKeys: !0 }), m.extend(s, r, null, { allOwnKeys: !0 }), s.create = function(n) {
    return Cr(ue(e, n));
  }, s;
}
const R = Cr(_e);
R.Axios = he;
R.CanceledError = ye;
R.CancelToken = da;
R.isCancel = vr;
R.VERSION = Pr;
R.toFormData = Ce;
R.AxiosError = L;
R.Cancel = R.CanceledError;
R.all = function(r) {
  return Promise.all(r);
};
R.spread = ca;
R.isAxiosError = ia;
R.mergeConfig = ue;
R.AxiosHeaders = Z;
R.formToJSON = (e) => _r(m.isHTMLForm(e) ? new FormData(e) : e);
R.getAdapter = Ir.getAdapter;
R.HttpStatusCode = je;
R.default = R;
const {
  Axios: Za,
  AxiosError: pa,
  CanceledError: Xa,
  isCancel: Ya,
  CancelToken: es,
  VERSION: rs,
  all: ts,
  Cancel: as,
  isAxiosError: ss,
  spread: ns,
  toFormData: os,
  AxiosHeaders: ls,
  HttpStatusCode: ds,
  formToJSON: cs,
  getAdapter: is,
  mergeConfig: ps
} = R, S = "http://localhost".replace(/\/+$/, "");
class ie {
  constructor(r, s = S, t = R) {
    te(this, "configuration");
    this.basePath = s, this.axios = t, r && (this.configuration = r, this.basePath = r.basePath ?? s);
  }
}
class ha extends Error {
  constructor(r, s) {
    super(s), this.field = r, this.name = "RequiredError";
  }
}
const y = {}, E = "https://example.com", h = function(e, r, s) {
  if (s == null)
    throw new ha(r, `Required parameter ${r} was null or undefined when calling ${e}.`);
};
function Ge(e, r, s = "") {
  r != null && (typeof r == "object" ? Array.isArray(r) ? r.forEach((t) => Ge(e, t, s)) : Object.keys(r).forEach(
    (t) => Ge(e, r[t], `${s}${s !== "" ? "." : ""}${t}`)
  ) : e.has(s) ? e.append(s, r) : e.set(s, r));
}
const O = function(e, ...r) {
  const s = new URLSearchParams(e.search);
  Ge(s, r), e.search = s.toString();
}, N = function(e, r, s) {
  const t = typeof e != "string";
  return (t && s && s.isJsonMime ? s.isJsonMime(r.headers["Content-Type"]) : t) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, T = function(e) {
  return e.pathname + e.search + e.hash;
}, _ = function(e, r, s, t) {
  return (n = r, a = s) => {
    const o = { ...e.options, url: (n.defaults.baseURL ? "" : (t == null ? void 0 : t.basePath) ?? a) + e.url };
    return n.request(o);
  };
}, hs = {
  User: "user",
  Admin: "admin"
}, us = {
  Active: "active",
  Inactive: "inactive"
}, ms = {
  MobilePhone: "MOBILE_PHONE",
  MobileTablet: "MOBILE_TABLET",
  WebBrowser: "WEB_BROWSER"
}, Rs = {
  All: "all",
  Loaded: "loaded",
  Loading: "loading",
  Available: "available",
  Removed: "removed"
}, Ss = {
  Active: "active",
  Inactive: "inactive"
}, ys = {
  All: "all",
  Some: "some",
  None: "none"
}, Es = {
  Active: "active",
  Inactive: "inactive"
}, Os = {
  Active: "active",
  Inactive: "inactive"
}, Ts = {
  User: "user",
  Helper: "helper"
}, _s = {
  Pending: "pending",
  Working: "working",
  Sent: "sent",
  Received: "received",
  Failed: "failed"
}, vs = {
  User: "user",
  Helper: "helper"
}, Vs = {
  ByFileNameAndHash: "byFileNameAndHash",
  ByContext: "byContext"
}, Hs = {
  User: "user",
  Admin: "admin"
}, gs = {
  Active: "active",
  Inactive: "inactive"
}, ws = {
  Loaded: "loaded",
  Loading: "loading",
  Removed: "removed",
  Removing: "removing"
}, bs = {
  Loaded: "loaded",
  Loading: "loading",
  Removed: "removed",
  Removing: "removing"
}, Is = {
  Loaded: "loaded",
  Loading: "loading",
  Removed: "removed",
  Removing: "removing"
}, Ps = {
  User: "user",
  Admin: "admin"
}, As = {
  Active: "active",
  Inactive: "inactive"
}, Cs = {
  User: "user",
  Admin: "admin"
}, Us = {
  Active: "active",
  Inactive: "inactive"
}, Ds = {
  User: "user",
  Admin: "admin"
}, xs = {
  Active: "active",
  Inactive: "inactive"
}, ua = function(e) {
  return {
    /**
     * Get a specific user
     * @summary Get a specific user
     * @param {string} adminId The ID of the admin
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetUser: async (r, s, t = {}) => {
      h("adminGetUser", "adminId", r), h("adminGetUser", "userId", s);
      const n = "/admin/{admin_id}/users/{user_id}".replace("{admin_id}", encodeURIComponent(String(r))).replace("{user_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Get all users
     * @summary Get all users
     * @param {string} adminId The ID of the admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetUsers: async (r, s = {}) => {
      h("adminGetUsers", "adminId", r);
      const t = "/admin/{admin_id}/users".replace("{admin_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Delete a user
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser: async (r, s = {}) => {
      h("deleteUser", "userId", r);
      const t = "/v1/users/{user_id}".replace("{user_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "DELETE", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Get AWS services status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServicesStatus: async (r = {}) => {
      const s = "/v1/services", t = new URL(s, E);
      let n;
      e && (n = e.baseOptions);
      const a = { method: "GET", ...n, ...r }, o = {};
      O(t, {});
      let d = n && n.headers ? n.headers : {};
      return a.headers = { ...o, ...d, ...r.headers }, {
        url: T(t),
        options: a
      };
    },
    /**
     * Get a specific user
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser: async (r, s = {}) => {
      h("getUser", "userId", r);
      const t = "/v1/users/{user_id}".replace("{user_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Get all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers: async (r = {}) => {
      const s = "/v1/users", t = new URL(s, E);
      let n;
      e && (n = e.baseOptions);
      const a = { method: "GET", ...n, ...r }, o = {};
      O(t, {});
      let d = n && n.headers ? n.headers : {};
      return a.headers = { ...o, ...d, ...r.headers }, {
        url: T(t),
        options: a
      };
    },
    /**
     * Update AWS services status
     * @param {UpdateServicesStatusRequest} updateServicesStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServicesStatus: async (r, s = {}) => {
      h("updateServicesStatus", "updateServicesStatusRequest", r);
      const t = "/v1/services", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "PUT", ...a, ...s }, l = {}, d = {};
      l["Content-Type"] = "application/json", O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = N(r, o, e), {
        url: T(n),
        options: o
      };
    },
    /**
     * Update a user
     * @param {string} userId The ID of the user
     * @param {User} user 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser: async (r, s, t = {}) => {
      h("updateUser", "userId", r), h("updateUser", "user", s);
      const n = "/v1/users/{user_id}".replace("{user_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PUT", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    }
  };
}, se = function(e) {
  const r = ua(e);
  return {
    /**
     * Get a specific user
     * @summary Get a specific user
     * @param {string} adminId The ID of the admin
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminGetUser(s, t, n) {
      var d, c;
      const a = await r.adminGetUser(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["AdminApi.adminGetUser"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Get all users
     * @summary Get all users
     * @param {string} adminId The ID of the admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminGetUsers(s, t) {
      var l, d;
      const n = await r.adminGetUsers(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["AdminApi.adminGetUsers"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Delete a user
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteUser(s, t) {
      var l, d;
      const n = await r.deleteUser(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["AdminApi.deleteUser"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Get AWS services status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getServicesStatus(s) {
      var o, l;
      const t = await r.getServicesStatus(s), n = (e == null ? void 0 : e.serverIndex) ?? 0, a = (l = (o = y["AdminApi.getServicesStatus"]) == null ? void 0 : o[n]) == null ? void 0 : l.url;
      return (d, c) => _(t, R, S, e)(d, a || c);
    },
    /**
     * Get a specific user
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUser(s, t) {
      var l, d;
      const n = await r.getUser(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["AdminApi.getUser"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Get all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUsers(s) {
      var o, l;
      const t = await r.getUsers(s), n = (e == null ? void 0 : e.serverIndex) ?? 0, a = (l = (o = y["AdminApi.getUsers"]) == null ? void 0 : o[n]) == null ? void 0 : l.url;
      return (d, c) => _(t, R, S, e)(d, a || c);
    },
    /**
     * Update AWS services status
     * @param {UpdateServicesStatusRequest} updateServicesStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateServicesStatus(s, t) {
      var l, d;
      const n = await r.updateServicesStatus(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["AdminApi.updateServicesStatus"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Update a user
     * @param {string} userId The ID of the user
     * @param {User} user 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUser(s, t, n) {
      var d, c;
      const a = await r.updateUser(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["AdminApi.updateUser"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    }
  };
}, Ls = function(e, r, s) {
  const t = se(e);
  return {
    /**
     * Get a specific user
     * @summary Get a specific user
     * @param {string} adminId The ID of the admin
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetUser(n, a, o) {
      return t.adminGetUser(n, a, o).then((l) => l(s, r));
    },
    /**
     * Get all users
     * @summary Get all users
     * @param {string} adminId The ID of the admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminGetUsers(n, a) {
      return t.adminGetUsers(n, a).then((o) => o(s, r));
    },
    /**
     * Delete a user
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(n, a) {
      return t.deleteUser(n, a).then((o) => o(s, r));
    },
    /**
     * Get AWS services status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServicesStatus(n) {
      return t.getServicesStatus(n).then((a) => a(s, r));
    },
    /**
     * Get a specific user
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(n, a) {
      return t.getUser(n, a).then((o) => o(s, r));
    },
    /**
     * Get all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(n) {
      return t.getUsers(n).then((a) => a(s, r));
    },
    /**
     * Update AWS services status
     * @param {UpdateServicesStatusRequest} updateServicesStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServicesStatus(n, a) {
      return t.updateServicesStatus(n, a).then((o) => o(s, r));
    },
    /**
     * Update a user
     * @param {string} userId The ID of the user
     * @param {User} user 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(n, a, o) {
      return t.updateUser(n, a, o).then((l) => l(s, r));
    }
  };
};
class ma extends ie {
  /**
   * Get a specific user
   * @summary Get a specific user
   * @param {string} adminId The ID of the admin
   * @param {string} userId The ID of the user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  adminGetUser(r, s, t) {
    return se(this.configuration).adminGetUser(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get all users
   * @summary Get all users
   * @param {string} adminId The ID of the admin
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  adminGetUsers(r, s) {
    return se(this.configuration).adminGetUsers(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Delete a user
   * @param {string} userId The ID of the user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  deleteUser(r, s) {
    return se(this.configuration).deleteUser(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Get AWS services status
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  getServicesStatus(r) {
    return se(this.configuration).getServicesStatus(r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * Get a specific user
   * @param {string} userId The ID of the user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  getUser(r, s) {
    return se(this.configuration).getUser(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Get all users
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  getUsers(r) {
    return se(this.configuration).getUsers(r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * Update AWS services status
   * @param {UpdateServicesStatusRequest} updateServicesStatusRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  updateServicesStatus(r, s) {
    return se(this.configuration).updateServicesStatus(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Update a user
   * @param {string} userId The ID of the user
   * @param {User} user 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  updateUser(r, s, t) {
    return se(this.configuration).updateUser(r, s, t).then((n) => n(this.axios, this.basePath));
  }
}
const Ra = function(e) {
  return {
    /**
     * Create a new conversation
     * @summary Create a new conversation
     * @param {Conversation} conversation Create a new conversation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConversation: async (r, s = {}) => {
      h("createConversation", "conversation", r);
      const t = "/v1/conversations", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "POST", ...a, ...s }, l = {}, d = {};
      l["Content-Type"] = "application/json", O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = N(r, o, e), {
        url: T(n),
        options: o
      };
    },
    /**
     * Create a new conversation
     * @param {string} ownerId The ID of the owner
     * @param {Conversation} [conversation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperConversation: async (r, s, t = {}) => {
      h("createHelperConversation", "ownerId", r);
      const n = "/helper/{owner_id}/conversations".replace("{owner_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Create a new message
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {Message} [message] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperMessage: async (r, s, t, n, a = {}) => {
      h("createHelperMessage", "ownerId", r), h("createHelperMessage", "conversationId", s), h("createHelperMessage", "threadId", t);
      const o = "/helper/{owner_id}/conversations/{conversation_id}/threads/{thread_id}/messages".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))).replace("{thread_id}", encodeURIComponent(String(t))), l = new URL(o, E);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "POST", ...d, ...a }, i = {}, p = {};
      i["Content-Type"] = "application/json", O(l, p);
      let u = d && d.headers ? d.headers : {};
      return c.headers = { ...i, ...u, ...a.headers }, c.data = N(n, c, e), {
        url: T(l),
        options: c
      };
    },
    /**
     * Create a new thread
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {Thread} thread Request to create a new thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperThread: async (r, s, t, n = {}) => {
      h("createHelperThread", "ownerId", r), h("createHelperThread", "conversationId", s), h("createHelperThread", "thread", t);
      const a = "/helper/{owner_id}/conversations/{conversation_id}/threads".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Create a new message for a thread
     * @summary Create a new message for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {Message} message Create a new message request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMessage: async (r, s, t, n = {}) => {
      h("createMessage", "conversationId", r), h("createMessage", "threadId", s), h("createMessage", "message", t);
      const a = "/v1/conversations/{conversation_id}/threads/{thread_id}/messages".replace("{conversation_id}", encodeURIComponent(String(r))).replace("{thread_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Create a new thread for a conversation
     * @summary Create a new thread for a conversation
     * @param {string} conversationId The ID of the conversation
     * @param {Thread} thread Create a new thread request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createThread: async (r, s, t = {}) => {
      h("createThread", "conversationId", r), h("createThread", "thread", s);
      const n = "/v1/conversations/{conversation_id}/threads".replace("{conversation_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Delete conversation by ID
     * @summary Delete conversation by ID
     * @param {string} conversationId The ID of the conversation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteConversation: async (r, s = {}) => {
      h("deleteConversation", "conversationId", r);
      const t = "/v1/conversations/{conversation_id}".replace("{conversation_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "DELETE", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Delete conversation by ID
     * @summary Delete conversation by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {GetConversationFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperConversation: async (r, s, t, n = {}) => {
      h("deleteHelperConversation", "ownerId", r), h("deleteHelperConversation", "conversationId", s);
      const a = "/helper/{owner_id}/conversations/{conversation_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...n }, c = {}, i = {};
      if (t !== void 0)
        for (const [u, b] of Object.entries(t))
          i[u] = b;
      O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * Delete message by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperMessage: async (r, s, t, n, a = {}) => {
      h("deleteHelperMessage", "ownerId", r), h("deleteHelperMessage", "conversationId", s), h("deleteHelperMessage", "threadId", t), h("deleteHelperMessage", "messageId", n);
      const o = "/helper/{owner_id}/conversations/{conversation_id}/threads/{thread_id}/messages/{message_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))).replace("{thread_id}", encodeURIComponent(String(t))).replace("{message_id}", encodeURIComponent(String(n))), l = new URL(o, E);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "DELETE", ...d, ...a }, i = {};
      O(l, {});
      let u = d && d.headers ? d.headers : {};
      return c.headers = { ...i, ...u, ...a.headers }, {
        url: T(l),
        options: c
      };
    },
    /**
     * Delete thread by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {Thread} [thread] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperThread: async (r, s, t, n, a = {}) => {
      h("deleteHelperThread", "ownerId", r), h("deleteHelperThread", "conversationId", s), h("deleteHelperThread", "threadId", t);
      const o = "/helper/{owner_id}/conversations/{conversation_id}/threads/{thread_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))).replace("{thread_id}", encodeURIComponent(String(t))), l = new URL(o, E);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "DELETE", ...d, ...a }, i = {}, p = {};
      i["Content-Type"] = "application/json", O(l, p);
      let u = d && d.headers ? d.headers : {};
      return c.headers = { ...i, ...u, ...a.headers }, c.data = N(n, c, e), {
        url: T(l),
        options: c
      };
    },
    /**
     * Delete a message for a thread
     * @summary Delete a message for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMessage: async (r, s, t, n = {}) => {
      h("deleteMessage", "conversationId", r), h("deleteMessage", "threadId", s), h("deleteMessage", "messageId", t);
      const a = "/v1/conversations/{conversation_id}/threads/{thread_id}/messages/{message_id}".replace("{conversation_id}", encodeURIComponent(String(r))).replace("{thread_id}", encodeURIComponent(String(s))).replace("{message_id}", encodeURIComponent(String(t))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...n }, c = {};
      O(o, {});
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * Delete a thread for a conversation
     * @summary Delete a thread for a conversation
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteThread: async (r, s, t = {}) => {
      h("deleteThread", "conversationId", r), h("deleteThread", "threadId", s);
      const n = "/v1/conversations/{conversation_id}/threads/{thread_id}".replace("{conversation_id}", encodeURIComponent(String(r))).replace("{thread_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Get conversation by ID
     * @summary Retrieve conversation by ID
     * @param {string} conversationId The ID of the conversation
     * @param {GetConversationFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConversation: async (r, s, t = {}) => {
      h("getConversation", "conversationId", r);
      const n = "/v1/conversations/{conversation_id}".replace("{conversation_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {}, c = {};
      if (s !== void 0)
        for (const [p, u] of Object.entries(s))
          c[p] = u;
      O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Get all conversations
     * @summary Retrieve all conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConversations: async (r = {}) => {
      const s = "/v1/conversations", t = new URL(s, E);
      let n;
      e && (n = e.baseOptions);
      const a = { method: "GET", ...n, ...r }, o = {};
      O(t, {});
      let d = n && n.headers ? n.headers : {};
      return a.headers = { ...o, ...d, ...r.headers }, {
        url: T(t),
        options: a
      };
    },
    /**
     * Conversation query endpoint
     * @summary Conversation query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {GetConversationFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperConversation: async (r, s, t, n = {}) => {
      h("getHelperConversation", "ownerId", r), h("getHelperConversation", "conversationId", s);
      const a = "/helper/{owner_id}/conversations/{conversation_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...n }, c = {}, i = {};
      if (t !== void 0)
        for (const [u, b] of Object.entries(t))
          i[u] = b;
      O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * Conversations query endpoint
     * @summary Conversations query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperConversations: async (r, s = {}) => {
      h("getHelperConversations", "ownerId", r);
      const t = "/helper/{owner_id}/conversations".replace("{owner_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Get message by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperMessage: async (r, s, t, n, a = {}) => {
      h("getHelperMessage", "ownerId", r), h("getHelperMessage", "conversationId", s), h("getHelperMessage", "threadId", t), h("getHelperMessage", "messageId", n);
      const o = "/helper/{owner_id}/conversations/{conversation_id}/threads/{thread_id}/messages/{message_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))).replace("{thread_id}", encodeURIComponent(String(t))).replace("{message_id}", encodeURIComponent(String(n))), l = new URL(o, E);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "GET", ...d, ...a }, i = {};
      O(l, {});
      let u = d && d.headers ? d.headers : {};
      return c.headers = { ...i, ...u, ...a.headers }, {
        url: T(l),
        options: c
      };
    },
    /**
     * Get message responses by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperMessageResponses: async (r, s, t, n, a = {}) => {
      h("getHelperMessageResponses", "ownerId", r), h("getHelperMessageResponses", "conversationId", s), h("getHelperMessageResponses", "threadId", t), h("getHelperMessageResponses", "messageId", n);
      const o = "/helper/{owner_id}/conversations/{conversation_id}/threads/{thread_id}/messages/{message_id}/responses".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))).replace("{thread_id}", encodeURIComponent(String(t))).replace("{message_id}", encodeURIComponent(String(n))), l = new URL(o, E);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "GET", ...d, ...a }, i = {};
      O(l, {});
      let u = d && d.headers ? d.headers : {};
      return c.headers = { ...i, ...u, ...a.headers }, {
        url: T(l),
        options: c
      };
    },
    /**
     * Get thread by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperThread: async (r, s, t, n = {}) => {
      h("getHelperThread", "ownerId", r), h("getHelperThread", "conversationId", s), h("getHelperThread", "threadId", t);
      const a = "/helper/{owner_id}/conversations/{conversation_id}/threads/{thread_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))).replace("{thread_id}", encodeURIComponent(String(t))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...n }, c = {};
      O(o, {});
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * Get messages for a thread
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperThreadMessages: async (r, s, t, n = {}) => {
      h("getHelperThreadMessages", "ownerId", r), h("getHelperThreadMessages", "conversationId", s), h("getHelperThreadMessages", "threadId", t);
      const a = "/helper/{owner_id}/conversations/{conversation_id}/threads/{thread_id}/messages".replace("{owner_id}", encodeURIComponent(String(r))).replace("{conversation_id}", encodeURIComponent(String(s))).replace("{thread_id}", encodeURIComponent(String(t))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...n }, c = {};
      O(o, {});
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * Get a message for a thread
     * @summary Get a message for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessage: async (r, s, t, n = {}) => {
      h("getMessage", "conversationId", r), h("getMessage", "threadId", s), h("getMessage", "messageId", t);
      const a = "/v1/conversations/{conversation_id}/threads/{thread_id}/messages/{message_id}".replace("{conversation_id}", encodeURIComponent(String(r))).replace("{thread_id}", encodeURIComponent(String(s))).replace("{message_id}", encodeURIComponent(String(t))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...n }, c = {};
      O(o, {});
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * Get message responses by ID
     * @summary Get message responses by ID
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessageResponses: async (r, s, t, n = {}) => {
      h("getMessageResponses", "conversationId", r), h("getMessageResponses", "threadId", s), h("getMessageResponses", "messageId", t);
      const a = "/v1/conversations/{conversation_id}/threads/{thread_id}/messages/{message_id}/responses".replace("{conversation_id}", encodeURIComponent(String(r))).replace("{thread_id}", encodeURIComponent(String(s))).replace("{message_id}", encodeURIComponent(String(t))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...n }, c = {};
      O(o, {});
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * Get messages for a thread
     * @summary Retrieve messages for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessages: async (r, s, t = {}) => {
      h("getMessages", "conversationId", r), h("getMessages", "threadId", s);
      const n = "/v1/conversations/{conversation_id}/threads/{thread_id}/messages".replace("{conversation_id}", encodeURIComponent(String(r))).replace("{thread_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Get a thread for a conversation
     * @summary Retrieve a thread for a conversation
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getThread: async (r, s, t = {}) => {
      h("getThread", "conversationId", r), h("getThread", "threadId", s);
      const n = "/v1/conversations/{conversation_id}/threads/{thread_id}".replace("{conversation_id}", encodeURIComponent(String(r))).replace("{thread_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    }
  };
}, G = function(e) {
  const r = Ra(e);
  return {
    /**
     * Create a new conversation
     * @summary Create a new conversation
     * @param {Conversation} conversation Create a new conversation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createConversation(s, t) {
      var l, d;
      const n = await r.createConversation(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["ConversationsApi.createConversation"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Create a new conversation
     * @param {string} ownerId The ID of the owner
     * @param {Conversation} [conversation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHelperConversation(s, t, n) {
      var d, c;
      const a = await r.createHelperConversation(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ConversationsApi.createHelperConversation"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Create a new message
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {Message} [message] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHelperMessage(s, t, n, a, o) {
      var i, p;
      const l = await r.createHelperMessage(s, t, n, a, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (p = (i = y["ConversationsApi.createHelperMessage"]) == null ? void 0 : i[d]) == null ? void 0 : p.url;
      return (u, b) => _(l, R, S, e)(u, c || b);
    },
    /**
     * Create a new thread
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {Thread} thread Request to create a new thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHelperThread(s, t, n, a) {
      var c, i;
      const o = await r.createHelperThread(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ConversationsApi.createHelperThread"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Create a new message for a thread
     * @summary Create a new message for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {Message} message Create a new message request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createMessage(s, t, n, a) {
      var c, i;
      const o = await r.createMessage(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ConversationsApi.createMessage"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Create a new thread for a conversation
     * @summary Create a new thread for a conversation
     * @param {string} conversationId The ID of the conversation
     * @param {Thread} thread Create a new thread request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createThread(s, t, n) {
      var d, c;
      const a = await r.createThread(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ConversationsApi.createThread"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Delete conversation by ID
     * @summary Delete conversation by ID
     * @param {string} conversationId The ID of the conversation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteConversation(s, t) {
      var l, d;
      const n = await r.deleteConversation(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["ConversationsApi.deleteConversation"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Delete conversation by ID
     * @summary Delete conversation by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {GetConversationFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelperConversation(s, t, n, a) {
      var c, i;
      const o = await r.deleteHelperConversation(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ConversationsApi.deleteHelperConversation"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Delete message by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelperMessage(s, t, n, a, o) {
      var i, p;
      const l = await r.deleteHelperMessage(s, t, n, a, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (p = (i = y["ConversationsApi.deleteHelperMessage"]) == null ? void 0 : i[d]) == null ? void 0 : p.url;
      return (u, b) => _(l, R, S, e)(u, c || b);
    },
    /**
     * Delete thread by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {Thread} [thread] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelperThread(s, t, n, a, o) {
      var i, p;
      const l = await r.deleteHelperThread(s, t, n, a, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (p = (i = y["ConversationsApi.deleteHelperThread"]) == null ? void 0 : i[d]) == null ? void 0 : p.url;
      return (u, b) => _(l, R, S, e)(u, c || b);
    },
    /**
     * Delete a message for a thread
     * @summary Delete a message for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteMessage(s, t, n, a) {
      var c, i;
      const o = await r.deleteMessage(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ConversationsApi.deleteMessage"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Delete a thread for a conversation
     * @summary Delete a thread for a conversation
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteThread(s, t, n) {
      var d, c;
      const a = await r.deleteThread(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ConversationsApi.deleteThread"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Get conversation by ID
     * @summary Retrieve conversation by ID
     * @param {string} conversationId The ID of the conversation
     * @param {GetConversationFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConversation(s, t, n) {
      var d, c;
      const a = await r.getConversation(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ConversationsApi.getConversation"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Get all conversations
     * @summary Retrieve all conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConversations(s) {
      var o, l;
      const t = await r.getConversations(s), n = (e == null ? void 0 : e.serverIndex) ?? 0, a = (l = (o = y["ConversationsApi.getConversations"]) == null ? void 0 : o[n]) == null ? void 0 : l.url;
      return (d, c) => _(t, R, S, e)(d, a || c);
    },
    /**
     * Conversation query endpoint
     * @summary Conversation query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {GetConversationFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperConversation(s, t, n, a) {
      var c, i;
      const o = await r.getHelperConversation(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ConversationsApi.getHelperConversation"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Conversations query endpoint
     * @summary Conversations query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperConversations(s, t) {
      var l, d;
      const n = await r.getHelperConversations(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["ConversationsApi.getHelperConversations"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Get message by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperMessage(s, t, n, a, o) {
      var i, p;
      const l = await r.getHelperMessage(s, t, n, a, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (p = (i = y["ConversationsApi.getHelperMessage"]) == null ? void 0 : i[d]) == null ? void 0 : p.url;
      return (u, b) => _(l, R, S, e)(u, c || b);
    },
    /**
     * Get message responses by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperMessageResponses(s, t, n, a, o) {
      var i, p;
      const l = await r.getHelperMessageResponses(s, t, n, a, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (p = (i = y["ConversationsApi.getHelperMessageResponses"]) == null ? void 0 : i[d]) == null ? void 0 : p.url;
      return (u, b) => _(l, R, S, e)(u, c || b);
    },
    /**
     * Get thread by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperThread(s, t, n, a) {
      var c, i;
      const o = await r.getHelperThread(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ConversationsApi.getHelperThread"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Get messages for a thread
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperThreadMessages(s, t, n, a) {
      var c, i;
      const o = await r.getHelperThreadMessages(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ConversationsApi.getHelperThreadMessages"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Get a message for a thread
     * @summary Get a message for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMessage(s, t, n, a) {
      var c, i;
      const o = await r.getMessage(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ConversationsApi.getMessage"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Get message responses by ID
     * @summary Get message responses by ID
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMessageResponses(s, t, n, a) {
      var c, i;
      const o = await r.getMessageResponses(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ConversationsApi.getMessageResponses"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Get messages for a thread
     * @summary Retrieve messages for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMessages(s, t, n) {
      var d, c;
      const a = await r.getMessages(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ConversationsApi.getMessages"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Get a thread for a conversation
     * @summary Retrieve a thread for a conversation
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getThread(s, t, n) {
      var d, c;
      const a = await r.getThread(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ConversationsApi.getThread"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    }
  };
}, Ns = function(e, r, s) {
  const t = G(e);
  return {
    /**
     * Create a new conversation
     * @summary Create a new conversation
     * @param {Conversation} conversation Create a new conversation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConversation(n, a) {
      return t.createConversation(n, a).then((o) => o(s, r));
    },
    /**
     * Create a new conversation
     * @param {string} ownerId The ID of the owner
     * @param {Conversation} [conversation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperConversation(n, a, o) {
      return t.createHelperConversation(n, a, o).then((l) => l(s, r));
    },
    /**
     * Create a new message
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {Message} [message] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperMessage(n, a, o, l, d) {
      return t.createHelperMessage(n, a, o, l, d).then((c) => c(s, r));
    },
    /**
     * Create a new thread
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {Thread} thread Request to create a new thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperThread(n, a, o, l) {
      return t.createHelperThread(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Create a new message for a thread
     * @summary Create a new message for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {Message} message Create a new message request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMessage(n, a, o, l) {
      return t.createMessage(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Create a new thread for a conversation
     * @summary Create a new thread for a conversation
     * @param {string} conversationId The ID of the conversation
     * @param {Thread} thread Create a new thread request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createThread(n, a, o) {
      return t.createThread(n, a, o).then((l) => l(s, r));
    },
    /**
     * Delete conversation by ID
     * @summary Delete conversation by ID
     * @param {string} conversationId The ID of the conversation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteConversation(n, a) {
      return t.deleteConversation(n, a).then((o) => o(s, r));
    },
    /**
     * Delete conversation by ID
     * @summary Delete conversation by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {GetConversationFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperConversation(n, a, o, l) {
      return t.deleteHelperConversation(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Delete message by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperMessage(n, a, o, l, d) {
      return t.deleteHelperMessage(n, a, o, l, d).then((c) => c(s, r));
    },
    /**
     * Delete thread by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {Thread} [thread] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperThread(n, a, o, l, d) {
      return t.deleteHelperThread(n, a, o, l, d).then((c) => c(s, r));
    },
    /**
     * Delete a message for a thread
     * @summary Delete a message for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMessage(n, a, o, l) {
      return t.deleteMessage(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Delete a thread for a conversation
     * @summary Delete a thread for a conversation
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteThread(n, a, o) {
      return t.deleteThread(n, a, o).then((l) => l(s, r));
    },
    /**
     * Get conversation by ID
     * @summary Retrieve conversation by ID
     * @param {string} conversationId The ID of the conversation
     * @param {GetConversationFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConversation(n, a, o) {
      return t.getConversation(n, a, o).then((l) => l(s, r));
    },
    /**
     * Get all conversations
     * @summary Retrieve all conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConversations(n) {
      return t.getConversations(n).then((a) => a(s, r));
    },
    /**
     * Conversation query endpoint
     * @summary Conversation query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {GetConversationFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperConversation(n, a, o, l) {
      return t.getHelperConversation(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Conversations query endpoint
     * @summary Conversations query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperConversations(n, a) {
      return t.getHelperConversations(n, a).then((o) => o(s, r));
    },
    /**
     * Get message by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperMessage(n, a, o, l, d) {
      return t.getHelperMessage(n, a, o, l, d).then((c) => c(s, r));
    },
    /**
     * Get message responses by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperMessageResponses(n, a, o, l, d) {
      return t.getHelperMessageResponses(n, a, o, l, d).then((c) => c(s, r));
    },
    /**
     * Get thread by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperThread(n, a, o, l) {
      return t.getHelperThread(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Get messages for a thread
     * @param {string} ownerId The ID of the owner
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperThreadMessages(n, a, o, l) {
      return t.getHelperThreadMessages(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Get a message for a thread
     * @summary Get a message for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessage(n, a, o, l) {
      return t.getMessage(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Get message responses by ID
     * @summary Get message responses by ID
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {string} messageId The ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessageResponses(n, a, o, l) {
      return t.getMessageResponses(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Get messages for a thread
     * @summary Retrieve messages for a thread
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessages(n, a, o) {
      return t.getMessages(n, a, o).then((l) => l(s, r));
    },
    /**
     * Get a thread for a conversation
     * @summary Retrieve a thread for a conversation
     * @param {string} conversationId The ID of the conversation
     * @param {string} threadId The ID of the thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getThread(n, a, o) {
      return t.getThread(n, a, o).then((l) => l(s, r));
    }
  };
};
class Sa extends ie {
  /**
   * Create a new conversation
   * @summary Create a new conversation
   * @param {Conversation} conversation Create a new conversation request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  createConversation(r, s) {
    return G(this.configuration).createConversation(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Create a new conversation
   * @param {string} ownerId The ID of the owner
   * @param {Conversation} [conversation] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  createHelperConversation(r, s, t) {
    return G(this.configuration).createHelperConversation(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Create a new message
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {Message} [message] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  createHelperMessage(r, s, t, n, a) {
    return G(this.configuration).createHelperMessage(r, s, t, n, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Create a new thread
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {Thread} thread Request to create a new thread
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  createHelperThread(r, s, t, n) {
    return G(this.configuration).createHelperThread(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Create a new message for a thread
   * @summary Create a new message for a thread
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {Message} message Create a new message request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  createMessage(r, s, t, n) {
    return G(this.configuration).createMessage(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Create a new thread for a conversation
   * @summary Create a new thread for a conversation
   * @param {string} conversationId The ID of the conversation
   * @param {Thread} thread Create a new thread request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  createThread(r, s, t) {
    return G(this.configuration).createThread(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete conversation by ID
   * @summary Delete conversation by ID
   * @param {string} conversationId The ID of the conversation
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  deleteConversation(r, s) {
    return G(this.configuration).deleteConversation(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Delete conversation by ID
   * @summary Delete conversation by ID
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {GetConversationFilterParameter} [filter] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  deleteHelperConversation(r, s, t, n) {
    return G(this.configuration).deleteHelperConversation(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Delete message by ID
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {string} messageId The ID of the message
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  deleteHelperMessage(r, s, t, n, a) {
    return G(this.configuration).deleteHelperMessage(r, s, t, n, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Delete thread by ID
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {Thread} [thread] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  deleteHelperThread(r, s, t, n, a) {
    return G(this.configuration).deleteHelperThread(r, s, t, n, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Delete a message for a thread
   * @summary Delete a message for a thread
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {string} messageId The ID of the message
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  deleteMessage(r, s, t, n) {
    return G(this.configuration).deleteMessage(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Delete a thread for a conversation
   * @summary Delete a thread for a conversation
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  deleteThread(r, s, t) {
    return G(this.configuration).deleteThread(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get conversation by ID
   * @summary Retrieve conversation by ID
   * @param {string} conversationId The ID of the conversation
   * @param {GetConversationFilterParameter} [filter] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getConversation(r, s, t) {
    return G(this.configuration).getConversation(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get all conversations
   * @summary Retrieve all conversations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getConversations(r) {
    return G(this.configuration).getConversations(r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * Conversation query endpoint
   * @summary Conversation query endpoint
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {GetConversationFilterParameter} [filter] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getHelperConversation(r, s, t, n) {
    return G(this.configuration).getHelperConversation(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Conversations query endpoint
   * @summary Conversations query endpoint
   * @param {string} ownerId The ID of the owner
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getHelperConversations(r, s) {
    return G(this.configuration).getHelperConversations(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Get message by ID
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {string} messageId The ID of the message
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getHelperMessage(r, s, t, n, a) {
    return G(this.configuration).getHelperMessage(r, s, t, n, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Get message responses by ID
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {string} messageId The ID of the message
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getHelperMessageResponses(r, s, t, n, a) {
    return G(this.configuration).getHelperMessageResponses(r, s, t, n, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Get thread by ID
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getHelperThread(r, s, t, n) {
    return G(this.configuration).getHelperThread(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Get messages for a thread
   * @param {string} ownerId The ID of the owner
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getHelperThreadMessages(r, s, t, n) {
    return G(this.configuration).getHelperThreadMessages(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Get a message for a thread
   * @summary Get a message for a thread
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {string} messageId The ID of the message
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getMessage(r, s, t, n) {
    return G(this.configuration).getMessage(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Get message responses by ID
   * @summary Get message responses by ID
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {string} messageId The ID of the message
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getMessageResponses(r, s, t, n) {
    return G(this.configuration).getMessageResponses(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Get messages for a thread
   * @summary Retrieve messages for a thread
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getMessages(r, s, t) {
    return G(this.configuration).getMessages(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get a thread for a conversation
   * @summary Retrieve a thread for a conversation
   * @param {string} conversationId The ID of the conversation
   * @param {string} threadId The ID of the thread
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConversationsApi
   */
  getThread(r, s, t) {
    return G(this.configuration).getThread(r, s, t).then((n) => n(this.axios, this.basePath));
  }
}
const ya = function(e) {
  return {
    /**
     * 
     * @summary Add system role
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addHelperHelperSystemRole: async (r, s, t, n = {}) => {
      h("addHelperHelperSystemRole", "ownerId", r), h("addHelperHelperSystemRole", "helperId", s), h("addHelperHelperSystemRole", "body", t);
      const a = "/helper/{owner_id}/helpers/{helper_id}/system_roles".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Add system role for a helper
     * @summary Add system role for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addHelperSystemRole: async (r, s, t = {}) => {
      h("addHelperSystemRole", "helperId", r), h("addHelperSystemRole", "body", s);
      const n = "/v1/helpers/{helper_id}/system_roles".replace("{helper_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Create a new helper
     * @summary Create a new helper
     * @param {Helper} helper Create a new helper request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelper: async (r, s = {}) => {
      h("createHelper", "helper", r);
      const t = "/v1/helpers", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "POST", ...a, ...s }, l = {}, d = {};
      l["Content-Type"] = "application/json", O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = N(r, o, e), {
        url: T(n),
        options: o
      };
    },
    /**
     * 
     * @summary Create a new agent
     * @param {string} ownerId The ID of the owner
     * @param {Helper} helper Create a new agent request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperHelper: async (r, s, t = {}) => {
      h("createHelperHelper", "ownerId", r), h("createHelperHelper", "helper", s);
      const n = "/helper/{owner_id}/helpers".replace("{owner_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * 
     * @summary Create instruction
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperHelperInstruction: async (r, s, t, n = {}) => {
      h("createHelperHelperInstruction", "ownerId", r), h("createHelperHelperInstruction", "helperId", s), h("createHelperHelperInstruction", "helperInstruction", t);
      const a = "/helper/{owner_id}/helpers/{helper_id}/instructions".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * 
     * @summary Create skills
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperHelperSkills: async (r, s, t, n = {}) => {
      h("createHelperHelperSkills", "ownerId", r), h("createHelperHelperSkills", "helperId", s), h("createHelperHelperSkills", "requestBody", t);
      const a = "/helper/{owner_id}/helpers/{helper_id}/skills".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Create a new instruction for a helper
     * @summary Create a new instruction for a helper
     * @param {string} helperId The ID of the user helper
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperInstruction: async (r, s, t = {}) => {
      h("createHelperInstruction", "helperId", r), h("createHelperInstruction", "helperInstruction", s);
      const n = "/v1/helpers/{helper_id}/instructions".replace("{helper_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Create skills for a helper
     * @summary Create skills for a helper
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperSkills: async (r, s, t = {}) => {
      h("createHelperSkills", "helperId", r), h("createHelperSkills", "requestBody", s);
      const n = "/v1/helpers/{helper_id}/skills".replace("{helper_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Delete helper by ID
     * @summary Delete helper by ID
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelper: async (r, s = {}) => {
      h("deleteHelper", "helperId", r);
      const t = "/v1/helpers/{helper_id}".replace("{helper_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "DELETE", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * 
     * @summary Delete agent
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperHelper: async (r, s, t = {}) => {
      h("deleteHelperHelper", "ownerId", r), h("deleteHelperHelper", "helperId", s);
      const n = "/helper/{owner_id}/helpers/{helper_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * 
     * @summary Delete instruction
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperHelperInstruction: async (r, s, t, n = {}) => {
      h("deleteHelperHelperInstruction", "ownerId", r), h("deleteHelperHelperInstruction", "helperId", s), h("deleteHelperHelperInstruction", "instructionId", t);
      const a = "/helper/{owner_id}/helpers/{helper_id}/instructions/{instruction_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))).replace("{instruction_id}", encodeURIComponent(String(t))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...n }, c = {};
      O(o, {});
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * 
     * @summary Delete skills
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperHelperSkills: async (r, s, t, n = {}) => {
      h("deleteHelperHelperSkills", "ownerId", r), h("deleteHelperHelperSkills", "helperId", s), h("deleteHelperHelperSkills", "requestBody", t);
      const a = "/helper/{owner_id}/helpers/{helper_id}/skills".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Delete an instruction for a helper
     * @summary Delete an instruction for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperInstruction: async (r, s, t = {}) => {
      h("deleteHelperInstruction", "helperId", r), h("deleteHelperInstruction", "instructionId", s);
      const n = "/v1/helpers/{helper_id}/instructions/{instruction_id}".replace("{helper_id}", encodeURIComponent(String(r))).replace("{instruction_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Delete skills for a helper
     * @summary Delete skills for a helper
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperSkills: async (r, s, t = {}) => {
      h("deleteHelperSkills", "helperId", r), h("deleteHelperSkills", "requestBody", s);
      const n = "/v1/helpers/{helper_id}/skills".replace("{helper_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Get helper by ID
     * @summary Retrieve helper by ID
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelper: async (r, s = {}) => {
      h("getHelper", "helperId", r);
      const t = "/v1/helpers/{helper_id}".replace("{helper_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * 
     * @summary Get egent
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperHelper: async (r, s, t = {}) => {
      h("getHelperHelper", "ownerId", r), h("getHelperHelper", "helperId", s);
      const n = "/helper/{owner_id}/helpers/{helper_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * 
     * @summary Get helpers by owner
     * @param {string} ownerId The ID of the owner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperHelpers: async (r, s = {}) => {
      h("getHelperHelpers", "ownerId", r);
      const t = "/helper/{owner_id}/helpers".replace("{owner_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Get all helpers
     * @summary Retrieve all helpers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelpers: async (r = {}) => {
      const s = "/v1/helpers", t = new URL(s, E);
      let n;
      e && (n = e.baseOptions);
      const a = { method: "GET", ...n, ...r }, o = {};
      O(t, {});
      let d = n && n.headers ? n.headers : {};
      return a.headers = { ...o, ...d, ...r.headers }, {
        url: T(t),
        options: a
      };
    },
    /**
     * 
     * @summary Remove system role
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeHelperHelperSystemRole: async (r, s, t, n = {}) => {
      h("removeHelperHelperSystemRole", "ownerId", r), h("removeHelperHelperSystemRole", "helperId", s), h("removeHelperHelperSystemRole", "body", t);
      const a = "/helper/{owner_id}/helpers/{helper_id}/system_roles".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Remove system role for a helper
     * @summary Remove system role for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeHelperSystemRole: async (r, s, t = {}) => {
      h("removeHelperSystemRole", "helperId", r), h("removeHelperSystemRole", "body", s);
      const n = "/v1/helpers/{helper_id}/system_roles".replace("{helper_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Update helper by ID
     * @summary Update helper by ID
     * @param {string} helperId The ID of the user helper
     * @param {Helper} helper 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelper: async (r, s, t = {}) => {
      h("updateHelper", "helperId", r), h("updateHelper", "helper", s);
      const n = "/v1/helpers/{helper_id}".replace("{helper_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PUT", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * 
     * @summary Update agent
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {Helper} helper 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperHelper: async (r, s, t, n = {}) => {
      h("updateHelperHelper", "ownerId", r), h("updateHelperHelper", "helperId", s), h("updateHelperHelper", "helper", t);
      const a = "/helper/{owner_id}/helpers/{helper_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "PUT", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * 
     * @summary Update instruction
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperHelperInstruction: async (r, s, t, n, a = {}) => {
      h("updateHelperHelperInstruction", "ownerId", r), h("updateHelperHelperInstruction", "helperId", s), h("updateHelperHelperInstruction", "instructionId", t), h("updateHelperHelperInstruction", "helperInstruction", n);
      const o = "/helper/{owner_id}/helpers/{helper_id}/instructions/{instruction_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{helper_id}", encodeURIComponent(String(s))).replace("{instruction_id}", encodeURIComponent(String(t))), l = new URL(o, E);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "PUT", ...d, ...a }, i = {}, p = {};
      i["Content-Type"] = "application/json", O(l, p);
      let u = d && d.headers ? d.headers : {};
      return c.headers = { ...i, ...u, ...a.headers }, c.data = N(n, c, e), {
        url: T(l),
        options: c
      };
    },
    /**
     * Update an instruction for a helper
     * @summary Update an instruction for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperInstruction: async (r, s, t, n = {}) => {
      h("updateHelperInstruction", "helperId", r), h("updateHelperInstruction", "instructionId", s), h("updateHelperInstruction", "helperInstruction", t);
      const a = "/v1/helpers/{helper_id}/instructions/{instruction_id}".replace("{helper_id}", encodeURIComponent(String(r))).replace("{instruction_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "PUT", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    }
  };
}, $ = function(e) {
  const r = ya(e);
  return {
    /**
     * 
     * @summary Add system role
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addHelperHelperSystemRole(s, t, n, a) {
      var c, i;
      const o = await r.addHelperHelperSystemRole(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["HelpersApi.addHelperHelperSystemRole"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Add system role for a helper
     * @summary Add system role for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addHelperSystemRole(s, t, n) {
      var d, c;
      const a = await r.addHelperSystemRole(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.addHelperSystemRole"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Create a new helper
     * @summary Create a new helper
     * @param {Helper} helper Create a new helper request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHelper(s, t) {
      var l, d;
      const n = await r.createHelper(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["HelpersApi.createHelper"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * 
     * @summary Create a new agent
     * @param {string} ownerId The ID of the owner
     * @param {Helper} helper Create a new agent request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHelperHelper(s, t, n) {
      var d, c;
      const a = await r.createHelperHelper(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.createHelperHelper"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * 
     * @summary Create instruction
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHelperHelperInstruction(s, t, n, a) {
      var c, i;
      const o = await r.createHelperHelperInstruction(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["HelpersApi.createHelperHelperInstruction"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * 
     * @summary Create skills
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHelperHelperSkills(s, t, n, a) {
      var c, i;
      const o = await r.createHelperHelperSkills(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["HelpersApi.createHelperHelperSkills"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Create a new instruction for a helper
     * @summary Create a new instruction for a helper
     * @param {string} helperId The ID of the user helper
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHelperInstruction(s, t, n) {
      var d, c;
      const a = await r.createHelperInstruction(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.createHelperInstruction"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Create skills for a helper
     * @summary Create skills for a helper
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createHelperSkills(s, t, n) {
      var d, c;
      const a = await r.createHelperSkills(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.createHelperSkills"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Delete helper by ID
     * @summary Delete helper by ID
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelper(s, t) {
      var l, d;
      const n = await r.deleteHelper(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["HelpersApi.deleteHelper"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * 
     * @summary Delete agent
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelperHelper(s, t, n) {
      var d, c;
      const a = await r.deleteHelperHelper(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.deleteHelperHelper"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * 
     * @summary Delete instruction
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelperHelperInstruction(s, t, n, a) {
      var c, i;
      const o = await r.deleteHelperHelperInstruction(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["HelpersApi.deleteHelperHelperInstruction"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * 
     * @summary Delete skills
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelperHelperSkills(s, t, n, a) {
      var c, i;
      const o = await r.deleteHelperHelperSkills(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["HelpersApi.deleteHelperHelperSkills"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Delete an instruction for a helper
     * @summary Delete an instruction for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelperInstruction(s, t, n) {
      var d, c;
      const a = await r.deleteHelperInstruction(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.deleteHelperInstruction"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Delete skills for a helper
     * @summary Delete skills for a helper
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelperSkills(s, t, n) {
      var d, c;
      const a = await r.deleteHelperSkills(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.deleteHelperSkills"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Get helper by ID
     * @summary Retrieve helper by ID
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelper(s, t) {
      var l, d;
      const n = await r.getHelper(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["HelpersApi.getHelper"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * 
     * @summary Get egent
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperHelper(s, t, n) {
      var d, c;
      const a = await r.getHelperHelper(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.getHelperHelper"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * 
     * @summary Get helpers by owner
     * @param {string} ownerId The ID of the owner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperHelpers(s, t) {
      var l, d;
      const n = await r.getHelperHelpers(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["HelpersApi.getHelperHelpers"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Get all helpers
     * @summary Retrieve all helpers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelpers(s) {
      var o, l;
      const t = await r.getHelpers(s), n = (e == null ? void 0 : e.serverIndex) ?? 0, a = (l = (o = y["HelpersApi.getHelpers"]) == null ? void 0 : o[n]) == null ? void 0 : l.url;
      return (d, c) => _(t, R, S, e)(d, a || c);
    },
    /**
     * 
     * @summary Remove system role
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeHelperHelperSystemRole(s, t, n, a) {
      var c, i;
      const o = await r.removeHelperHelperSystemRole(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["HelpersApi.removeHelperHelperSystemRole"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Remove system role for a helper
     * @summary Remove system role for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeHelperSystemRole(s, t, n) {
      var d, c;
      const a = await r.removeHelperSystemRole(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.removeHelperSystemRole"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Update helper by ID
     * @summary Update helper by ID
     * @param {string} helperId The ID of the user helper
     * @param {Helper} helper 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHelper(s, t, n) {
      var d, c;
      const a = await r.updateHelper(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["HelpersApi.updateHelper"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * 
     * @summary Update agent
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {Helper} helper 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHelperHelper(s, t, n, a) {
      var c, i;
      const o = await r.updateHelperHelper(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["HelpersApi.updateHelperHelper"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * 
     * @summary Update instruction
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHelperHelperInstruction(s, t, n, a, o) {
      var i, p;
      const l = await r.updateHelperHelperInstruction(s, t, n, a, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (p = (i = y["HelpersApi.updateHelperHelperInstruction"]) == null ? void 0 : i[d]) == null ? void 0 : p.url;
      return (u, b) => _(l, R, S, e)(u, c || b);
    },
    /**
     * Update an instruction for a helper
     * @summary Update an instruction for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHelperInstruction(s, t, n, a) {
      var c, i;
      const o = await r.updateHelperInstruction(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["HelpersApi.updateHelperInstruction"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    }
  };
}, fs = function(e, r, s) {
  const t = $(e);
  return {
    /**
     * 
     * @summary Add system role
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addHelperHelperSystemRole(n, a, o, l) {
      return t.addHelperHelperSystemRole(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Add system role for a helper
     * @summary Add system role for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addHelperSystemRole(n, a, o) {
      return t.addHelperSystemRole(n, a, o).then((l) => l(s, r));
    },
    /**
     * Create a new helper
     * @summary Create a new helper
     * @param {Helper} helper Create a new helper request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelper(n, a) {
      return t.createHelper(n, a).then((o) => o(s, r));
    },
    /**
     * 
     * @summary Create a new agent
     * @param {string} ownerId The ID of the owner
     * @param {Helper} helper Create a new agent request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperHelper(n, a, o) {
      return t.createHelperHelper(n, a, o).then((l) => l(s, r));
    },
    /**
     * 
     * @summary Create instruction
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperHelperInstruction(n, a, o, l) {
      return t.createHelperHelperInstruction(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * 
     * @summary Create skills
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperHelperSkills(n, a, o, l) {
      return t.createHelperHelperSkills(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Create a new instruction for a helper
     * @summary Create a new instruction for a helper
     * @param {string} helperId The ID of the user helper
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperInstruction(n, a, o) {
      return t.createHelperInstruction(n, a, o).then((l) => l(s, r));
    },
    /**
     * Create skills for a helper
     * @summary Create skills for a helper
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createHelperSkills(n, a, o) {
      return t.createHelperSkills(n, a, o).then((l) => l(s, r));
    },
    /**
     * Delete helper by ID
     * @summary Delete helper by ID
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelper(n, a) {
      return t.deleteHelper(n, a).then((o) => o(s, r));
    },
    /**
     * 
     * @summary Delete agent
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperHelper(n, a, o) {
      return t.deleteHelperHelper(n, a, o).then((l) => l(s, r));
    },
    /**
     * 
     * @summary Delete instruction
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperHelperInstruction(n, a, o, l) {
      return t.deleteHelperHelperInstruction(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * 
     * @summary Delete skills
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperHelperSkills(n, a, o, l) {
      return t.deleteHelperHelperSkills(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Delete an instruction for a helper
     * @summary Delete an instruction for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperInstruction(n, a, o) {
      return t.deleteHelperInstruction(n, a, o).then((l) => l(s, r));
    },
    /**
     * Delete skills for a helper
     * @summary Delete skills for a helper
     * @param {string} helperId The ID of the user helper
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperSkills(n, a, o) {
      return t.deleteHelperSkills(n, a, o).then((l) => l(s, r));
    },
    /**
     * Get helper by ID
     * @summary Retrieve helper by ID
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelper(n, a) {
      return t.getHelper(n, a).then((o) => o(s, r));
    },
    /**
     * 
     * @summary Get egent
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperHelper(n, a, o) {
      return t.getHelperHelper(n, a, o).then((l) => l(s, r));
    },
    /**
     * 
     * @summary Get helpers by owner
     * @param {string} ownerId The ID of the owner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperHelpers(n, a) {
      return t.getHelperHelpers(n, a).then((o) => o(s, r));
    },
    /**
     * Get all helpers
     * @summary Retrieve all helpers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelpers(n) {
      return t.getHelpers(n).then((a) => a(s, r));
    },
    /**
     * 
     * @summary Remove system role
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeHelperHelperSystemRole(n, a, o, l) {
      return t.removeHelperHelperSystemRole(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Remove system role for a helper
     * @summary Remove system role for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeHelperSystemRole(n, a, o) {
      return t.removeHelperSystemRole(n, a, o).then((l) => l(s, r));
    },
    /**
     * Update helper by ID
     * @summary Update helper by ID
     * @param {string} helperId The ID of the user helper
     * @param {Helper} helper 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelper(n, a, o) {
      return t.updateHelper(n, a, o).then((l) => l(s, r));
    },
    /**
     * 
     * @summary Update agent
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {Helper} helper 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperHelper(n, a, o, l) {
      return t.updateHelperHelper(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * 
     * @summary Update instruction
     * @param {string} ownerId The ID of the owner
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperHelperInstruction(n, a, o, l, d) {
      return t.updateHelperHelperInstruction(n, a, o, l, d).then((c) => c(s, r));
    },
    /**
     * Update an instruction for a helper
     * @summary Update an instruction for a helper
     * @param {string} helperId The ID of the user helper
     * @param {string} instructionId The ID of the instruction
     * @param {HelperInstruction} helperInstruction 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperInstruction(n, a, o, l) {
      return t.updateHelperInstruction(n, a, o, l).then((d) => d(s, r));
    }
  };
};
class Ea extends ie {
  /**
   * 
   * @summary Add system role
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {string} body 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  addHelperHelperSystemRole(r, s, t, n) {
    return $(this.configuration).addHelperHelperSystemRole(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Add system role for a helper
   * @summary Add system role for a helper
   * @param {string} helperId The ID of the user helper
   * @param {string} body 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  addHelperSystemRole(r, s, t) {
    return $(this.configuration).addHelperSystemRole(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Create a new helper
   * @summary Create a new helper
   * @param {Helper} helper Create a new helper request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  createHelper(r, s) {
    return $(this.configuration).createHelper(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Create a new agent
   * @param {string} ownerId The ID of the owner
   * @param {Helper} helper Create a new agent request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  createHelperHelper(r, s, t) {
    return $(this.configuration).createHelperHelper(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Create instruction
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {HelperInstruction} helperInstruction 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  createHelperHelperInstruction(r, s, t, n) {
    return $(this.configuration).createHelperHelperInstruction(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Create skills
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {Array<string>} requestBody 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  createHelperHelperSkills(r, s, t, n) {
    return $(this.configuration).createHelperHelperSkills(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Create a new instruction for a helper
   * @summary Create a new instruction for a helper
   * @param {string} helperId The ID of the user helper
   * @param {HelperInstruction} helperInstruction 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  createHelperInstruction(r, s, t) {
    return $(this.configuration).createHelperInstruction(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Create skills for a helper
   * @summary Create skills for a helper
   * @param {string} helperId The ID of the user helper
   * @param {Array<string>} requestBody 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  createHelperSkills(r, s, t) {
    return $(this.configuration).createHelperSkills(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete helper by ID
   * @summary Delete helper by ID
   * @param {string} helperId The ID of the user helper
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  deleteHelper(r, s) {
    return $(this.configuration).deleteHelper(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete agent
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  deleteHelperHelper(r, s, t) {
    return $(this.configuration).deleteHelperHelper(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete instruction
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {string} instructionId The ID of the instruction
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  deleteHelperHelperInstruction(r, s, t, n) {
    return $(this.configuration).deleteHelperHelperInstruction(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete skills
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {Array<string>} requestBody 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  deleteHelperHelperSkills(r, s, t, n) {
    return $(this.configuration).deleteHelperHelperSkills(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Delete an instruction for a helper
   * @summary Delete an instruction for a helper
   * @param {string} helperId The ID of the user helper
   * @param {string} instructionId The ID of the instruction
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  deleteHelperInstruction(r, s, t) {
    return $(this.configuration).deleteHelperInstruction(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete skills for a helper
   * @summary Delete skills for a helper
   * @param {string} helperId The ID of the user helper
   * @param {Array<string>} requestBody 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  deleteHelperSkills(r, s, t) {
    return $(this.configuration).deleteHelperSkills(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get helper by ID
   * @summary Retrieve helper by ID
   * @param {string} helperId The ID of the user helper
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  getHelper(r, s) {
    return $(this.configuration).getHelper(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get egent
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  getHelperHelper(r, s, t) {
    return $(this.configuration).getHelperHelper(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get helpers by owner
   * @param {string} ownerId The ID of the owner
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  getHelperHelpers(r, s) {
    return $(this.configuration).getHelperHelpers(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Get all helpers
   * @summary Retrieve all helpers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  getHelpers(r) {
    return $(this.configuration).getHelpers(r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Remove system role
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {string} body 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  removeHelperHelperSystemRole(r, s, t, n) {
    return $(this.configuration).removeHelperHelperSystemRole(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Remove system role for a helper
   * @summary Remove system role for a helper
   * @param {string} helperId The ID of the user helper
   * @param {string} body 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  removeHelperSystemRole(r, s, t) {
    return $(this.configuration).removeHelperSystemRole(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Update helper by ID
   * @summary Update helper by ID
   * @param {string} helperId The ID of the user helper
   * @param {Helper} helper 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  updateHelper(r, s, t) {
    return $(this.configuration).updateHelper(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update agent
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {Helper} helper 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  updateHelperHelper(r, s, t, n) {
    return $(this.configuration).updateHelperHelper(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update instruction
   * @param {string} ownerId The ID of the owner
   * @param {string} helperId The ID of the user helper
   * @param {string} instructionId The ID of the instruction
   * @param {HelperInstruction} helperInstruction 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  updateHelperHelperInstruction(r, s, t, n, a) {
    return $(this.configuration).updateHelperHelperInstruction(r, s, t, n, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Update an instruction for a helper
   * @summary Update an instruction for a helper
   * @param {string} helperId The ID of the user helper
   * @param {string} instructionId The ID of the instruction
   * @param {HelperInstruction} helperInstruction 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HelpersApi
   */
  updateHelperInstruction(r, s, t, n) {
    return $(this.configuration).updateHelperInstruction(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
}
const Oa = function(e) {
  return {
    /**
     * Add a tag to a document
     * @param {string} documentId The ID of the document
     * @param {string} body Add a tag to a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addDocumentTag: async (r, s, t = {}) => {
      h("addDocumentTag", "documentId", r), h("addDocumentTag", "body", s);
      const n = "/v1/documents/{document_id}/tags".replace("{document_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Add a tag to a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {string} body Add a tag to a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addKnowledgebaseDocumentTag: async (r, s, t, n = {}) => {
      h("addKnowledgebaseDocumentTag", "ownerId", r), h("addKnowledgebaseDocumentTag", "documentId", s), h("addKnowledgebaseDocumentTag", "body", t);
      const a = "/knowledgebase/{owner_id}/documents/{document_id}/tags".replace("{owner_id}", encodeURIComponent(String(r))).replace("{document_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "POST", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Create a new document
     * @param {string} ownerId The ID of the owner
     * @param {FileStorage} fileStorage Create a new document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createKnowledgebaseDocument: async (r, s, t = {}) => {
      h("createKnowledgebaseDocument", "ownerId", r), h("createKnowledgebaseDocument", "fileStorage", s);
      const n = "/knowledgebase/{owner_id}/documents".replace("{owner_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Delete document by ID
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDocument: async (r, s = {}) => {
      h("deleteDocument", "documentId", r);
      const t = "/v1/documents/{document_id}".replace("{document_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "DELETE", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Delete a document text chunk
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDocumentTextChunk: async (r, s, t = {}) => {
      h("deleteDocumentTextChunk", "documentId", r), h("deleteDocumentTextChunk", "documentChunkIndex", s);
      const n = "/v1/documents/{document_id}/text_chunks/{document_chunk_index}".replace("{document_id}", encodeURIComponent(String(r))).replace("{document_chunk_index}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Delete a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKnowledgebaseDocument: async (r, s, t = {}) => {
      h("deleteKnowledgebaseDocument", "ownerId", r), h("deleteKnowledgebaseDocument", "documentId", s);
      const n = "/knowledgebase/{owner_id}/documents/{document_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{document_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Delete a document text chunk
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKnowledgebaseDocumentTextChunk: async (r, s, t, n = {}) => {
      h("deleteKnowledgebaseDocumentTextChunk", "ownerId", r), h("deleteKnowledgebaseDocumentTextChunk", "documentId", s), h("deleteKnowledgebaseDocumentTextChunk", "documentChunkIndex", t);
      const a = "/knowledgebase/{owner_id}/documents/{document_id}/text_chunks/{document_chunk_index}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{document_id}", encodeURIComponent(String(s))).replace("{document_chunk_index}", encodeURIComponent(String(t))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...n }, c = {};
      O(o, {});
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * Get document by ID
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocument: async (r, s = {}) => {
      h("getDocument", "documentId", r);
      const t = "/v1/documents/{document_id}".replace("{document_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Get document content for preview
     * @summary Retrieve the actual file content of a document
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentContent: async (r, s = {}) => {
      h("getDocumentContent", "documentId", r);
      const t = "/v1/documents/{document_id}/content".replace("{document_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Get document text chunks
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentTextChunks: async (r, s = {}) => {
      h("getDocumentTextChunks", "documentId", r);
      const t = "/v1/documents/{document_id}/text_chunks".replace("{document_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Get Document
     * @summary Get Document endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKnowledgebaseDocument: async (r, s, t = {}) => {
      h("getKnowledgebaseDocument", "ownerId", r), h("getKnowledgebaseDocument", "documentId", s);
      const n = "/knowledgebase/{owner_id}/documents/{document_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{document_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Get document text chunks
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKnowledgebaseDocumentTextChunks: async (r, s, t = {}) => {
      h("getKnowledgebaseDocumentTextChunks", "ownerId", r), h("getKnowledgebaseDocumentTextChunks", "documentId", s);
      const n = "/knowledgebase/{owner_id}/documents/{document_id}/text_chunks".replace("{owner_id}", encodeURIComponent(String(r))).replace("{document_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Query Documents
     * @param {string} ownerId The ID of the owner
     * @param {SearchDocumentsFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryKnowledgebaseDocuments: async (r, s, t = {}) => {
      h("queryKnowledgebaseDocuments", "ownerId", r);
      const n = "/knowledgebase/{owner_id}/documents".replace("{owner_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {}, c = {};
      if (s !== void 0)
        for (const [p, u] of Object.entries(s))
          c[p] = u;
      O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Remove a tag from a document
     * @param {string} documentId The ID of the document
     * @param {string} body Remove a tag from a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeDocumentTag: async (r, s, t = {}) => {
      h("removeDocumentTag", "documentId", r), h("removeDocumentTag", "body", s);
      const n = "/v1/documents/{document_id}/tags".replace("{document_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Remove a tag from a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {string} body Remove a tag from a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeKnowledgebaseDocumentTag: async (r, s, t, n = {}) => {
      h("removeKnowledgebaseDocumentTag", "ownerId", r), h("removeKnowledgebaseDocumentTag", "documentId", s), h("removeKnowledgebaseDocumentTag", "body", t);
      const a = "/knowledgebase/{owner_id}/documents/{document_id}/tags".replace("{owner_id}", encodeURIComponent(String(r))).replace("{document_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "DELETE", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Reset document process
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetDocumentProcess: async (r, s = {}) => {
      h("resetDocumentProcess", "documentId", r);
      const t = "/v1/documents/{document_id}/process".replace("{document_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "PUT", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Process a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetKnowledgebaseDocumentProcess: async (r, s, t = {}) => {
      h("resetKnowledgebaseDocumentProcess", "ownerId", r), h("resetKnowledgebaseDocumentProcess", "documentId", s);
      const n = "/knowledgebase/{owner_id}/documents/{document_id}/process".replace("{owner_id}", encodeURIComponent(String(r))).replace("{document_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PUT", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Search documents contextually
     * @param {SearchDocumentsFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDocuments: async (r, s = {}) => {
      const t = "/v1/documents", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {}, d = {};
      if (r !== void 0)
        for (const [i, p] of Object.entries(r))
          d[i] = p;
      O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Update document name
     * @param {string} documentId The ID of the document
     * @param {string} body Update document name request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDocumentName: async (r, s, t = {}) => {
      h("updateDocumentName", "documentId", r), h("updateDocumentName", "body", s);
      const n = "/v1/documents/{document_id}/name".replace("{document_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PUT", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Update a document text chunk
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {string} body Update a document text chunk request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDocumentTextChunk: async (r, s, t, n = {}) => {
      h("updateDocumentTextChunk", "documentId", r), h("updateDocumentTextChunk", "documentChunkIndex", s), h("updateDocumentTextChunk", "body", t);
      const a = "/v1/documents/{document_id}/text_chunks/{document_chunk_index}".replace("{document_id}", encodeURIComponent(String(r))).replace("{document_chunk_index}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "PUT", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Update a document name
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {string} body Update a document name request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateKnowledgebaseDocumentName: async (r, s, t, n = {}) => {
      h("updateKnowledgebaseDocumentName", "ownerId", r), h("updateKnowledgebaseDocumentName", "documentId", s), h("updateKnowledgebaseDocumentName", "body", t);
      const a = "/knowledgebase/{owner_id}/documents/{document_id}/name".replace("{owner_id}", encodeURIComponent(String(r))).replace("{document_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "PUT", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Update a document text chunk
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {string} body Update a document text chunk request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateKnowledgebaseDocumentTextChunk: async (r, s, t, n, a = {}) => {
      h("updateKnowledgebaseDocumentTextChunk", "ownerId", r), h("updateKnowledgebaseDocumentTextChunk", "documentId", s), h("updateKnowledgebaseDocumentTextChunk", "documentChunkIndex", t), h("updateKnowledgebaseDocumentTextChunk", "body", n);
      const o = "/knowledgebase/{owner_id}/documents/{document_id}/text_chunks/{document_chunk_index}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{document_id}", encodeURIComponent(String(s))).replace("{document_chunk_index}", encodeURIComponent(String(t))), l = new URL(o, E);
      let d;
      e && (d = e.baseOptions);
      const c = { method: "PUT", ...d, ...a }, i = {}, p = {};
      i["Content-Type"] = "application/json", O(l, p);
      let u = d && d.headers ? d.headers : {};
      return c.headers = { ...i, ...u, ...a.headers }, c.data = N(n, c, e), {
        url: T(l),
        options: c
      };
    },
    /**
     * Upload a file
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadFile: async (r, s = {}) => {
      const t = "/v1/documents", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "POST", ...a, ...s }, l = {}, d = {}, c = new (e && e.formDataCtor || FormData)();
      r !== void 0 && c.append("file", r), l["Content-Type"] = "multipart/form-data", O(n, d);
      let i = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...i, ...s.headers }, o.data = c, {
        url: T(n),
        options: o
      };
    }
  };
}, q = function(e) {
  const r = Oa(e);
  return {
    /**
     * Add a tag to a document
     * @param {string} documentId The ID of the document
     * @param {string} body Add a tag to a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addDocumentTag(s, t, n) {
      var d, c;
      const a = await r.addDocumentTag(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.addDocumentTag"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Add a tag to a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {string} body Add a tag to a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addKnowledgebaseDocumentTag(s, t, n, a) {
      var c, i;
      const o = await r.addKnowledgebaseDocumentTag(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["KnowledgebaseApi.addKnowledgebaseDocumentTag"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Create a new document
     * @param {string} ownerId The ID of the owner
     * @param {FileStorage} fileStorage Create a new document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createKnowledgebaseDocument(s, t, n) {
      var d, c;
      const a = await r.createKnowledgebaseDocument(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.createKnowledgebaseDocument"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Delete document by ID
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteDocument(s, t) {
      var l, d;
      const n = await r.deleteDocument(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["KnowledgebaseApi.deleteDocument"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Delete a document text chunk
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteDocumentTextChunk(s, t, n) {
      var d, c;
      const a = await r.deleteDocumentTextChunk(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.deleteDocumentTextChunk"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Delete a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteKnowledgebaseDocument(s, t, n) {
      var d, c;
      const a = await r.deleteKnowledgebaseDocument(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.deleteKnowledgebaseDocument"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Delete a document text chunk
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteKnowledgebaseDocumentTextChunk(s, t, n, a) {
      var c, i;
      const o = await r.deleteKnowledgebaseDocumentTextChunk(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["KnowledgebaseApi.deleteKnowledgebaseDocumentTextChunk"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Get document by ID
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDocument(s, t) {
      var l, d;
      const n = await r.getDocument(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["KnowledgebaseApi.getDocument"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Get document content for preview
     * @summary Retrieve the actual file content of a document
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDocumentContent(s, t) {
      var l, d;
      const n = await r.getDocumentContent(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["KnowledgebaseApi.getDocumentContent"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Get document text chunks
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDocumentTextChunks(s, t) {
      var l, d;
      const n = await r.getDocumentTextChunks(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["KnowledgebaseApi.getDocumentTextChunks"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Get Document
     * @summary Get Document endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getKnowledgebaseDocument(s, t, n) {
      var d, c;
      const a = await r.getKnowledgebaseDocument(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.getKnowledgebaseDocument"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Get document text chunks
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getKnowledgebaseDocumentTextChunks(s, t, n) {
      var d, c;
      const a = await r.getKnowledgebaseDocumentTextChunks(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.getKnowledgebaseDocumentTextChunks"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Query Documents
     * @param {string} ownerId The ID of the owner
     * @param {SearchDocumentsFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async queryKnowledgebaseDocuments(s, t, n) {
      var d, c;
      const a = await r.queryKnowledgebaseDocuments(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.queryKnowledgebaseDocuments"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Remove a tag from a document
     * @param {string} documentId The ID of the document
     * @param {string} body Remove a tag from a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeDocumentTag(s, t, n) {
      var d, c;
      const a = await r.removeDocumentTag(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.removeDocumentTag"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Remove a tag from a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {string} body Remove a tag from a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeKnowledgebaseDocumentTag(s, t, n, a) {
      var c, i;
      const o = await r.removeKnowledgebaseDocumentTag(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["KnowledgebaseApi.removeKnowledgebaseDocumentTag"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Reset document process
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetDocumentProcess(s, t) {
      var l, d;
      const n = await r.resetDocumentProcess(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["KnowledgebaseApi.resetDocumentProcess"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Process a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetKnowledgebaseDocumentProcess(s, t, n) {
      var d, c;
      const a = await r.resetKnowledgebaseDocumentProcess(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.resetKnowledgebaseDocumentProcess"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Search documents contextually
     * @param {SearchDocumentsFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchDocuments(s, t) {
      var l, d;
      const n = await r.searchDocuments(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["KnowledgebaseApi.searchDocuments"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Update document name
     * @param {string} documentId The ID of the document
     * @param {string} body Update document name request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateDocumentName(s, t, n) {
      var d, c;
      const a = await r.updateDocumentName(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["KnowledgebaseApi.updateDocumentName"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Update a document text chunk
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {string} body Update a document text chunk request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateDocumentTextChunk(s, t, n, a) {
      var c, i;
      const o = await r.updateDocumentTextChunk(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["KnowledgebaseApi.updateDocumentTextChunk"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Update a document name
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {string} body Update a document name request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateKnowledgebaseDocumentName(s, t, n, a) {
      var c, i;
      const o = await r.updateKnowledgebaseDocumentName(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["KnowledgebaseApi.updateKnowledgebaseDocumentName"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Update a document text chunk
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {string} body Update a document text chunk request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateKnowledgebaseDocumentTextChunk(s, t, n, a, o) {
      var i, p;
      const l = await r.updateKnowledgebaseDocumentTextChunk(s, t, n, a, o), d = (e == null ? void 0 : e.serverIndex) ?? 0, c = (p = (i = y["KnowledgebaseApi.updateKnowledgebaseDocumentTextChunk"]) == null ? void 0 : i[d]) == null ? void 0 : p.url;
      return (u, b) => _(l, R, S, e)(u, c || b);
    },
    /**
     * Upload a file
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadFile(s, t) {
      var l, d;
      const n = await r.uploadFile(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["KnowledgebaseApi.uploadFile"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    }
  };
}, Bs = function(e, r, s) {
  const t = q(e);
  return {
    /**
     * Add a tag to a document
     * @param {string} documentId The ID of the document
     * @param {string} body Add a tag to a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addDocumentTag(n, a, o) {
      return t.addDocumentTag(n, a, o).then((l) => l(s, r));
    },
    /**
     * Add a tag to a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {string} body Add a tag to a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addKnowledgebaseDocumentTag(n, a, o, l) {
      return t.addKnowledgebaseDocumentTag(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Create a new document
     * @param {string} ownerId The ID of the owner
     * @param {FileStorage} fileStorage Create a new document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createKnowledgebaseDocument(n, a, o) {
      return t.createKnowledgebaseDocument(n, a, o).then((l) => l(s, r));
    },
    /**
     * Delete document by ID
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDocument(n, a) {
      return t.deleteDocument(n, a).then((o) => o(s, r));
    },
    /**
     * Delete a document text chunk
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDocumentTextChunk(n, a, o) {
      return t.deleteDocumentTextChunk(n, a, o).then((l) => l(s, r));
    },
    /**
     * Delete a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKnowledgebaseDocument(n, a, o) {
      return t.deleteKnowledgebaseDocument(n, a, o).then((l) => l(s, r));
    },
    /**
     * Delete a document text chunk
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKnowledgebaseDocumentTextChunk(n, a, o, l) {
      return t.deleteKnowledgebaseDocumentTextChunk(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Get document by ID
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocument(n, a) {
      return t.getDocument(n, a).then((o) => o(s, r));
    },
    /**
     * Get document content for preview
     * @summary Retrieve the actual file content of a document
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentContent(n, a) {
      return t.getDocumentContent(n, a).then((o) => o(s, r));
    },
    /**
     * Get document text chunks
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentTextChunks(n, a) {
      return t.getDocumentTextChunks(n, a).then((o) => o(s, r));
    },
    /**
     * Get Document
     * @summary Get Document endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKnowledgebaseDocument(n, a, o) {
      return t.getKnowledgebaseDocument(n, a, o).then((l) => l(s, r));
    },
    /**
     * Get document text chunks
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKnowledgebaseDocumentTextChunks(n, a, o) {
      return t.getKnowledgebaseDocumentTextChunks(n, a, o).then((l) => l(s, r));
    },
    /**
     * Query Documents
     * @param {string} ownerId The ID of the owner
     * @param {SearchDocumentsFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryKnowledgebaseDocuments(n, a, o) {
      return t.queryKnowledgebaseDocuments(n, a, o).then((l) => l(s, r));
    },
    /**
     * Remove a tag from a document
     * @param {string} documentId The ID of the document
     * @param {string} body Remove a tag from a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeDocumentTag(n, a, o) {
      return t.removeDocumentTag(n, a, o).then((l) => l(s, r));
    },
    /**
     * Remove a tag from a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {string} body Remove a tag from a document request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeKnowledgebaseDocumentTag(n, a, o, l) {
      return t.removeKnowledgebaseDocumentTag(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Reset document process
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetDocumentProcess(n, a) {
      return t.resetDocumentProcess(n, a).then((o) => o(s, r));
    },
    /**
     * Process a document
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetKnowledgebaseDocumentProcess(n, a, o) {
      return t.resetKnowledgebaseDocumentProcess(n, a, o).then((l) => l(s, r));
    },
    /**
     * Search documents contextually
     * @param {SearchDocumentsFilterParameter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDocuments(n, a) {
      return t.searchDocuments(n, a).then((o) => o(s, r));
    },
    /**
     * Update document name
     * @param {string} documentId The ID of the document
     * @param {string} body Update document name request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDocumentName(n, a, o) {
      return t.updateDocumentName(n, a, o).then((l) => l(s, r));
    },
    /**
     * Update a document text chunk
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {string} body Update a document text chunk request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDocumentTextChunk(n, a, o, l) {
      return t.updateDocumentTextChunk(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Update a document name
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {string} body Update a document name request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateKnowledgebaseDocumentName(n, a, o, l) {
      return t.updateKnowledgebaseDocumentName(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Update a document text chunk
     * @param {string} ownerId The ID of the owner
     * @param {string} documentId The ID of the document
     * @param {number} documentChunkIndex The index of the document chunk
     * @param {string} body Update a document text chunk request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateKnowledgebaseDocumentTextChunk(n, a, o, l, d) {
      return t.updateKnowledgebaseDocumentTextChunk(n, a, o, l, d).then((c) => c(s, r));
    },
    /**
     * Upload a file
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadFile(n, a) {
      return t.uploadFile(n, a).then((o) => o(s, r));
    }
  };
};
class Ta extends ie {
  /**
   * Add a tag to a document
   * @param {string} documentId The ID of the document
   * @param {string} body Add a tag to a document request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  addDocumentTag(r, s, t) {
    return q(this.configuration).addDocumentTag(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Add a tag to a document
   * @param {string} ownerId The ID of the owner
   * @param {string} documentId The ID of the document
   * @param {string} body Add a tag to a document request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  addKnowledgebaseDocumentTag(r, s, t, n) {
    return q(this.configuration).addKnowledgebaseDocumentTag(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Create a new document
   * @param {string} ownerId The ID of the owner
   * @param {FileStorage} fileStorage Create a new document request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  createKnowledgebaseDocument(r, s, t) {
    return q(this.configuration).createKnowledgebaseDocument(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete document by ID
   * @param {string} documentId The ID of the document
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  deleteDocument(r, s) {
    return q(this.configuration).deleteDocument(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Delete a document text chunk
   * @param {string} documentId The ID of the document
   * @param {number} documentChunkIndex The index of the document chunk
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  deleteDocumentTextChunk(r, s, t) {
    return q(this.configuration).deleteDocumentTextChunk(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete a document
   * @param {string} ownerId The ID of the owner
   * @param {string} documentId The ID of the document
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  deleteKnowledgebaseDocument(r, s, t) {
    return q(this.configuration).deleteKnowledgebaseDocument(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete a document text chunk
   * @param {string} ownerId The ID of the owner
   * @param {string} documentId The ID of the document
   * @param {number} documentChunkIndex The index of the document chunk
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  deleteKnowledgebaseDocumentTextChunk(r, s, t, n) {
    return q(this.configuration).deleteKnowledgebaseDocumentTextChunk(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Get document by ID
   * @param {string} documentId The ID of the document
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  getDocument(r, s) {
    return q(this.configuration).getDocument(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Get document content for preview
   * @summary Retrieve the actual file content of a document
   * @param {string} documentId The ID of the document
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  getDocumentContent(r, s) {
    return q(this.configuration).getDocumentContent(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Get document text chunks
   * @param {string} documentId The ID of the document
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  getDocumentTextChunks(r, s) {
    return q(this.configuration).getDocumentTextChunks(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Get Document
   * @summary Get Document endpoint
   * @param {string} ownerId The ID of the owner
   * @param {string} documentId The ID of the document
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  getKnowledgebaseDocument(r, s, t) {
    return q(this.configuration).getKnowledgebaseDocument(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get document text chunks
   * @param {string} ownerId The ID of the owner
   * @param {string} documentId The ID of the document
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  getKnowledgebaseDocumentTextChunks(r, s, t) {
    return q(this.configuration).getKnowledgebaseDocumentTextChunks(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Query Documents
   * @param {string} ownerId The ID of the owner
   * @param {SearchDocumentsFilterParameter} [filter] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  queryKnowledgebaseDocuments(r, s, t) {
    return q(this.configuration).queryKnowledgebaseDocuments(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Remove a tag from a document
   * @param {string} documentId The ID of the document
   * @param {string} body Remove a tag from a document request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  removeDocumentTag(r, s, t) {
    return q(this.configuration).removeDocumentTag(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Remove a tag from a document
   * @param {string} ownerId The ID of the owner
   * @param {string} documentId The ID of the document
   * @param {string} body Remove a tag from a document request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  removeKnowledgebaseDocumentTag(r, s, t, n) {
    return q(this.configuration).removeKnowledgebaseDocumentTag(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Reset document process
   * @param {string} documentId The ID of the document
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  resetDocumentProcess(r, s) {
    return q(this.configuration).resetDocumentProcess(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Process a document
   * @param {string} ownerId The ID of the owner
   * @param {string} documentId The ID of the document
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  resetKnowledgebaseDocumentProcess(r, s, t) {
    return q(this.configuration).resetKnowledgebaseDocumentProcess(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Search documents contextually
   * @param {SearchDocumentsFilterParameter} [filter] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  searchDocuments(r, s) {
    return q(this.configuration).searchDocuments(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Update document name
   * @param {string} documentId The ID of the document
   * @param {string} body Update document name request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  updateDocumentName(r, s, t) {
    return q(this.configuration).updateDocumentName(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Update a document text chunk
   * @param {string} documentId The ID of the document
   * @param {number} documentChunkIndex The index of the document chunk
   * @param {string} body Update a document text chunk request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  updateDocumentTextChunk(r, s, t, n) {
    return q(this.configuration).updateDocumentTextChunk(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Update a document name
   * @param {string} ownerId The ID of the owner
   * @param {string} documentId The ID of the document
   * @param {string} body Update a document name request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  updateKnowledgebaseDocumentName(r, s, t, n) {
    return q(this.configuration).updateKnowledgebaseDocumentName(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Update a document text chunk
   * @param {string} ownerId The ID of the owner
   * @param {string} documentId The ID of the document
   * @param {number} documentChunkIndex The index of the document chunk
   * @param {string} body Update a document text chunk request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  updateKnowledgebaseDocumentTextChunk(r, s, t, n, a) {
    return q(this.configuration).updateKnowledgebaseDocumentTextChunk(r, s, t, n, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Upload a file
   * @param {File} [file] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KnowledgebaseApi
   */
  uploadFile(r, s) {
    return q(this.configuration).uploadFile(r, s).then((t) => t(this.axios, this.basePath));
  }
}
const _a = function(e) {
  return {
    /**
     * Sigup endpoint
     * @param {SignupRequest} signupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signup: async (r, s = {}) => {
      h("signup", "signupRequest", r);
      const t = "/v1/signup", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "POST", ...a, ...s }, l = {}, d = {};
      l["Content-Type"] = "application/json", O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = N(r, o, e), {
        url: T(n),
        options: o
      };
    },
    /**
     * Verify email endpoint
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyEmail: async (r, s = {}) => {
      h("verifyEmail", "verifyEmailRequest", r);
      const t = "/v1/signup", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "PUT", ...a, ...s }, l = {}, d = {};
      l["Content-Type"] = "application/json", O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = N(r, o, e), {
        url: T(n),
        options: o
      };
    }
  };
}, $e = function(e) {
  const r = _a(e);
  return {
    /**
     * Sigup endpoint
     * @param {SignupRequest} signupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async signup(s, t) {
      var l, d;
      const n = await r.signup(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["RegistrationApi.signup"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Verify email endpoint
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyEmail(s, t) {
      var l, d;
      const n = await r.verifyEmail(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["RegistrationApi.verifyEmail"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    }
  };
}, Fs = function(e, r, s) {
  const t = $e(e);
  return {
    /**
     * Sigup endpoint
     * @param {SignupRequest} signupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signup(n, a) {
      return t.signup(n, a).then((o) => o(s, r));
    },
    /**
     * Verify email endpoint
     * @param {VerifyEmailRequest} verifyEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyEmail(n, a) {
      return t.verifyEmail(n, a).then((o) => o(s, r));
    }
  };
};
class va extends ie {
  /**
   * Sigup endpoint
   * @param {SignupRequest} signupRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrationApi
   */
  signup(r, s) {
    return $e(this.configuration).signup(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Verify email endpoint
   * @param {VerifyEmailRequest} verifyEmailRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrationApi
   */
  verifyEmail(r, s) {
    return $e(this.configuration).verifyEmail(r, s).then((t) => t(this.axios, this.basePath));
  }
}
const Va = function(e) {
  return {
    /**
     * Initialize app with user session data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession: async (r = {}) => {
      const s = "/v1/", t = new URL(s, E);
      let n;
      e && (n = e.baseOptions);
      const a = { method: "GET", ...n, ...r }, o = {};
      O(t, {});
      let d = n && n.headers ? n.headers : {};
      return a.headers = { ...o, ...d, ...r.headers }, {
        url: T(t),
        options: a
      };
    },
    /**
     * User login endpoint
     * @param {SignInRequest} signInRequest Signin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signIn: async (r, s = {}) => {
      h("signIn", "signInRequest", r);
      const t = "/v1/signin", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "POST", ...a, ...s }, l = {}, d = {};
      l["Content-Type"] = "application/json", O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = N(r, o, e), {
        url: T(n),
        options: o
      };
    },
    /**
     * User logout endpoint
     * @summary Logs out current logged in user session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signOut: async (r = {}) => {
      const s = "/v1/signout", t = new URL(s, E);
      let n;
      e && (n = e.baseOptions);
      const a = { method: "GET", ...n, ...r }, o = {};
      O(t, {});
      let d = n && n.headers ? n.headers : {};
      return a.headers = { ...o, ...d, ...r.headers }, {
        url: T(t),
        options: a
      };
    }
  };
}, ge = function(e) {
  const r = Va(e);
  return {
    /**
     * Initialize app with user session data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSession(s) {
      var o, l;
      const t = await r.getSession(s), n = (e == null ? void 0 : e.serverIndex) ?? 0, a = (l = (o = y["SessionApi.getSession"]) == null ? void 0 : o[n]) == null ? void 0 : l.url;
      return (d, c) => _(t, R, S, e)(d, a || c);
    },
    /**
     * User login endpoint
     * @param {SignInRequest} signInRequest Signin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async signIn(s, t) {
      var l, d;
      const n = await r.signIn(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["SessionApi.signIn"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * User logout endpoint
     * @summary Logs out current logged in user session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async signOut(s) {
      var o, l;
      const t = await r.signOut(s), n = (e == null ? void 0 : e.serverIndex) ?? 0, a = (l = (o = y["SessionApi.signOut"]) == null ? void 0 : o[n]) == null ? void 0 : l.url;
      return (d, c) => _(t, R, S, e)(d, a || c);
    }
  };
}, ks = function(e, r, s) {
  const t = ge(e);
  return {
    /**
     * Initialize app with user session data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(n) {
      return t.getSession(n).then((a) => a(s, r));
    },
    /**
     * User login endpoint
     * @param {SignInRequest} signInRequest Signin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signIn(n, a) {
      return t.signIn(n, a).then((o) => o(s, r));
    },
    /**
     * User logout endpoint
     * @summary Logs out current logged in user session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signOut(n) {
      return t.signOut(n).then((a) => a(s, r));
    }
  };
};
class Ha extends ie {
  /**
   * Initialize app with user session data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  getSession(r) {
    return ge(this.configuration).getSession(r).then((s) => s(this.axios, this.basePath));
  }
  /**
   * User login endpoint
   * @param {SignInRequest} signInRequest Signin request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  signIn(r, s) {
    return ge(this.configuration).signIn(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * User logout endpoint
   * @summary Logs out current logged in user session
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  signOut(r) {
    return ge(this.configuration).signOut(r).then((s) => s(this.axios, this.basePath));
  }
}
const ga = function(e) {
  return {
    /**
     * Tool delete endpoint
     * @summary Tool delete endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperTool: async (r, s, t = {}) => {
      h("deleteHelperTool", "ownerId", r), h("deleteHelperTool", "toolId", s);
      const n = "/helper/{owner_id}/tools/{tool_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{tool_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Delete tool
     * @summary Delete tool
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTool: async (r, s = {}) => {
      h("deleteTool", "toolId", r);
      const t = "/v1/tools/{tool_id}".replace("{tool_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "DELETE", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Tool query endpoint
     * @summary Tool query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperTool: async (r, s, t = {}) => {
      h("getHelperTool", "ownerId", r), h("getHelperTool", "toolId", s);
      const n = "/helper/{owner_id}/tools/{tool_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{tool_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Tools query endpoint
     * @summary Tools query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {GetToolsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperTools: async (r, s, t = {}) => {
      h("getHelperTools", "ownerId", r), h("getHelperTools", "filter", s);
      const n = "/helper/{owner_id}/tools".replace("{owner_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {}, c = {};
      if (s !== void 0)
        for (const [p, u] of Object.entries(s))
          c[p] = u;
      O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Get tool by ID
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTool: async (r, s = {}) => {
      h("getTool", "toolId", r);
      const t = "/v1/tools/{tool_id}".replace("{tool_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Get all tools
     * @param {GetToolsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTools: async (r, s = {}) => {
      h("getTools", "filter", r);
      const t = "/v1/tools", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {}, d = {};
      if (r !== void 0)
        for (const [i, p] of Object.entries(r))
          d[i] = p;
      O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * Tool update endpoint
     * @summary Tool update endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} toolId The ID of the tool
     * @param {UpdateHelperToolRequest} updateHelperToolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperTool: async (r, s, t, n = {}) => {
      h("updateHelperTool", "ownerId", r), h("updateHelperTool", "toolId", s), h("updateHelperTool", "updateHelperToolRequest", t);
      const a = "/helper/{owner_id}/tools/{tool_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{tool_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "PUT", ...l, ...n }, c = {}, i = {};
      c["Content-Type"] = "application/json", O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, d.data = N(t, d, e), {
        url: T(o),
        options: d
      };
    },
    /**
     * Update tool
     * @summary Update tool
     * @param {string} toolId The ID of the tool
     * @param {UpdateToolRequest} updateToolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTool: async (r, s, t = {}) => {
      h("updateTool", "toolId", r), h("updateTool", "updateToolRequest", s);
      const n = "/v1/tools/{tool_id}".replace("{tool_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PUT", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    }
  };
}, ne = function(e) {
  const r = ga(e);
  return {
    /**
     * Tool delete endpoint
     * @summary Tool delete endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHelperTool(s, t, n) {
      var d, c;
      const a = await r.deleteHelperTool(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ToolsApi.deleteHelperTool"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Delete tool
     * @summary Delete tool
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteTool(s, t) {
      var l, d;
      const n = await r.deleteTool(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["ToolsApi.deleteTool"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Tool query endpoint
     * @summary Tool query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperTool(s, t, n) {
      var d, c;
      const a = await r.getHelperTool(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ToolsApi.getHelperTool"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Tools query endpoint
     * @summary Tools query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {GetToolsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperTools(s, t, n) {
      var d, c;
      const a = await r.getHelperTools(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ToolsApi.getHelperTools"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Get tool by ID
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTool(s, t) {
      var l, d;
      const n = await r.getTool(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["ToolsApi.getTool"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Get all tools
     * @param {GetToolsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTools(s, t) {
      var l, d;
      const n = await r.getTools(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["ToolsApi.getTools"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * Tool update endpoint
     * @summary Tool update endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} toolId The ID of the tool
     * @param {UpdateHelperToolRequest} updateHelperToolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHelperTool(s, t, n, a) {
      var c, i;
      const o = await r.updateHelperTool(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["ToolsApi.updateHelperTool"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * Update tool
     * @summary Update tool
     * @param {string} toolId The ID of the tool
     * @param {UpdateToolRequest} updateToolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTool(s, t, n) {
      var d, c;
      const a = await r.updateTool(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["ToolsApi.updateTool"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    }
  };
}, Ms = function(e, r, s) {
  const t = ne(e);
  return {
    /**
     * Tool delete endpoint
     * @summary Tool delete endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHelperTool(n, a, o) {
      return t.deleteHelperTool(n, a, o).then((l) => l(s, r));
    },
    /**
     * Delete tool
     * @summary Delete tool
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTool(n, a) {
      return t.deleteTool(n, a).then((o) => o(s, r));
    },
    /**
     * Tool query endpoint
     * @summary Tool query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperTool(n, a, o) {
      return t.getHelperTool(n, a, o).then((l) => l(s, r));
    },
    /**
     * Tools query endpoint
     * @summary Tools query endpoint
     * @param {string} ownerId The ID of the owner
     * @param {GetToolsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperTools(n, a, o) {
      return t.getHelperTools(n, a, o).then((l) => l(s, r));
    },
    /**
     * Get tool by ID
     * @param {string} toolId The ID of the tool
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTool(n, a) {
      return t.getTool(n, a).then((o) => o(s, r));
    },
    /**
     * Get all tools
     * @param {GetToolsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTools(n, a) {
      return t.getTools(n, a).then((o) => o(s, r));
    },
    /**
     * Tool update endpoint
     * @summary Tool update endpoint
     * @param {string} ownerId The ID of the owner
     * @param {string} toolId The ID of the tool
     * @param {UpdateHelperToolRequest} updateHelperToolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperTool(n, a, o, l) {
      return t.updateHelperTool(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * Update tool
     * @summary Update tool
     * @param {string} toolId The ID of the tool
     * @param {UpdateToolRequest} updateToolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTool(n, a, o) {
      return t.updateTool(n, a, o).then((l) => l(s, r));
    }
  };
};
class wa extends ie {
  /**
   * Tool delete endpoint
   * @summary Tool delete endpoint
   * @param {string} ownerId The ID of the owner
   * @param {string} toolId The ID of the tool
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToolsApi
   */
  deleteHelperTool(r, s, t) {
    return ne(this.configuration).deleteHelperTool(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Delete tool
   * @summary Delete tool
   * @param {string} toolId The ID of the tool
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToolsApi
   */
  deleteTool(r, s) {
    return ne(this.configuration).deleteTool(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Tool query endpoint
   * @summary Tool query endpoint
   * @param {string} ownerId The ID of the owner
   * @param {string} toolId The ID of the tool
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToolsApi
   */
  getHelperTool(r, s, t) {
    return ne(this.configuration).getHelperTool(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Tools query endpoint
   * @summary Tools query endpoint
   * @param {string} ownerId The ID of the owner
   * @param {GetToolsFilterParameter} filter 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToolsApi
   */
  getHelperTools(r, s, t) {
    return ne(this.configuration).getHelperTools(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get tool by ID
   * @param {string} toolId The ID of the tool
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToolsApi
   */
  getTool(r, s) {
    return ne(this.configuration).getTool(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Get all tools
   * @param {GetToolsFilterParameter} filter 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToolsApi
   */
  getTools(r, s) {
    return ne(this.configuration).getTools(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * Tool update endpoint
   * @summary Tool update endpoint
   * @param {string} ownerId The ID of the owner
   * @param {string} toolId The ID of the tool
   * @param {UpdateHelperToolRequest} updateHelperToolRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToolsApi
   */
  updateHelperTool(r, s, t, n) {
    return ne(this.configuration).updateHelperTool(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * Update tool
   * @summary Update tool
   * @param {string} toolId The ID of the tool
   * @param {UpdateToolRequest} updateToolRequest 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ToolsApi
   */
  updateTool(r, s, t) {
    return ne(this.configuration).updateTool(r, s, t).then((n) => n(this.axios, this.basePath));
  }
}
const ba = function(e) {
  return {
    /**
     * 
     * @summary Get training by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} trainingId The ID of the training
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperTraining: async (r, s, t, n = {}) => {
      h("getHelperTraining", "ownerId", r), h("getHelperTraining", "trainingId", s), h("getHelperTraining", "filter", t);
      const a = "/helper/{owner_id}/trainings/{training_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{training_id}", encodeURIComponent(String(s))), o = new URL(a, E);
      let l;
      e && (l = e.baseOptions);
      const d = { method: "GET", ...l, ...n }, c = {}, i = {};
      if (t !== void 0)
        for (const [u, b] of Object.entries(t))
          i[u] = b;
      O(o, i);
      let p = l && l.headers ? l.headers : {};
      return d.headers = { ...c, ...p, ...n.headers }, {
        url: T(o),
        options: d
      };
    },
    /**
     * 
     * @summary Get trainings by owner
     * @param {string} ownerId The ID of the owner
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperTrainings: async (r, s, t = {}) => {
      h("getHelperTrainings", "ownerId", r), h("getHelperTrainings", "filter", s);
      const n = "/helper/{owner_id}/trainings".replace("{owner_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {}, c = {};
      if (s !== void 0)
        for (const [p, u] of Object.entries(s))
          c[p] = u;
      O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Get training by ID
     * @summary Retrieve training by ID
     * @param {string} trainingId The ID of the training
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTraining: async (r, s, t = {}) => {
      h("getTraining", "trainingId", r), h("getTraining", "filter", s);
      const n = "/v1/trainings/{training_id}".replace("{training_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "GET", ...o, ...t }, d = {}, c = {};
      if (s !== void 0)
        for (const [p, u] of Object.entries(s))
          c[p] = u;
      O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Get all trainings
     * @summary Retrieve all trainings
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTrainings: async (r, s = {}) => {
      h("getTrainings", "filter", r);
      const t = "/v1/trainings", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "GET", ...a, ...s }, l = {}, d = {};
      if (r !== void 0)
        for (const [i, p] of Object.entries(r))
          d[i] = p;
      O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * 
     * @summary Remove training by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeHelperTraining: async (r, s, t = {}) => {
      h("removeHelperTraining", "ownerId", r), h("removeHelperTraining", "trainingId", s);
      const n = "/helper/{owner_id}/trainings/{training_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{training_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "DELETE", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Remove training by ID
     * @summary Remove training by ID
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeTraining: async (r, s = {}) => {
      h("removeTraining", "trainingId", r);
      const t = "/v1/trainings/{training_id}".replace("{training_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "DELETE", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * 
     * @summary Update training by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperTraining: async (r, s, t = {}) => {
      h("updateHelperTraining", "ownerId", r), h("updateHelperTraining", "trainingId", s);
      const n = "/helper/{owner_id}/trainings/{training_id}".replace("{owner_id}", encodeURIComponent(String(r))).replace("{training_id}", encodeURIComponent(String(s))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "PUT", ...o, ...t }, d = {};
      O(a, {});
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, {
        url: T(a),
        options: l
      };
    },
    /**
     * Update training by ID
     * @summary Update training by ID
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTraining: async (r, s = {}) => {
      h("updateTraining", "trainingId", r);
      const t = "/v1/trainings/{training_id}".replace("{training_id}", encodeURIComponent(String(r))), n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "PUT", ...a, ...s }, l = {};
      O(n, {});
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, {
        url: T(n),
        options: o
      };
    },
    /**
     * 
     * @summary Load training
     * @param {string} ownerId The ID of the owner
     * @param {Training} training 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadHelperTraining: async (r, s, t = {}) => {
      h("uploadHelperTraining", "ownerId", r), h("uploadHelperTraining", "training", s);
      const n = "/helper/{owner_id}/trainings".replace("{owner_id}", encodeURIComponent(String(r))), a = new URL(n, E);
      let o;
      e && (o = e.baseOptions);
      const l = { method: "POST", ...o, ...t }, d = {}, c = {};
      d["Content-Type"] = "application/json", O(a, c);
      let i = o && o.headers ? o.headers : {};
      return l.headers = { ...d, ...i, ...t.headers }, l.data = N(s, l, e), {
        url: T(a),
        options: l
      };
    },
    /**
     * Upload a new training
     * @summary Upload a new training
     * @param {Training} training 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTraining: async (r, s = {}) => {
      h("uploadTraining", "training", r);
      const t = "/v1/trainings", n = new URL(t, E);
      let a;
      e && (a = e.baseOptions);
      const o = { method: "POST", ...a, ...s }, l = {}, d = {};
      l["Content-Type"] = "application/json", O(n, d);
      let c = a && a.headers ? a.headers : {};
      return o.headers = { ...l, ...c, ...s.headers }, o.data = N(r, o, e), {
        url: T(n),
        options: o
      };
    }
  };
}, ee = function(e) {
  const r = ba(e);
  return {
    /**
     * 
     * @summary Get training by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} trainingId The ID of the training
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperTraining(s, t, n, a) {
      var c, i;
      const o = await r.getHelperTraining(s, t, n, a), l = (e == null ? void 0 : e.serverIndex) ?? 0, d = (i = (c = y["TrainingsApi.getHelperTraining"]) == null ? void 0 : c[l]) == null ? void 0 : i.url;
      return (p, u) => _(o, R, S, e)(p, d || u);
    },
    /**
     * 
     * @summary Get trainings by owner
     * @param {string} ownerId The ID of the owner
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHelperTrainings(s, t, n) {
      var d, c;
      const a = await r.getHelperTrainings(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["TrainingsApi.getHelperTrainings"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Get training by ID
     * @summary Retrieve training by ID
     * @param {string} trainingId The ID of the training
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTraining(s, t, n) {
      var d, c;
      const a = await r.getTraining(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["TrainingsApi.getTraining"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Get all trainings
     * @summary Retrieve all trainings
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTrainings(s, t) {
      var l, d;
      const n = await r.getTrainings(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["TrainingsApi.getTrainings"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * 
     * @summary Remove training by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeHelperTraining(s, t, n) {
      var d, c;
      const a = await r.removeHelperTraining(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["TrainingsApi.removeHelperTraining"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Remove training by ID
     * @summary Remove training by ID
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeTraining(s, t) {
      var l, d;
      const n = await r.removeTraining(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["TrainingsApi.removeTraining"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * 
     * @summary Update training by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateHelperTraining(s, t, n) {
      var d, c;
      const a = await r.updateHelperTraining(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["TrainingsApi.updateHelperTraining"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Update training by ID
     * @summary Update training by ID
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTraining(s, t) {
      var l, d;
      const n = await r.updateTraining(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["TrainingsApi.updateTraining"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    },
    /**
     * 
     * @summary Load training
     * @param {string} ownerId The ID of the owner
     * @param {Training} training 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadHelperTraining(s, t, n) {
      var d, c;
      const a = await r.uploadHelperTraining(s, t, n), o = (e == null ? void 0 : e.serverIndex) ?? 0, l = (c = (d = y["TrainingsApi.uploadHelperTraining"]) == null ? void 0 : d[o]) == null ? void 0 : c.url;
      return (i, p) => _(a, R, S, e)(i, l || p);
    },
    /**
     * Upload a new training
     * @summary Upload a new training
     * @param {Training} training 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadTraining(s, t) {
      var l, d;
      const n = await r.uploadTraining(s, t), a = (e == null ? void 0 : e.serverIndex) ?? 0, o = (d = (l = y["TrainingsApi.uploadTraining"]) == null ? void 0 : l[a]) == null ? void 0 : d.url;
      return (c, i) => _(n, R, S, e)(c, o || i);
    }
  };
}, js = function(e, r, s) {
  const t = ee(e);
  return {
    /**
     * 
     * @summary Get training by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} trainingId The ID of the training
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperTraining(n, a, o, l) {
      return t.getHelperTraining(n, a, o, l).then((d) => d(s, r));
    },
    /**
     * 
     * @summary Get trainings by owner
     * @param {string} ownerId The ID of the owner
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHelperTrainings(n, a, o) {
      return t.getHelperTrainings(n, a, o).then((l) => l(s, r));
    },
    /**
     * Get training by ID
     * @summary Retrieve training by ID
     * @param {string} trainingId The ID of the training
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTraining(n, a, o) {
      return t.getTraining(n, a, o).then((l) => l(s, r));
    },
    /**
     * Get all trainings
     * @summary Retrieve all trainings
     * @param {GetTrainingsFilterParameter} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTrainings(n, a) {
      return t.getTrainings(n, a).then((o) => o(s, r));
    },
    /**
     * 
     * @summary Remove training by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeHelperTraining(n, a, o) {
      return t.removeHelperTraining(n, a, o).then((l) => l(s, r));
    },
    /**
     * Remove training by ID
     * @summary Remove training by ID
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeTraining(n, a) {
      return t.removeTraining(n, a).then((o) => o(s, r));
    },
    /**
     * 
     * @summary Update training by ID
     * @param {string} ownerId The ID of the owner
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateHelperTraining(n, a, o) {
      return t.updateHelperTraining(n, a, o).then((l) => l(s, r));
    },
    /**
     * Update training by ID
     * @summary Update training by ID
     * @param {string} trainingId The ID of the training
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTraining(n, a) {
      return t.updateTraining(n, a).then((o) => o(s, r));
    },
    /**
     * 
     * @summary Load training
     * @param {string} ownerId The ID of the owner
     * @param {Training} training 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadHelperTraining(n, a, o) {
      return t.uploadHelperTraining(n, a, o).then((l) => l(s, r));
    },
    /**
     * Upload a new training
     * @summary Upload a new training
     * @param {Training} training 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadTraining(n, a) {
      return t.uploadTraining(n, a).then((o) => o(s, r));
    }
  };
};
class Ia extends ie {
  /**
   * 
   * @summary Get training by ID
   * @param {string} ownerId The ID of the owner
   * @param {string} trainingId The ID of the training
   * @param {GetTrainingsFilterParameter} filter 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  getHelperTraining(r, s, t, n) {
    return ee(this.configuration).getHelperTraining(r, s, t, n).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get trainings by owner
   * @param {string} ownerId The ID of the owner
   * @param {GetTrainingsFilterParameter} filter 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  getHelperTrainings(r, s, t) {
    return ee(this.configuration).getHelperTrainings(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get training by ID
   * @summary Retrieve training by ID
   * @param {string} trainingId The ID of the training
   * @param {GetTrainingsFilterParameter} filter 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  getTraining(r, s, t) {
    return ee(this.configuration).getTraining(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get all trainings
   * @summary Retrieve all trainings
   * @param {GetTrainingsFilterParameter} filter 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  getTrainings(r, s) {
    return ee(this.configuration).getTrainings(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Remove training by ID
   * @param {string} ownerId The ID of the owner
   * @param {string} trainingId The ID of the training
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  removeHelperTraining(r, s, t) {
    return ee(this.configuration).removeHelperTraining(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Remove training by ID
   * @summary Remove training by ID
   * @param {string} trainingId The ID of the training
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  removeTraining(r, s) {
    return ee(this.configuration).removeTraining(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update training by ID
   * @param {string} ownerId The ID of the owner
   * @param {string} trainingId The ID of the training
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  updateHelperTraining(r, s, t) {
    return ee(this.configuration).updateHelperTraining(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Update training by ID
   * @summary Update training by ID
   * @param {string} trainingId The ID of the training
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  updateTraining(r, s) {
    return ee(this.configuration).updateTraining(r, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Load training
   * @param {string} ownerId The ID of the owner
   * @param {Training} training 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  uploadHelperTraining(r, s, t) {
    return ee(this.configuration).uploadHelperTraining(r, s, t).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Upload a new training
   * @summary Upload a new training
   * @param {Training} training 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrainingsApi
   */
  uploadTraining(r, s) {
    return ee(this.configuration).uploadTraining(r, s).then((t) => t(this.axios, this.basePath));
  }
}
class oe {
  constructor(r = {}) {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    te(this, "apiKey");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    te(this, "username");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    te(this, "password");
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    te(this, "accessToken");
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    te(this, "basePath");
    /**
     * override server index
     *
     * @type {number}
     * @memberof Configuration
     */
    te(this, "serverIndex");
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    te(this, "baseOptions");
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    te(this, "formDataCtor");
    this.apiKey = r.apiKey, this.username = r.username, this.password = r.password, this.accessToken = r.accessToken, this.basePath = r.basePath, this.serverIndex = r.serverIndex, this.baseOptions = r.baseOptions, this.formDataCtor = r.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(r) {
    const s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (s.test(r) || r.toLowerCase() === "application/json-patch+json");
  }
}
function U(e, r) {
  const s = "An unknown error occurred";
  return e instanceof pa && e.response && e.response.data ? e.response.data.message || r || s : e instanceof Error ? e.message || r || s : typeof e == "string" ? e : r || s;
}
const f = {
  // Blue-Gray scale
  blueGray: {
    50: "#D0E1EF",
    100: "#90BDDD",
    200: "#6C96B3",
    300: "#507087",
    400: "#364D5D",
    500: "#1D2C36",
    600: "#0A1217"
  },
  // Orange-Brown scale
  orangeBrown: {
    50: "#FCD5C3",
    100: "#FAA082",
    200: "#D27929",
    300: "#9E5A1C",
    400: "#6D3D10",
    500: "#402106",
    600: "#1E0D01"
  },
  // Teal-Green scale
  tealGreen: {
    50: "#CAF1DF",
    100: "#9DE4CA",
    200: "#72D0B5",
    300: "#4DBAA0",
    400: "#38786A",
    500: "#2C5F54",
    600: "#245349",
    700: "#123029"
  },
  // Beige-Brown scale
  beigeBrown: {
    50: "#F2EEEA",
    100: "#D5C3B2",
    200: "#AD9D8D",
    300: "#85786C",
    400: "#5F564C",
    500: "#3C352F",
    600: "#1C1814"
  },
  // Gray scale
  gray: {
    50: "#DEDEDF",
    100: "#B5B7B9",
    200: "#8F9194",
    300: "#6B6C6F",
    400: "#494A4C",
    500: "#2A2A2B",
    600: "#111112"
  },
  // Red scale
  red: {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#d32f2f",
    400: "#c62828",
    500: "#b71c1c",
    600: "#8d0e0e",
    700: "#6d0000"
  },
  // Accent colors
  accent: {
    blue: "#364D5D",
    orange: "#9E5A1C",
    teal: "#38786A",
    beige: "#AD9D8D",
    red: "#c62828",
    white: "#ffffff"
  }
}, Pa = {
  primary: {
    main: f.tealGreen[400],
    light: f.tealGreen[300],
    dark: f.tealGreen[500],
    contrastText: f.beigeBrown[50]
  },
  secondary: {
    main: f.blueGray[400],
    light: f.blueGray[300],
    dark: f.blueGray[500],
    contrastText: f.accent.white
  },
  background: {
    default: "#ffffff",
    paper: "#f5f5f5"
  },
  text: {
    primary: f.gray[600],
    secondary: f.gray[400],
    disabled: f.gray[300]
  },
  divider: f.gray[200],
  border: {
    default: "rgba(0, 0, 0, 0.23)",
    paper: f.gray[100],
    hover: f.gray[600]
  },
  error: {
    main: f.red[300],
    soft: "rgba(211, 47, 47, 0.08)"
  },
  warning: {
    main: f.orangeBrown[200],
    soft: "rgba(210, 121, 41, 0.08)"
  },
  info: {
    main: f.blueGray[200],
    soft: "rgba(108, 150, 179, 0.08)"
  },
  success: {
    main: f.tealGreen[400],
    soft: "rgba(77, 186, 160, 0.08)"
  }
}, Aa = {
  primary: {
    main: f.tealGreen[300],
    light: f.tealGreen[200],
    dark: f.tealGreen[400],
    contrastText: f.blueGray[600]
  },
  secondary: {
    main: f.blueGray[300],
    light: f.blueGray[200],
    dark: f.blueGray[400],
    contrastText: f.blueGray[600]
  },
  background: {
    default: f.blueGray[600],
    paper: f.blueGray[500]
  },
  text: {
    primary: "#ffffff",
    secondary: f.gray[100],
    disabled: f.gray[200]
  },
  divider: f.blueGray[400],
  border: {
    default: "rgba(255, 255, 255, 0.23)",
    paper: f.blueGray[400],
    hover: f.tealGreen[200]
  },
  error: {
    main: f.red[300],
    soft: "rgba(211, 47, 47, 0.2)"
  },
  warning: {
    main: f.orangeBrown[200],
    soft: "rgba(210, 121, 41, 0.2)"
  },
  info: {
    main: f.blueGray[200],
    soft: "rgba(108, 150, 179, 0.2)"
  },
  success: {
    main: f.tealGreen[300],
    soft: "rgba(77, 186, 160, 0.2)"
  }
}, Gs = {
  fontFamily: {
    primary: ["Inter", "sans-serif"].join(","),
    fallback: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", "sans-serif"].join(",")
  },
  fontSize: {
    h1: "2.5rem",
    h2: "2rem",
    h3: "1.75rem",
    h4: "1.5rem",
    h5: "1.25rem",
    h6: "1rem",
    body1: "1rem",
    body2: "0.875rem",
    button: "0.875rem",
    caption: "0.75rem"
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  lineHeight: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75
  }
}, $s = {
  unit: 8,
  borderRadius: {
    small: 8,
    medium: 12,
    large: 16
  }
}, qs = {
  light: {
    level1: "0 2px 4px rgba(0, 0, 0, 0.08)",
    level2: "0 4px 8px rgba(0, 0, 0, 0.12)",
    level3: "0 8px 16px rgba(0, 0, 0, 0.16)"
  },
  dark: {
    level1: "0 2px 4px rgba(0, 0, 0, 0.3)",
    level2: "0 4px 8px rgba(0, 0, 0, 0.4)",
    level3: "0 8px 16px rgba(0, 0, 0, 0.5)"
  }
}, Ks = (e) => e === "light" ? Pa : Aa;
var j = /* @__PURE__ */ ((e) => (e.SET_IS_INITIALIZED = "SET_IS_INITIALIZED", e.SET_IS_DARK_MODE = "SET_IS_DARK_MODE", e.SET_IS_LOADING = "SET_IS_LOADING", e.SET_ERROR = "SET_ERROR", e.CLEAR_ERROR = "CLEAR_ERROR", e.SET_DEVICE = "SET_DEVICE", e.SET_SESSION_USER = "SET_USER", e.SET_VERIFIED_USER = "SET_VERIFIED_USER", e))(j || {});
const Ca = (e) => ({
  isInitialized: !1,
  baseApiUrl: e,
  isLoading: void 0,
  isDarkMode: !1
}), Ur = le(void 0), Ua = (e, r) => {
  switch (r.type) {
    case j.SET_IS_INITIALIZED:
      return {
        ...e,
        isInitialized: r.payload,
        isLoading: void 0
      };
    case j.SET_IS_DARK_MODE:
      return {
        ...e,
        isDarkMode: r.payload
      };
    case j.SET_ERROR:
      return {
        ...e,
        error: r.payload,
        isLoading: void 0
      };
    case j.CLEAR_ERROR:
      return {
        ...e,
        error: void 0
      };
    case j.SET_IS_LOADING:
      return {
        ...e,
        isLoading: r.payload,
        error: void 0
      };
    case j.SET_SESSION_USER:
      return {
        ...e,
        sessionUser: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case j.SET_VERIFIED_USER:
      return {
        ...e,
        sessionUser: r.payload.id && e.sessionUser && e.sessionUser.id === r.payload.id ? {
          ...e.sessionUser,
          emailVerified: !0
        } : void 0,
        error: r.payload.error,
        isLoading: void 0
      };
    default:
      return e;
  }
}, Qs = ({ device: e, baseApiUrl: r, children: s }) => {
  const [t, n] = de(Ua, { ...Ca(r), device: e }), { isLoading: a, error: o, isInitialized: l, isDarkMode: d } = t, c = {
    session: new Ha(new oe({
      basePath: r,
      baseOptions: { withCredentials: !0 }
    })),
    registration: new va(new oe({
      basePath: r,
      baseOptions: { withCredentials: !0 }
    }))
  };
  ce(() => {
    !c || a || o || l || (n({
      type: j.SET_IS_LOADING,
      payload: "initializing"
    }), c.session.getSession().then((w) => {
      w.data == "" ? n({
        type: j.SET_SESSION_USER,
        payload: void 0
      }) : n({
        type: j.SET_SESSION_USER,
        payload: w.data
      });
    }).catch((w) => {
      n({
        type: j.SET_ERROR,
        payload: U(w, "Failed to fetch session")
      });
    }).finally(() => {
      n({
        type: j.SET_IS_INITIALIZED,
        payload: !0
      });
    }));
  }, [c, l, a, o]);
  const i = x(() => {
    n({
      type: j.SET_IS_DARK_MODE,
      payload: !d
    });
  }, [d, n]), p = x(async (w, A, k) => {
    if (!c)
      throw new Error("API is not initialized");
    n({
      type: j.SET_IS_LOADING,
      payload: "signing in"
    });
    try {
      const z = await c.session.signIn({
        username: w,
        password: A,
        deviceInfo: k
      });
      n({
        type: j.SET_SESSION_USER,
        payload: z.data
      });
    } catch (z) {
      n({
        type: j.SET_ERROR,
        payload: U(z, "failed to sign in")
      });
    }
  }, [c, n]), u = x(async (w, A, k, z) => {
    n({
      type: j.SET_IS_LOADING,
      payload: "signing up"
    });
    try {
      const v = await c.registration.signup({
        givenName: w,
        familyName: A,
        password: k,
        email: z,
        role: "user",
        status: "inactive"
      });
      n({
        type: j.SET_SESSION_USER,
        payload: {
          ...v.data
        }
      });
    } catch (v) {
      n({
        type: j.SET_ERROR,
        payload: U(v, "failed to sign up")
      });
    }
  }, [n]), b = x(async (w, A) => {
    if (!c)
      n({
        type: j.SET_ERROR,
        payload: "Session API is not initialized"
      });
    else {
      n({
        type: j.SET_IS_LOADING,
        payload: "verifying email"
      });
      try {
        const k = await c.registration.verifyEmail({
          email: w,
          verificationCode: A
        });
        n({
          type: j.SET_VERIFIED_USER,
          payload: {
            id: k.data.id
          }
        });
      } catch (k) {
        n({
          type: j.SET_VERIFIED_USER,
          payload: {
            error: U(k, "failed to verify email")
          }
        });
      }
    }
  }, [c, n]), H = x(async () => {
    n({
      type: j.SET_IS_LOADING,
      payload: "signing out"
    });
    try {
      await c.session.signOut(), n({
        type: j.SET_SESSION_USER
      });
    } catch (w) {
      n({
        type: j.SET_ERROR,
        payload: U(w, "failed to sign out")
      });
    } finally {
      n({
        type: j.SET_IS_LOADING,
        payload: void 0
      });
    }
  }, [n]), I = x(() => {
    n({
      type: j.CLEAR_ERROR
    });
  }, [n]), V = {
    toggleTheme: i,
    signUp: u,
    verifyEmail: b,
    signIn: p,
    signOut: H,
    clearError: I
  };
  return /* @__PURE__ */ Y(Ur.Provider, { value: { view: t, command: V }, children: s });
}, me = () => {
  const e = lr(Ur);
  if (!e)
    throw new Error("useApi must be used within an AppProvider");
  const { view: { sessionUser: r, baseApiUrl: s } } = e, t = {};
  return s && r && r.auth && r.auth.accessToken && (t.admin = new ma(new oe({
    basePath: s,
    accessToken: r.auth.accessToken,
    baseOptions: { withCredentials: !0 }
  })), t.knowledgebase = new Ta(new oe({
    basePath: s,
    accessToken: r.auth.accessToken,
    baseOptions: { withCredentials: !0 }
  })), t.helpers = new Ea(new oe({
    basePath: s,
    accessToken: r.auth.accessToken,
    baseOptions: { withCredentials: !0 }
  })), t.trainings = new Ia(new oe({
    basePath: s,
    accessToken: r.auth.accessToken,
    baseOptions: { withCredentials: !0 }
  })), t.converstions = new Sa(new oe({
    basePath: s,
    accessToken: r.auth.accessToken,
    baseOptions: { withCredentials: !0 }
  })), t.tools = new wa(new oe({
    basePath: s,
    accessToken: r.auth.accessToken,
    baseOptions: { withCredentials: !0 }
  }))), {
    sessionUser: r,
    api: t
  };
};
var W = /* @__PURE__ */ ((e) => (e.SET_IS_LOADING = "SET_IS_LOADING", e.SET_ERROR = "SET_ERROR", e.CLEAR_ERROR = "CLEAR_ERROR", e.SET_SERVICES = "SET_SERVICES", e))(W || {});
const Da = (e, r) => {
  switch (r.type) {
    case W.SET_ERROR:
      return {
        ...e,
        error: r.payload,
        isLoading: void 0
      };
    case W.CLEAR_ERROR:
      return {
        ...e,
        error: void 0
      };
    case W.SET_IS_LOADING:
      return {
        ...e,
        isLoading: r.payload,
        error: void 0
      };
    case W.SET_SERVICES:
      return {
        ...e,
        services: r.payload,
        isLoading: void 0,
        error: void 0
      };
    default:
      return e;
  }
}, xa = le(void 0), zs = ({ children: e }) => {
  const { sessionUser: r, api: s } = me(), [t, n] = de(Da, {}), { isLoading: a, error: o, services: l } = t;
  ce(() => {
    a || o || !s || r && r.role === "admin" && s.admin && (l || (n({
      type: W.SET_IS_LOADING,
      payload: "fetching services..."
    }), s.admin.getServicesStatus().then((p) => {
      n({
        type: W.SET_SERVICES,
        payload: p.data
      });
    }).catch((p) => {
      n({
        type: W.SET_ERROR,
        payload: U(p)
      });
    })));
  }, [a, s, n, r, l]);
  const d = x(async (p, u) => {
    if (!s.admin)
      return n({
        type: W.SET_ERROR,
        payload: "Admin API is not initialized"
      }), !1;
    n({
      type: W.SET_IS_LOADING,
      payload: "updating service..."
    });
    try {
      await s.admin.updateServicesStatus({ serviceName: p, desiredCount: u });
      const b = await s.admin.getServicesStatus();
      return n({
        type: W.SET_SERVICES,
        payload: b.data
      }), !0;
    } catch (b) {
      return n({
        type: W.SET_ERROR,
        payload: U(b)
      }), !1;
    }
  }, [s]), c = x(() => {
    if (!s.admin) {
      n({
        type: W.SET_ERROR,
        payload: "Admin API is not initialized"
      });
      return;
    }
    s.admin.getServicesStatus().then((p) => {
      n({
        type: W.SET_SERVICES,
        payload: p.data
      });
    }).catch((p) => {
      n({
        type: W.SET_ERROR,
        payload: U(p)
      });
    });
  }, [s, n]), i = {
    updateService: d,
    refreshServiceStatus: c
  };
  return /* @__PURE__ */ Y(xa.Provider, { value: { view: t, command: i }, children: e });
};
var K = /* @__PURE__ */ ((e) => (e.SET_IS_LOADING = "SET_IS_LOADING", e.SET_ERROR = "SET_ERROR", e.CLEAR_ERROR = "CLEAR_ERROR", e.SET_USERS = "SET_USERS", e.SET_CURRENT_USER = "SET_CURRENT_USER", e))(K || {});
const La = (e, r) => {
  switch (r.type) {
    case K.SET_ERROR:
      return {
        ...e,
        error: r.payload,
        isLoading: void 0
      };
    case K.CLEAR_ERROR:
      return {
        ...e,
        error: void 0,
        isLoading: void 0
      };
    case K.SET_IS_LOADING:
      return {
        ...e,
        isLoading: r.payload,
        error: void 0
      };
    case K.SET_USERS:
      return {
        ...e,
        users: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case K.SET_CURRENT_USER:
      return {
        ...e,
        currentUser: r.payload,
        isLoading: void 0,
        error: void 0
      };
    default:
      return e;
  }
}, Na = le(void 0), Js = ({ children: e, userId: r }) => {
  const { sessionUser: s, api: t } = me(), [n, a] = de(La, {}), { isLoading: o, error: l, users: d, currentUser: c } = n;
  ce(() => {
    !t.admin || !s || o || l || s.role === "admin" && (r ? (!c || c.id !== r) && (a({
      type: K.SET_IS_LOADING,
      payload: "fetching user..."
    }), t.admin.getUser(r).then((H) => {
      a({
        type: K.SET_CURRENT_USER,
        payload: H.data
      });
    }).catch((H) => {
      a({
        type: K.SET_ERROR,
        payload: U(H)
      });
    })) : (d || (a({
      type: K.SET_IS_LOADING,
      payload: "fetching users..."
    }), t.admin.getUsers().then((H) => {
      a({
        type: K.SET_USERS,
        payload: H.data
      });
    }).catch((H) => {
      a({
        type: K.SET_ERROR,
        payload: U(H)
      });
    })), c && a({
      type: K.SET_CURRENT_USER
    })));
  }, [o, t.admin, a, r]);
  const i = x(async (H) => {
    if (!t.admin)
      return a({
        type: K.SET_ERROR,
        payload: "Users API is not initialized"
      }), !1;
    a({
      type: K.SET_IS_LOADING,
      payload: "deleting user..."
    });
    try {
      await t.admin.deleteUser(H);
      const I = await t.admin.getUsers();
      return a({
        type: K.SET_USERS,
        payload: I.data
      }), !0;
    } catch (I) {
      return a({
        type: K.SET_ERROR,
        payload: U(I)
      }), !1;
    }
  }, [t.admin, a]), p = x(async (H, I) => {
    if (!t.admin)
      a({
        type: K.SET_ERROR,
        payload: "Users API is not initialized"
      });
    else {
      a({
        type: K.SET_IS_LOADING,
        payload: "updating user..."
      });
      try {
        await t.admin.updateUser(H, I);
        const V = await t.admin.getUsers();
        a({
          type: K.SET_USERS,
          payload: V.data
        });
      } catch (V) {
        a({
          type: K.SET_ERROR,
          payload: U(V)
        });
      }
    }
  }, [t.admin, a]), u = x(() => {
    a({
      type: K.CLEAR_ERROR
    });
  }, [a]), b = {
    deleteUser: i,
    updateUser: p,
    clearError: u
  };
  return /* @__PURE__ */ Y(Na.Provider, { value: { view: n, command: b }, children: e });
};
var P = /* @__PURE__ */ ((e) => (e.SET_IS_LOADING = "SET_IS_LOADING", e.SET_ERROR = "SET_ERROR", e.CLEAR_ERROR = "CLEAR_ERROR", e.SET_CONVERSATIONS = "SET_CONVERSATIONS", e.SET_CURRENT_CONVERSATION = "SET_CURRENT_CONVERSATION", e.SET_CURRENT_THREAD = "SET_CURRENT_THREAD", e.SET_AVAILABLE_HELPERS = "SET_AVAILABLE_HELPERS", e.SET_MESSAGES = "SET_MESSAGES", e.APPEND_MESSAGES = "APPEND_MESSAGES", e.REFRESH_MESSAGE = "REFRESH_MESSAGE", e))(P || {});
const fa = (e, r) => {
  switch (r.type) {
    case P.SET_ERROR:
      return {
        ...e,
        error: r.payload,
        isLoading: void 0
      };
    case P.CLEAR_ERROR:
      return {
        ...e,
        error: void 0
      };
    case P.SET_IS_LOADING:
      return {
        ...e,
        isLoading: r.payload,
        error: void 0
      };
    case P.SET_CONVERSATIONS:
      return {
        ...e,
        conversations: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case P.SET_CURRENT_CONVERSATION:
      return {
        ...e,
        currentConversation: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case P.SET_CURRENT_THREAD:
      return {
        ...e,
        currentConversation: e.currentConversation ? {
          ...e.currentConversation,
          threads: e.currentConversation.threads.some((s) => s.id === r.payload.id) ? e.currentConversation.threads : [...e.currentConversation.threads, {
            id: r.payload.id,
            conversation_id: r.payload.conversation_id,
            topic: r.payload.messages[0].body,
            created_at: r.payload.created_at,
            updated_at: r.payload.updated_at
          }],
          currentThread: r.payload
        } : void 0,
        isLoading: void 0,
        error: void 0
      };
    case P.SET_AVAILABLE_HELPERS:
      return {
        ...e,
        availableHelpers: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case P.SET_MESSAGES:
      return {
        ...e,
        currentConversation: e.currentConversation ? {
          ...e.currentConversation,
          currentThread: {
            ...e.currentConversation.currentThread,
            messages: r.payload,
            context_usage: r.payload[r.payload.length - 1].context_usage ?? e.currentConversation.currentThread.context_usage
          }
        } : void 0,
        isLoading: void 0,
        error: void 0
      };
    case P.REFRESH_MESSAGE:
      return {
        ...e,
        currentConversation: e.currentConversation ? {
          ...e.currentConversation,
          currentThread: {
            ...e.currentConversation.currentThread,
            messages: e.currentConversation.currentThread.messages.map((s) => s.id === r.payload.id ? r.payload : s),
            context_usage: r.payload.context_usage ?? e.currentConversation.currentThread.context_usage
          }
        } : void 0,
        isLoading: void 0,
        error: void 0
      };
    case P.APPEND_MESSAGES:
      return {
        ...e,
        currentConversation: e.currentConversation ? {
          ...e.currentConversation,
          currentThread: {
            ...e.currentConversation.currentThread,
            messages: [...e.currentConversation.currentThread.messages, ...r.payload],
            context_usage: r.payload[r.payload.length - 1].context_usage ?? e.currentConversation.currentThread.context_usage
          }
        } : void 0,
        isLoading: void 0,
        error: void 0
      };
    default:
      return e;
  }
}, Ba = le(void 0), Ws = ({ conversationId: e, children: r }) => {
  const { sessionUser: s, api: t } = me(), [n, a] = de(fa, {}), {
    isLoading: o,
    error: l,
    conversations: d,
    currentConversation: c,
    availableHelpers: i
  } = n;
  ce(() => {
    o || l || (!i && t.helpers && (a({
      type: P.SET_IS_LOADING,
      payload: "fetching available helpers..."
    }), t.helpers.getHelpers().then((v) => {
      a({
        type: P.SET_AVAILABLE_HELPERS,
        payload: v.data
      });
    }).catch((v) => {
      a({
        type: P.SET_ERROR,
        payload: U(v)
      });
    })), e ? (!c || c.id !== e) && t.converstions && t.helpers && (a({
      type: P.SET_IS_LOADING,
      payload: "fetching conversation..."
    }), t.converstions.getConversation(e).then((v) => {
      a({
        type: P.SET_CURRENT_CONVERSATION,
        payload: v.data
      });
    }).catch((v) => {
      a({
        type: P.SET_ERROR,
        payload: U(v)
      });
    }), a({
      type: P.SET_IS_LOADING,
      payload: "fetching available helpers..."
    }), t.helpers.getHelpers().then((v) => {
      a({
        type: P.SET_AVAILABLE_HELPERS,
        payload: v.data
      });
    }).catch((v) => {
      a({
        type: P.SET_ERROR,
        payload: U(v)
      });
    })) : (!d && t.converstions && (a({
      type: P.SET_IS_LOADING,
      payload: "fetching conversations..."
    }), t.converstions.getConversations().then((v) => {
      a({
        type: P.SET_CONVERSATIONS,
        payload: v.data
      });
    }).catch((v) => {
      a({
        type: P.SET_ERROR,
        payload: U(v)
      });
    })), c && a({
      type: P.SET_CURRENT_CONVERSATION
    })));
  }, [o, t, a, s, e, c, d]);
  const p = x(async (v, D) => {
    if (!v || !D)
      return a({
        type: P.SET_ERROR,
        payload: "Participant ID and topic are required"
      }), null;
    if (!t.converstions)
      return a({
        type: P.SET_ERROR,
        payload: "Conversation API is not initialized"
      }), null;
    try {
      a({
        type: P.SET_IS_LOADING,
        payload: "starting new conversation..."
      });
      const C = await t.converstions.createConversation({ participant_id: v, topic: D }), M = await t.converstions.getConversation(C.data.id);
      return a({
        type: P.SET_CURRENT_CONVERSATION,
        payload: M.data
      }), C.data.id;
    } catch (C) {
      return a({
        type: P.SET_ERROR,
        payload: U(C)
      }), null;
    }
  }, [t, a]), u = x(async (v) => {
    if (a({
      type: P.SET_IS_LOADING,
      payload: "deleting conversation..."
    }), !t.converstions)
      return a({
        type: P.SET_ERROR,
        payload: "Conversation API is not initialized"
      }), !1;
    try {
      await t.converstions.deleteConversation(v);
      const D = await t.converstions.getConversations();
      return a({
        type: P.SET_CONVERSATIONS,
        payload: D.data
      }), !0;
    } catch (D) {
      return a({
        type: P.SET_ERROR,
        payload: U(D)
      }), !1;
    }
  }, [t]), b = x(async (v, D) => {
    if (!t.converstions)
      return a({
        type: P.SET_ERROR,
        payload: "Conversation API is not initialized"
      }), null;
    try {
      return a({
        type: P.SET_IS_LOADING,
        payload: "creating new thread..."
      }), (await t.converstions.createThread(v, D)).data;
    } catch (C) {
      return a({
        type: P.SET_ERROR,
        payload: U(C)
      }), null;
    }
  }, [t, a]), H = x(async (v) => {
    if (!t.converstions)
      return a({
        type: P.SET_ERROR,
        payload: "Conversation API is not initialized"
      }), !1;
    if (!c || !c.currentThread)
      throw new Error("Current conversation is not initialized");
    const { id: D } = c, { id: C } = c.currentThread;
    try {
      a({
        type: P.SET_IS_LOADING,
        payload: "submitting message..."
      });
      const M = await t.converstions.createMessage(
        D,
        C,
        v
      );
      if (M.data.thread_id !== C) {
        const Re = await t.converstions.getThread(D, M.data.thread_id);
        a({
          type: P.SET_CURRENT_THREAD,
          payload: Re.data
        });
      } else {
        const Re = await t.converstions.getMessage(
          D,
          C,
          M.data.message_id
        );
        a({
          type: P.APPEND_MESSAGES,
          payload: [Re.data]
        });
      }
      return !0;
    } catch (M) {
      return a({
        type: P.SET_ERROR,
        payload: U(M)
      }), !1;
    }
  }, [t, a, c]), I = x(async (v, D, C) => {
    if (!t.converstions) {
      a({
        type: P.SET_ERROR,
        payload: "Conversation API is not initialized"
      });
      return;
    }
    try {
      a({
        type: P.SET_IS_LOADING,
        payload: "refreshing message..."
      });
      const M = await t.converstions.getMessage(v, D, C);
      a({
        type: P.REFRESH_MESSAGE,
        payload: M.data
      });
    } catch (M) {
      throw a({
        type: P.SET_ERROR,
        payload: U(M)
      }), M;
    }
  }, [t, a]), V = x(async (v, D) => {
    if (!t.converstions) {
      a({
        type: P.SET_ERROR,
        payload: "Conversation API is not initialized"
      });
      return;
    }
    try {
      a({
        type: P.SET_IS_LOADING,
        payload: "getting thread messages..."
      });
      const C = await t.converstions.getMessages(v, D);
      a({
        type: P.SET_MESSAGES,
        payload: C.data
      });
    } catch (C) {
      throw a({
        type: P.SET_ERROR,
        payload: U(C)
      }), C;
    }
  }, [t, a]), w = x(async (v, D, C) => {
    if (!t.converstions) {
      a({
        type: P.SET_ERROR,
        payload: "Conversation API is not initialized"
      });
      return;
    }
    try {
      a({
        type: P.SET_IS_LOADING,
        payload: "getting responses..."
      });
      const M = await t.converstions.getMessageResponses(
        v,
        D,
        C
      );
      a({
        type: P.APPEND_MESSAGES,
        payload: M.data
      });
    } catch (M) {
      throw a({
        type: P.SET_ERROR,
        payload: U(M)
      }), M;
    }
  }, [t, a]), A = x(() => {
    a({
      type: P.CLEAR_ERROR
    });
  }, [a]), k = x(async (v) => {
    var D;
    if (!t.converstions) {
      a({
        type: P.SET_ERROR,
        payload: "Conversation API is not initialized"
      });
      return;
    }
    if (!(!c || v === ((D = c == null ? void 0 : c.currentThread) == null ? void 0 : D.id)))
      try {
        a({
          type: P.SET_IS_LOADING,
          payload: "selecting thread..."
        });
        const C = await t.converstions.getThread(c.id, v);
        a({
          type: P.SET_CURRENT_THREAD,
          payload: C.data
        });
      } catch (C) {
        throw a({
          type: P.SET_ERROR,
          payload: U(C)
        }), C;
      }
  }, [a, t, c]), z = {
    startConversation: p,
    deleteConversation: u,
    createThread: b,
    submitMessage: H,
    refreshMessage: I,
    getResponses: w,
    getThreadMessages: V,
    selectThread: k,
    clearError: A
  };
  return /* @__PURE__ */ Y(Ba.Provider, { value: { view: n, command: z }, children: r });
};
var F = /* @__PURE__ */ ((e) => (e.SET_IS_LOADING = "SET_IS_LOADING", e.SET_ERROR = "SET_ERROR", e.CLEAR_ERROR = "CLEAR_ERROR", e.SET_DOCUMENTS = "SET_DOCUMENTS", e.SET_CURRENT_DOCUMENT = "SET_CURRENT_DOCUMENT", e.DOCUMENT_CREATED = "DOCUMENT_CREATED", e.DOCUMENT_DELETED = "DOCUMENT_DELETED", e.SET_UPLOADS = "SET_UPLOADS", e.FILE_UPLOADED = "FILE_UPLOADED", e.UPLOAD_REMOVED = "UPLOAD_REMOVED", e.FILE_UPDATED = "FILE_UPDATED", e))(F || {});
const Fa = (e, r) => {
  var s, t, n, a;
  switch (r.type) {
    case F.SET_ERROR:
      return {
        ...e,
        error: r.payload,
        isLoading: void 0
      };
    case F.CLEAR_ERROR:
      return {
        ...e,
        error: void 0,
        isLoading: void 0
      };
    case F.SET_IS_LOADING:
      return {
        ...e,
        isLoading: r.payload,
        error: void 0
      };
    // Document actions
    case F.SET_DOCUMENTS:
      return {
        ...e,
        documents: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case F.SET_CURRENT_DOCUMENT:
      return {
        ...e,
        currentDocument: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case F.DOCUMENT_CREATED:
      return {
        ...e,
        documents: e.documents ? [...e.documents, r.payload] : [r.payload],
        isLoading: void 0,
        error: void 0
      };
    case F.DOCUMENT_DELETED:
      return {
        ...e,
        // Remove the deleted document from the list if it exists
        documents: (s = e.documents) == null ? void 0 : s.filter((o) => o.id !== r.payload),
        // Clear current document if it's the one being deleting
        currentDocument: ((t = e.currentDocument) == null ? void 0 : t.id) === r.payload ? void 0 : e.currentDocument,
        isLoading: void 0,
        error: void 0
      };
    case F.FILE_UPDATED:
      return {
        ...e,
        documents: (n = e.documents) == null ? void 0 : n.map(
          (o) => o.id === r.payload.id ? { ...o, file_name: r.payload.file_name } : o
        ),
        currentDocument: ((a = e.currentDocument) == null ? void 0 : a.id) === r.payload.id ? { ...e.currentDocument, file_name: r.payload.file_name } : e.currentDocument,
        isLoading: void 0,
        error: void 0
      };
    default:
      return e;
  }
}, Dr = le(void 0), Zs = ({ children: e, documentId: r }) => {
  const { sessionUser: s, api: t } = me(), [n, a] = de(Fa, {}), {
    isLoading: o,
    error: l,
    documents: d,
    currentDocument: c
  } = n;
  ce(() => {
    o || l || !s || (r ? (!c || c.id !== r) && t.knowledgebase && (a({
      type: F.SET_IS_LOADING,
      payload: "loading document..."
    }), t.knowledgebase.getDocument(r).then((w) => {
      a({
        type: F.SET_CURRENT_DOCUMENT,
        payload: w.data
      });
    }).catch((w) => {
      a({
        type: F.SET_ERROR,
        payload: U(w, "Failed to load document")
      });
    })) : !d && t.knowledgebase && (a({
      type: F.SET_IS_LOADING,
      payload: "loading documents..."
    }), t.knowledgebase.searchDocuments({}).then((w) => {
      a({
        type: F.SET_DOCUMENTS,
        payload: w.data
      });
    }).catch((w) => {
      a({
        type: F.SET_ERROR,
        payload: U(w, "Failed to search documents")
      });
    }), c && a({
      type: F.SET_CURRENT_DOCUMENT
    })));
  }, [t, o, s, a, r, d]);
  const i = x(async (w) => {
    if (!t.knowledgebase)
      return a({
        type: F.SET_ERROR,
        payload: "Knowledgebase API is not initialized"
      }), !1;
    try {
      a({
        type: F.SET_IS_LOADING,
        payload: "creating document..."
      });
      const A = await t.knowledgebase.uploadFile(w), k = await t.knowledgebase.getDocument(A.data.id);
      return a({
        type: F.DOCUMENT_CREATED,
        payload: k.data
      }), !0;
    } catch (A) {
      return a({
        type: F.SET_ERROR,
        payload: U(A, "Failed to create document")
      }), !1;
    }
  }, [t, a]), p = x(async (w) => {
    if (!t.knowledgebase)
      return a({
        type: F.SET_ERROR,
        payload: "Knowledgebase API is not initialized"
      }), !1;
    try {
      return a({
        type: F.SET_IS_LOADING,
        payload: "deleting document..."
      }), await t.knowledgebase.deleteDocument(w), a({
        type: F.DOCUMENT_DELETED,
        payload: w
      }), !0;
    } catch (A) {
      return a({
        type: F.SET_ERROR,
        payload: U(A, "Failed to delete document")
      }), !1;
    }
  }, [t, a]), u = x(async (w) => {
    if (!t.knowledgebase) {
      a({
        type: F.SET_ERROR,
        payload: "Knowledgebase API is not initialized"
      });
      return;
    }
    try {
      a({
        type: F.SET_IS_LOADING,
        payload: "searching documents..."
      });
      const A = await t.knowledgebase.searchDocuments(w);
      a({
        type: F.SET_DOCUMENTS,
        payload: A.data
      });
    } catch (A) {
      a({
        type: F.SET_ERROR,
        payload: U(A, "Failed to search documents")
      });
    }
  }, [t, a]), b = x(async (w) => {
    if (!t.knowledgebase) {
      a({
        type: F.SET_ERROR,
        payload: "Knowledgebase API is not initialized"
      });
      return;
    }
    try {
      return (await t.knowledgebase.getDocumentContent(w, {
        responseType: "blob"
      })).data;
    } catch (A) {
      throw a({
        type: F.SET_ERROR,
        payload: U(A, "Failed to get document content")
      }), A;
    }
  }, [t, a]), H = x(async () => {
    if (!t.knowledgebase) {
      a({
        type: F.SET_ERROR,
        payload: "Knowledgebase API is not initialized"
      });
      return;
    }
    try {
      a({
        type: F.SET_IS_LOADING,
        payload: "refreshing documents..."
      });
      const w = await t.knowledgebase.searchDocuments({});
      a({
        type: F.SET_DOCUMENTS,
        payload: w.data
      });
    } catch (w) {
      a({
        type: F.SET_ERROR,
        payload: U(w, "Failed to refresh documents")
      });
    }
  }, [t, a]), I = x(() => {
    a({
      type: F.CLEAR_ERROR
    });
  }, [a]), V = {
    createDocument: i,
    deleteDocument: p,
    searchDocuments: u,
    refreshDocuments: H,
    getContent: b,
    clearError: I
  };
  return /* @__PURE__ */ Y(Dr.Provider, { value: { view: n, command: V }, children: e });
}, Xs = () => {
  const e = lr(Dr);
  if (!e)
    throw new Error("DocumentsContext not found");
  return e;
};
var g = /* @__PURE__ */ ((e) => (e.SET_IS_LOADING = "SET_IS_LOADING", e.SET_ERROR = "SET_ERROR", e.CLEAR_ERROR = "CLEAR_ERROR", e.SET_HELPERS = "SET_HELPERS", e.SET_CURRENT_HELPER = "SET_CURRENT_HELPER", e.RESET_CURRENT_HELPER = "RESET_CURRENT_HELPER", e.HELPER_CREATED = "HELPER_CREATED", e.HELPER_UPDATED = "HELPER_UPDATED", e.HELPER_DELETED = "HELPER_DELETED", e.SET_TRAININGS = "SET_TRAININGS", e.HELPER_INSTRUCTION_CREATED = "HELPER_INSTRUCTION_CREATED", e.HELPER_INSTRUCTION_DELETED = "HELPER_INSTRUCTION_DELETED", e.HELPER_INSTRUCTION_UPDATED = "HELPER_INSTRUCTION_UPDATED", e))(g || {});
const ka = (e, r) => {
  var s, t, n, a;
  switch (r.type) {
    case g.SET_IS_LOADING:
      return {
        ...e,
        isLoading: r.payload,
        error: void 0
      };
    case g.SET_ERROR:
      return {
        ...e,
        error: r.payload,
        isLoading: void 0
      };
    case g.CLEAR_ERROR:
      return {
        ...e,
        error: void 0,
        isLoading: void 0
      };
    case g.SET_HELPERS:
      return {
        ...e,
        helpers: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.SET_CURRENT_HELPER:
      return {
        ...e,
        currentHelper: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.RESET_CURRENT_HELPER:
      return {
        ...e,
        currentHelper: void 0,
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_CREATED:
      return {
        ...e,
        helpers: [...e.helpers || [], r.payload],
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_UPDATED:
      return {
        ...e,
        currentHelper: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_DELETED:
      return {
        ...e,
        helpers: (s = e.helpers) == null ? void 0 : s.filter((o) => o.id !== r.payload),
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_INSTRUCTION_CREATED:
      return {
        ...e,
        currentHelper: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_INSTRUCTION_DELETED:
      return {
        ...e,
        currentHelper: ((t = e.currentHelper) == null ? void 0 : t.id) === r.payload.helperId ? {
          ...e.currentHelper,
          instructions: e.currentHelper.instructions.filter((o) => o.id !== r.payload.instructionId)
        } : e.currentHelper
      };
    case g.HELPER_INSTRUCTION_UPDATED:
      return {
        ...e,
        currentHelper: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.SET_HELPERS:
      return {
        ...e,
        helpers: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.SET_CURRENT_HELPER:
      return {
        ...e,
        currentHelper: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.RESET_CURRENT_HELPER:
      return {
        ...e,
        currentHelper: void 0,
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_CREATED:
      return {
        ...e,
        helpers: [...e.helpers || [], r.payload],
        currentHelper: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_UPDATED:
      return {
        ...e,
        currentHelper: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_DELETED:
      return {
        ...e,
        helpers: (n = e.helpers) == null ? void 0 : n.filter((o) => o.id !== r.payload),
        currentHelper: ((a = e.currentHelper) == null ? void 0 : a.id) === r.payload ? void 0 : e.currentHelper,
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_INSTRUCTION_CREATED:
      return {
        ...e,
        currentHelper: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_INSTRUCTION_DELETED:
      return {
        ...e,
        currentHelper: e.currentHelper && e.currentHelper.id === r.payload.helperId ? {
          ...e.currentHelper,
          instructions: e.currentHelper.instructions.filter((o) => o.id !== r.payload.instructionId)
        } : e.currentHelper,
        isLoading: void 0,
        error: void 0
      };
    case g.HELPER_INSTRUCTION_UPDATED:
      return {
        ...e,
        currentHelper: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case g.SET_TRAININGS:
      return {
        ...e,
        trainings: r.payload,
        isLoading: void 0,
        error: void 0
      };
    default:
      return e;
  }
}, Ma = le(void 0), Ys = ({ children: e, helperId: r }) => {
  const { sessionUser: s, api: t } = me(), [n, a] = de(ka, {}), {
    isLoading: o,
    error: l,
    trainings: d,
    helpers: c,
    currentHelper: i
  } = n;
  ce(() => {
    o || l || !t || !s || (r ? (!i || i.id !== r) && t.helpers && (a({
      type: g.SET_IS_LOADING,
      payload: "Loading helper..."
    }), t.helpers.getHelper(r).then((v) => {
      a({
        type: g.SET_CURRENT_HELPER,
        payload: v.data
      });
    }).catch((v) => {
      a({
        type: g.SET_ERROR,
        payload: U(v)
      });
    })) : (!d && t.trainings && (a({
      type: g.SET_IS_LOADING,
      payload: "Loading trainings..."
    }), t.trainings.getTrainings({ status: "loaded" }).then((v) => {
      a({
        type: g.SET_TRAININGS,
        payload: v.data
      });
    }).catch((v) => {
      a({
        type: g.SET_ERROR,
        payload: U(v)
      });
    })), !c && t.helpers && (a({
      type: g.SET_IS_LOADING,
      payload: "Loading helpers..."
    }), t.helpers.getHelpers().then((v) => {
      a({
        type: g.SET_HELPERS,
        payload: v.data
      });
    }).catch((v) => {
      a({
        type: g.SET_ERROR,
        payload: U(v)
      });
    })), i && a({
      type: g.SET_CURRENT_HELPER
    })));
  }, [o, s, t, r]);
  const p = x(async (v) => {
    if (!t.helpers) {
      a({
        type: g.SET_ERROR,
        payload: "Helpers API is not initialized"
      });
      return;
    }
    try {
      a({
        type: g.SET_IS_LOADING,
        payload: "Creating helper..."
      });
      const D = await t.helpers.createHelper(v), C = await t.helpers.getHelper(D.data.id);
      return a({
        type: g.HELPER_CREATED,
        payload: C.data
      }), D.data.id;
    } catch (D) {
      a({
        type: g.SET_ERROR,
        payload: U(D, "Failed to create helper")
      });
      return;
    } finally {
      a({
        type: g.SET_IS_LOADING,
        payload: void 0
      });
    }
  }, [t, a]), u = x(async (v, D) => {
    if (!t.helpers)
      return a({
        type: g.SET_ERROR,
        payload: "Helpers API is not initialized"
      }), !1;
    try {
      a({
        type: g.SET_IS_LOADING,
        payload: "Updating helper..."
      }), await t.helpers.updateHelper(v, D);
      const C = await t.helpers.getHelper(v);
      return a({
        type: g.HELPER_UPDATED,
        payload: C.data
      }), !0;
    } catch (C) {
      return a({
        type: g.SET_ERROR,
        payload: U(C)
      }), !1;
    } finally {
      a({
        type: g.SET_IS_LOADING,
        payload: void 0
      });
    }
  }, [t, a]), b = x(async (v) => {
    if (!t.helpers)
      return a({
        type: g.SET_ERROR,
        payload: "Helpers API is not initialized"
      }), !1;
    try {
      return a({
        type: g.SET_IS_LOADING,
        payload: "Deleting helper..."
      }), await t.helpers.deleteHelper(v), a({
        type: g.HELPER_DELETED,
        payload: v
      }), !0;
    } catch (D) {
      return a({
        type: g.SET_ERROR,
        payload: U(D)
      }), !1;
    } finally {
      a({
        type: g.SET_IS_LOADING,
        payload: void 0
      });
    }
  }, [t, a]), H = x(async (v, D) => {
    if (!t.helpers)
      return a({
        type: g.SET_ERROR,
        payload: "Helpers API is not initialized"
      }), !1;
    if (!i || i.id !== v)
      throw new Error("Current helper is not initialized");
    try {
      a({
        type: g.SET_IS_LOADING,
        payload: "Creating helper instruction..."
      }), await t.helpers.createHelperInstruction(v, D);
      const C = await t.helpers.getHelper(v);
      return a({
        type: g.HELPER_INSTRUCTION_CREATED,
        payload: C.data
      }), !0;
    } catch (C) {
      return a({
        type: g.SET_ERROR,
        payload: U(C, "Failed to create helper instruction")
      }), !1;
    } finally {
      a({
        type: g.SET_IS_LOADING,
        payload: void 0
      });
    }
  }, [t, a, i]), I = x(async (v, D) => {
    if (!t.helpers)
      return a({
        type: g.SET_ERROR,
        payload: "Helpers API is not initialized"
      }), !1;
    try {
      return a({
        type: g.SET_IS_LOADING,
        payload: "Deleting helper instruction..."
      }), await t.helpers.deleteHelperInstruction(v, D), a({
        type: g.HELPER_INSTRUCTION_DELETED,
        payload: {
          helperId: v,
          instructionId: D
        }
      }), !0;
    } catch (C) {
      return a({
        type: g.SET_ERROR,
        payload: U(C)
      }), !1;
    } finally {
      a({
        type: g.SET_IS_LOADING,
        payload: void 0
      });
    }
  }, [t, a]), V = x(async (v, D, C) => {
    if (!t.helpers)
      return a({
        type: g.SET_ERROR,
        payload: "Helpers API is not initialized"
      }), !1;
    try {
      a({
        type: g.SET_IS_LOADING,
        payload: "Updating helper instruction..."
      }), await t.helpers.updateHelperInstruction(v, D, C);
      const M = await t.helpers.getHelper(v);
      return a({
        type: g.HELPER_INSTRUCTION_UPDATED,
        payload: M.data
      }), !0;
    } catch (M) {
      return a({
        type: g.SET_ERROR,
        payload: U(M)
      }), !1;
    } finally {
      a({
        type: g.SET_IS_LOADING,
        payload: void 0
      });
    }
  }, [t, a]), w = x(async (v, D) => {
    if (!t.helpers)
      return a({
        type: g.SET_ERROR,
        payload: "Helpers API is not initialized"
      }), !1;
    try {
      if (a({
        type: g.SET_IS_LOADING,
        payload: "Adding skills..."
      }), (await t.helpers.createHelperSkills(v, D)).status !== 200)
        throw new Error("Failed to add skills");
      const M = await t.helpers.getHelper(v);
      return a({
        type: g.HELPER_UPDATED,
        payload: M.data
      }), !0;
    } catch (C) {
      return a({
        type: g.SET_ERROR,
        payload: U(C)
      }), !1;
    } finally {
      a({
        type: g.SET_IS_LOADING,
        payload: void 0
      });
    }
  }, [t, a]), A = x(async (v, D) => {
    if (!t.helpers)
      return a({
        type: g.SET_ERROR,
        payload: "Helpers API is not initialized"
      }), !1;
    try {
      if (a({
        type: g.SET_IS_LOADING,
        payload: "Removing skills..."
      }), (await t.helpers.deleteHelperSkills(v, D)).status !== 200)
        throw new Error("Failed to remove skills");
      const M = await t.helpers.getHelper(v);
      return a({
        type: g.HELPER_UPDATED,
        payload: M.data
      }), !0;
    } catch (C) {
      return a({
        type: g.SET_ERROR,
        payload: U(C)
      }), !1;
    } finally {
      a({
        type: g.SET_IS_LOADING,
        payload: void 0
      });
    }
  }, [t, a]), k = x(() => {
    a({
      type: g.CLEAR_ERROR
    });
  }, [a]), z = {
    createHelper: p,
    updateHelper: u,
    deleteHelper: b,
    createInstruction: H,
    updateInstruction: V,
    deleteInstruction: I,
    addSkills: w,
    removeSkills: A,
    clearError: k
  };
  return /* @__PURE__ */ Y(Ma.Provider, { value: { view: n, command: z }, children: e });
};
var B = /* @__PURE__ */ ((e) => (e.SET_IS_LOADING = "SET_IS_LOADING", e.SET_ERROR = "SET_ERROR", e.CLEAR_ERROR = "CLEAR_ERROR", e.SET_TRAININGS = "SET_TRAININGS", e.RESET_TRAININGS = "RESET_TRAININGS", e.SET_CURRENT_TRAINING = "SET_CURRENT_TRAINING", e.RESET_CURRENT_TRAINING = "RESET_CURRENT_TRAINING", e))(B || {});
const ja = (e, r) => {
  switch (r.type) {
    case B.SET_IS_LOADING:
      return {
        ...e,
        isLoading: r.payload
      };
    case B.SET_ERROR:
      return {
        ...e,
        error: r.payload,
        isLoading: void 0
      };
    case B.CLEAR_ERROR:
      return {
        ...e,
        error: void 0,
        isLoading: void 0
      };
    case B.SET_TRAININGS:
      return {
        ...e,
        trainings: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case B.RESET_TRAININGS:
      return {
        ...e,
        trainings: void 0,
        isLoading: void 0,
        error: void 0
      };
    case B.SET_CURRENT_TRAINING:
      return {
        ...e,
        currentTraining: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case B.RESET_CURRENT_TRAINING:
      return {
        ...e,
        currentTraining: void 0,
        isLoading: void 0,
        error: void 0
      };
    default:
      return e;
  }
}, Ga = le(void 0), en = ({ children: e, trainingId: r }) => {
  const { sessionUser: s, api: t } = me(), [n, a] = de(ja, {}), {
    isLoading: o,
    error: l,
    trainings: d,
    currentTraining: c
  } = n;
  ce(() => {
    !s || o || l || (r && t.trainings ? ((!c || c.id !== r) && (a({
      type: B.SET_IS_LOADING,
      payload: "loading training..."
    }), t.trainings.getTraining(r, {}).then((V) => {
      a({
        type: B.SET_CURRENT_TRAINING,
        payload: V.data
      });
    }).catch((V) => {
      a({
        type: B.SET_ERROR,
        payload: U(V, "Failed to load training")
      });
    })), d && a({
      type: B.RESET_TRAININGS
    })) : (!d && t.trainings && (a({
      type: B.SET_IS_LOADING,
      payload: "loading trainings..."
    }), t.trainings.getTrainings({}).then((V) => {
      a({
        type: B.SET_TRAININGS,
        payload: V.data
      });
    }).catch((V) => {
      a({
        type: B.SET_ERROR,
        payload: U(V, "Failed to load trainings")
      });
    })), c && a({
      type: B.RESET_CURRENT_TRAINING
    })));
  }, [t, s, r]);
  const i = x(async (V) => {
    if (!t.trainings) {
      a({
        type: B.SET_ERROR,
        payload: "Trainings API is not initialized"
      });
      return;
    }
    a({
      type: B.SET_IS_LOADING,
      payload: "removing training..."
    }), t.trainings.removeTraining(V, {}).then(() => {
      var w;
      (w = t.trainings) == null || w.getTrainings({}).then((A) => {
        a({
          type: B.SET_TRAININGS,
          payload: A.data
        });
      }).catch((A) => {
        a({
          type: B.SET_ERROR,
          payload: U(A, "Failed to load trainings")
        });
      });
    }).catch((w) => {
      a({
        type: B.SET_ERROR,
        payload: U(w, "Failed to remove training")
      });
    });
  }, [t, a]), p = x(() => {
    a({
      type: B.CLEAR_ERROR
    });
  }, [a]), u = x(async () => {
    if (!t.trainings) {
      a({
        type: B.SET_ERROR,
        payload: "Trainings API is not initialized"
      });
      return;
    }
    a({
      type: B.SET_IS_LOADING,
      payload: "refreshing trainings..."
    }), t.trainings.getTrainings({}).then((V) => {
      a({
        type: B.SET_TRAININGS,
        payload: V.data
      });
    }).catch((V) => {
      a({
        type: B.SET_ERROR,
        payload: U(V, "Failed to load trainings")
      });
    });
  }, [t, a]), b = x(async (V) => {
    if (!t.trainings) {
      a({
        type: B.SET_ERROR,
        payload: "Trainings API is not initialized"
      });
      return;
    }
    a({
      type: B.SET_IS_LOADING,
      payload: "refreshing training..."
    }), t.trainings.getTraining(V, {}).then((w) => {
      a(d ? {
        type: B.SET_TRAININGS,
        payload: d.map((A) => A.id === V ? {
          ...A,
          status: w.data.status,
          updated_at: w.data.updated_at
        } : A)
      } : c ? {
        type: B.SET_CURRENT_TRAINING,
        payload: w.data
      } : {
        type: B.SET_IS_LOADING
      });
    }).catch((w) => {
      a({
        type: B.SET_ERROR,
        payload: U(w, "Failed to load training")
      });
    });
  }, [t, a]), H = x(async (V, w) => {
    if (!t.trainings) {
      a({
        type: B.SET_ERROR,
        payload: "Trainings API is not initialized"
      });
      return;
    }
    a({
      type: B.SET_IS_LOADING,
      payload: "uploading training..."
    }), t.trainings.uploadTraining({ name: V, version: w }, {}).then((A) => (a({
      type: B.SET_IS_LOADING
    }), A.data.id)).catch((A) => {
      a({
        type: B.SET_ERROR,
        payload: U(A, "Failed to upload training")
      });
    });
  }, [t, a]), I = {
    refreshTrainings: u,
    refreshTraining: b,
    uploadTraining: H,
    removeTraining: i,
    clearError: p
  };
  return /* @__PURE__ */ Y(Ga.Provider, { value: { view: n, command: I }, children: e });
};
var Q = /* @__PURE__ */ ((e) => (e.SET_IS_LOADING = "SET_IS_LOADING", e.SET_ERROR = "SET_ERROR", e.CLEAR_ERROR = "CLEAR_ERROR", e.SET_TOOLS = "SET_TOOLS", e.SET_CURRENT_TOOL = "SET_CURRENT_TOOL", e.RESET_CURRENT_TOOL = "RESET_CURRENT_TOOL", e.TOOL_UPDATED = "TOOL_UPDATED", e))(Q || {});
const $a = (e, r) => {
  var s;
  switch (r.type) {
    case Q.SET_IS_LOADING:
      return {
        ...e,
        isLoading: r.payload,
        error: void 0
      };
    case Q.SET_ERROR:
      return {
        ...e,
        error: r.payload,
        isLoading: void 0
      };
    case Q.CLEAR_ERROR:
      return {
        ...e,
        error: void 0,
        isLoading: void 0
      };
    // Tools actions
    case Q.SET_TOOLS:
      return {
        ...e,
        tools: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case Q.SET_CURRENT_TOOL:
      return {
        ...e,
        currentTool: r.payload,
        isLoading: void 0,
        error: void 0
      };
    case Q.RESET_CURRENT_TOOL:
      return {
        ...e,
        currentTool: void 0,
        isLoading: void 0,
        error: void 0
      };
    case Q.TOOL_UPDATED:
      return {
        ...e,
        currentTool: e.currentTool ? e.currentTool.id === r.payload.id ? r.payload : e.currentTool : void 0,
        tools: (s = e.tools) == null ? void 0 : s.map((t) => t.id === r.payload.id ? r.payload : t),
        isLoading: void 0,
        error: void 0
      };
    default:
      return e;
  }
}, qa = le(void 0), rn = ({ children: e, toolId: r }) => {
  const { sessionUser: s, api: t } = me(), [n, a] = de($a, {}), { isLoading: o, error: l, tools: d, currentTool: c } = n;
  ce(() => {
    !s || o || l || (r && t.tools ? (!c || c.id !== r) && (a({
      type: Q.SET_IS_LOADING,
      payload: "loading tool"
    }), t.tools.getTool(r).then((b) => {
      a({
        type: Q.SET_CURRENT_TOOL,
        payload: b.data
      });
    }).catch((b) => {
      a({
        type: Q.SET_ERROR,
        payload: U(b, "Failed to load tool")
      });
    })) : (!d && t.tools && (a({
      type: Q.SET_IS_LOADING,
      payload: "loading tools"
    }), t.tools.getTools({ enabled: !1 }).then((b) => {
      a({
        type: Q.SET_TOOLS,
        payload: b.data
      });
    }).catch((b) => {
      a({
        type: Q.SET_ERROR,
        payload: U(b, "Failed to load tools")
      });
    })), c && a({
      type: Q.RESET_CURRENT_TOOL
    })));
  }, [s, o, l, r]);
  const i = x(async (b, H) => {
    if (!t.tools)
      return a({
        type: Q.SET_ERROR,
        payload: "Tools API is not initialized"
      }), !1;
    try {
      if (a({
        type: Q.SET_IS_LOADING,
        payload: "Toggling tool status"
      }), (await t.tools.updateTool(b, { enabled: H })).status !== 200)
        throw new Error("Failed to toggle tool status");
      const V = await t.tools.getTool(b);
      a({
        type: Q.TOOL_UPDATED,
        payload: V.data
      });
    } catch (I) {
      a({
        type: Q.SET_ERROR,
        payload: U(I, "Failed to toggle tool status")
      });
    }
  }, [t, a]), p = x(() => {
    a({
      type: Q.CLEAR_ERROR
    });
  }, [a]), u = {
    toggleUserToolStatus: i,
    clearError: p
  };
  return /* @__PURE__ */ Y(qa.Provider, { value: { view: n, command: u }, children: e });
}, tn = ({
  width: e = 300,
  height: r = 85,
  fill: s = "none",
  stroke: t = "black",
  strokeWidth: n = 1,
  className: a,
  style: o,
  preserveAspectRatio: l = "xMidYMid meet"
}) => /* @__PURE__ */ Y(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    width: e,
    height: r,
    viewBox: "0 0 3576 1003",
    className: a,
    style: o,
    preserveAspectRatio: l,
    children: /* @__PURE__ */ Y(
      "path",
      {
        id: "HelperLogo",
        fill: s,
        stroke: t,
        strokeWidth: n,
        d: `M 41.00,10.14
           C 41.00,10.14 79.00,10.14 79.00,10.14
             79.00,10.14 148.00,10.14 148.00,10.14
             165.79,10.03 180.76,15.61 181.00,36.00
             181.00,36.00 181.00,57.00 181.00,57.00
             181.00,57.00 182.00,72.00 182.00,72.00
             182.00,72.00 182.00,88.00 182.00,88.00
             182.00,88.00 183.91,110.00 183.91,110.00
             186.87,153.31 193.09,194.70 203.12,237.00
             211.42,272.01 219.62,300.09 234.69,333.00
             252.24,371.31 280.44,412.93 320.00,430.97
             330.57,435.79 338.47,438.60 350.00,440.41
             388.58,446.45 422.55,430.41 449.91,403.83
             457.64,396.32 464.53,387.46 471.20,379.00
             490.23,354.86 508.78,308.80 517.72,279.00
             531.91,231.71 541.41,183.12 546.17,134.00
             546.17,134.00 548.04,117.00 548.04,117.00
             548.04,117.00 548.04,109.00 548.04,109.00
             548.04,109.00 550.00,86.00 550.00,86.00
             550.00,86.00 551.00,45.00 551.00,45.00
             551.00,36.15 550.02,27.59 555.79,20.09
             562.23,11.70 574.12,10.02 584.00,10.00
             584.00,10.00 684.00,10.00 684.00,10.00
             693.11,10.04 704.20,11.93 710.47,19.17
             718.11,28.00 715.99,44.73 716.00,56.00
             716.00,56.00 716.00,693.00 716.00,693.00
             716.00,693.00 716.00,858.00 716.00,858.00
             715.99,862.41 716.01,865.76 714.44,870.00
             709.54,883.26 695.54,885.98 683.00,886.00
             683.00,886.00 586.00,886.00 586.00,886.00
             573.46,885.98 559.46,883.26 554.56,870.00
             552.99,865.76 553.01,862.41 553.00,858.00
             553.00,858.00 553.00,720.00 553.00,720.00
             553.00,720.00 553.00,655.00 553.00,655.00
             552.82,645.40 544.06,641.04 537.00,635.65
             521.18,623.57 497.77,608.79 480.00,599.76
             445.75,582.35 400.81,565.55 362.00,566.00
             353.47,566.10 340.56,568.68 332.00,570.40
             301.74,576.46 269.97,589.88 243.00,604.70
             227.33,613.30 208.08,625.51 194.00,636.42
             185.09,643.33 179.02,645.10 179.00,657.00
             179.00,657.00 179.00,830.00 179.00,830.00
             179.00,830.00 179.00,851.00 179.00,851.00
             179.00,867.03 178.97,879.73 160.00,884.49
             155.30,885.67 150.81,885.99 146.00,886.00
             146.00,886.00 49.00,886.00 49.00,886.00
             36.46,885.98 22.46,883.26 17.56,870.00
             15.99,865.76 16.01,862.41 16.00,858.00
             16.00,858.00 16.00,245.00 16.00,245.00
             16.00,245.00 16.00,54.00 16.00,54.00
             16.11,38.59 12.71,20.80 30.00,13.24
             34.20,11.41 36.60,11.15 41.00,10.14 Z`
      }
    )
  }
), an = ({
  width: e = 300,
  height: r = 85,
  fill: s = "none",
  stroke: t = "black",
  strokeWidth: n = 1,
  className: a,
  style: o,
  preserveAspectRatio: l = "xMidYMid meet"
}) => /* @__PURE__ */ Y(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    width: e,
    height: r,
    viewBox: "0 0 3576 1003",
    className: a,
    style: o,
    preserveAspectRatio: l,
    children: /* @__PURE__ */ Y(
      "path",
      {
        id: "HelperLogoText",
        fill: s,
        stroke: t,
        strokeWidth: n,
        d: `M 116.00,61.21
           C 116.00,61.21 149.00,61.21 149.00,61.21
             149.00,61.21 166.00,62.00 166.00,62.00
             166.00,62.00 186.00,62.00 186.00,62.00
             193.62,62.01 205.33,63.34 212.00,67.07
             221.22,72.22 224.89,81.31 227.37,91.00
             231.54,107.29 230.97,128.99 231.00,146.00
             231.00,146.00 231.91,158.00 231.91,158.00
             231.91,158.00 235.43,189.00 235.43,189.00
             235.43,189.00 238.08,202.00 238.08,202.00
             241.62,222.48 249.91,256.54 256.69,276.00
             256.69,276.00 262.80,291.00 262.80,291.00
             262.80,291.00 268.43,306.00 268.43,306.00
             277.27,326.52 291.23,348.18 307.00,364.00
             326.21,383.27 353.62,402.96 382.00,403.00
             382.00,403.00 389.00,403.00 389.00,403.00
             423.81,402.59 464.18,371.96 482.42,344.00
             500.85,315.76 506.30,302.58 516.75,271.00
             516.75,271.00 522.57,254.00 522.57,254.00
             528.21,234.22 531.78,214.20 535.42,194.00
             535.42,194.00 541.13,155.00 541.13,155.00
             542.20,147.35 543.97,139.75 544.00,132.00
             544.00,132.00 543.04,118.00 543.04,118.00
             542.79,112.09 543.57,110.95 543.91,106.00
             544.95,90.84 545.37,77.16 560.00,68.12
             563.28,66.09 567.26,64.79 571.00,63.90
             575.71,62.77 584.09,62.01 589.00,62.00
             589.00,62.00 671.00,62.00 671.00,62.00
             685.71,62.18 702.25,65.90 709.60,80.00
             715.22,90.78 715.00,114.63 715.00,127.00
             715.00,127.00 715.00,214.00 715.00,214.00
             715.00,214.00 715.00,645.00 715.00,645.00
             715.00,645.00 715.00,727.00 715.00,727.00
             714.91,738.25 712.49,756.34 704.53,764.70
             695.52,774.17 676.51,775.98 664.00,776.00
             664.00,776.00 593.00,776.00 593.00,776.00
             583.66,775.89 567.42,774.43 560.00,768.61
             550.51,761.15 548.14,748.44 548.00,737.00
             548.00,737.00 548.00,610.00 548.00,610.00
             547.56,572.77 507.98,557.97 479.00,546.01
             449.94,534.02 426.77,525.09 395.00,522.91
             390.63,522.61 389.03,521.84 384.00,522.04
             349.73,523.37 318.25,534.21 287.00,547.58
             257.61,560.15 226.06,573.98 226.00,611.00
             226.00,611.00 226.00,728.00 226.00,728.00
             226.00,728.00 225.09,738.00 225.09,738.00
             224.33,749.05 225.38,756.40 215.96,764.79
             207.65,772.19 187.04,775.87 176.00,776.00
             176.00,776.00 151.00,776.00 151.00,776.00
             134.31,776.00 103.10,777.00 88.00,773.79
             75.28,771.08 65.47,765.20 61.75,752.00
             60.23,746.63 60.01,743.49 60.00,738.00
             60.00,738.00 60.00,227.00 60.00,227.00
             60.00,227.00 60.00,118.00 60.00,118.00
             60.00,99.77 56.76,83.86 72.09,70.33
             82.74,60.92 102.76,63.30 116.00,61.21 Z
           M 1392.00,67.21
           C 1392.00,67.21 1412.00,67.21 1412.00,67.21
             1431.57,67.00 1462.20,66.75 1475.67,83.00
             1484.89,94.12 1486.98,114.92 1487.00,129.00
             1487.00,129.00 1487.00,625.00 1487.00,625.00
             1487.00,625.00 1487.00,717.00 1487.00,717.00
             1486.98,727.60 1485.58,743.68 1480.48,753.00
             1471.26,769.86 1453.85,773.97 1436.00,774.00
             1436.00,774.00 1411.00,774.00 1411.00,774.00
             1411.00,774.00 1395.00,775.00 1395.00,775.00
             1395.00,775.00 1382.00,774.09 1382.00,774.09
             1365.84,772.96 1347.11,769.59 1339.52,753.00
             1336.75,746.94 1336.01,739.59 1336.00,733.00
             1336.00,733.00 1336.00,230.00 1336.00,230.00
             1336.00,230.00 1336.00,128.00 1336.00,128.00
             1336.00,114.56 1334.07,94.77 1343.21,84.00
             1358.00,66.57 1372.46,70.20 1392.00,67.21 Z
           M 3272.00,242.21
           C 3272.00,242.21 3293.00,242.21 3293.00,242.21
             3293.00,242.21 3305.00,243.04 3305.00,243.04
             3305.00,243.04 3314.00,243.04 3314.00,243.04
             3349.19,246.52 3391.01,254.91 3422.00,272.42
             3441.06,283.20 3460.88,293.13 3461.00,318.00
             3461.09,337.52 3450.00,359.74 3441.24,377.00
             3436.84,385.69 3430.48,395.12 3421.00,398.73
             3405.68,404.56 3387.48,392.78 3374.00,387.00
             3351.16,377.21 3331.86,371.65 3307.00,369.91
             3307.00,369.91 3297.00,369.00 3297.00,369.00
             3275.69,368.75 3256.70,368.53 3239.00,382.52
             3229.08,390.36 3222.90,401.81 3229.00,414.00
             3240.34,436.69 3279.30,444.92 3302.00,450.88
             3356.88,465.31 3403.74,472.29 3446.96,513.17
             3450.67,516.68 3457.20,524.75 3460.34,529.00
             3497.80,579.30 3493.68,650.74 3460.34,702.00
             3444.85,725.74 3426.39,741.62 3402.00,755.57
             3375.85,770.54 3346.97,778.90 3317.00,781.09
             3317.00,781.09 3305.00,782.04 3305.00,782.04
             3305.00,782.04 3291.00,782.04 3291.00,782.04
             3291.00,782.04 3279.00,782.99 3279.00,782.99
             3279.00,782.99 3265.00,782.00 3265.00,782.00
             3265.00,782.00 3235.00,782.00 3235.00,782.00
             3223.54,781.86 3202.42,777.73 3191.00,774.87
             3169.15,769.41 3149.75,763.30 3129.00,754.42
             3116.95,749.27 3097.02,739.26 3088.18,729.91
             3068.03,708.58 3085.90,671.77 3096.75,650.00
             3101.39,640.70 3106.80,629.60 3117.00,625.48
             3132.02,619.41 3156.92,633.20 3171.00,638.99
             3184.09,644.37 3213.63,652.25 3228.00,655.42
             3240.36,658.15 3258.65,662.37 3271.00,662.96
             3291.15,663.93 3312.15,660.08 3329.00,648.28
             3336.37,643.11 3344.51,634.89 3343.45,625.00
             3341.41,606.00 3313.03,591.02 3297.00,584.81
             3277.14,577.11 3254.68,572.80 3234.00,567.63
             3204.40,560.23 3168.53,548.93 3143.00,532.31
             3127.73,522.36 3116.38,510.07 3106.33,495.00
             3064.86,432.78 3075.22,341.55 3131.00,291.17
             3154.59,269.87 3178.99,260.98 3209.00,252.85
             3209.00,252.85 3241.00,245.28 3241.00,245.28
             3241.00,245.28 3259.00,243.09 3259.00,243.09
             3259.00,243.09 3272.00,242.21 3272.00,242.21 Z
           M 921.00,565.00
           C 928.83,580.28 930.40,591.81 942.16,608.00
             961.61,634.80 991.70,649.64 1024.00,654.27
             1024.00,654.27 1040.00,656.00 1040.00,656.00
             1071.44,656.36 1091.61,652.61 1121.00,641.19
             1136.82,635.04 1158.69,620.90 1175.00,622.09
             1192.60,623.37 1210.28,643.28 1222.00,655.00
             1229.43,662.43 1236.37,668.92 1241.93,678.00
             1245.40,683.65 1246.00,686.48 1246.00,693.00
             1246.00,716.86 1218.00,729.82 1200.00,739.86
             1171.75,755.62 1144.83,768.56 1113.00,775.58
             1080.58,782.73 1043.20,782.05 1010.00,782.00
             992.56,781.97 968.84,777.63 952.00,772.86
             888.94,754.99 831.49,712.98 801.26,654.00
             789.41,630.88 781.88,603.56 777.59,578.00
             769.33,528.78 771.52,472.43 783.63,424.00
             791.21,393.68 802.66,363.72 820.72,338.00
             852.34,292.96 907.04,258.30 961.00,247.45
             990.10,241.59 1021.34,242.66 1051.00,243.00
             1051.00,243.00 1061.00,243.91 1061.00,243.91
             1158.51,250.73 1236.12,318.76 1260.37,413.00
             1269.70,449.26 1270.00,467.25 1270.00,504.00
             1270.00,523.87 1272.95,547.11 1253.00,558.91
             1249.59,560.92 1245.84,562.18 1242.00,563.10
             1236.75,564.37 1230.40,564.99 1225.00,565.00
             1225.00,565.00 921.00,565.00 921.00,565.00 Z
           M 1715.00,291.00
           C 1736.56,276.64 1764.27,259.69 1789.00,252.02
             1818.09,243.01 1853.64,242.65 1884.00,243.00
             1884.00,243.00 1894.00,243.91 1894.00,243.91
             1912.61,245.19 1930.23,248.08 1948.00,254.00
             2023.00,279.00 2071.29,340.11 2094.02,414.00
             2128.30,525.40 2104.75,669.28 2005.00,740.57
             1990.05,751.26 1975.03,759.39 1958.00,766.20
             1935.68,775.13 1918.78,778.79 1895.00,781.17
             1895.00,781.17 1886.00,782.00 1886.00,782.00
             1846.48,782.46 1806.64,781.47 1770.00,764.69
             1756.47,758.49 1744.82,751.13 1733.00,742.12
             1733.00,742.12 1720.00,732.00 1720.00,732.00
             1720.00,732.00 1720.00,912.00 1720.00,912.00
             1719.99,918.20 1718.90,928.07 1717.26,934.00
             1715.86,939.04 1713.80,944.63 1710.90,949.00
             1696.94,970.00 1674.26,970.00 1652.00,970.00
             1652.00,970.00 1625.00,970.00 1625.00,970.00
             1625.00,970.00 1616.00,969.17 1616.00,969.17
             1605.31,968.15 1598.50,968.31 1589.00,961.78
             1570.09,948.78 1565.03,922.56 1565.00,901.00
             1565.00,901.00 1565.00,412.00 1565.00,412.00
             1565.00,412.00 1565.00,300.00 1565.00,300.00
             1565.15,287.46 1568.01,272.79 1578.01,264.33
             1590.22,254.00 1607.19,256.17 1622.00,256.00
             1622.00,256.00 1635.00,255.00 1635.00,255.00
             1661.17,254.70 1699.95,247.81 1711.94,279.00
             1713.58,283.28 1714.59,286.41 1715.00,291.00 Z
           M 2309.00,562.00
           C 2311.80,575.87 2320.00,593.38 2328.02,605.00
             2352.81,640.90 2391.30,657.07 2434.00,657.00
             2443.02,656.99 2460.23,654.77 2469.00,652.52
             2469.00,652.52 2530.00,632.33 2530.00,632.33
             2530.00,632.33 2554.00,624.60 2554.00,624.60
             2562.71,623.35 2573.99,629.76 2581.00,634.34
             2599.61,646.52 2626.65,673.00 2625.98,697.00
             2625.52,713.78 2602.88,727.94 2590.00,735.94
             2566.88,750.29 2541.76,761.08 2516.00,769.67
             2498.43,775.52 2472.44,781.91 2454.00,782.00
             2454.00,782.00 2398.00,782.00 2398.00,782.00
             2387.12,781.98 2368.90,779.45 2358.00,777.39
             2289.45,764.46 2221.81,719.80 2188.31,658.00
             2150.07,587.46 2149.97,489.73 2171.58,414.00
             2180.17,383.88 2194.64,351.70 2214.01,327.00
             2240.45,293.30 2280.57,267.86 2321.00,254.33
             2339.00,248.31 2362.02,243.23 2381.00,243.00
             2410.00,242.66 2440.52,241.75 2469.00,247.45
             2525.31,258.71 2577.79,291.22 2610.25,339.00
             2617.97,350.35 2623.10,360.59 2628.70,373.00
             2642.41,403.42 2649.77,435.81 2652.09,469.00
             2652.09,469.00 2653.00,481.00 2653.00,481.00
             2653.00,481.00 2653.00,528.00 2653.00,528.00
             2652.70,553.20 2635.74,564.96 2612.00,565.00
             2612.00,565.00 2393.00,565.00 2393.00,565.00
             2393.00,565.00 2378.00,566.00 2378.00,566.00
             2378.00,566.00 2354.00,566.00 2354.00,566.00
             2354.00,566.00 2335.00,565.00 2335.00,565.00
             2326.43,564.99 2317.43,563.54 2309.00,562.00 Z
           M 2870.00,302.00
           C 2903.65,268.38 2947.30,243.43 2996.00,244.00
             3008.71,244.15 3023.32,247.50 3032.99,256.18
             3043.78,265.88 3048.93,283.82 3049.00,298.00
             3049.00,298.00 3050.00,316.00 3050.00,316.00
             3050.00,316.00 3050.00,332.00 3050.00,332.00
             3050.00,332.00 3049.09,344.00 3049.09,344.00
             3048.18,356.45 3046.92,367.97 3036.99,376.81
             3024.11,388.28 3001.12,385.82 2985.00,386.00
             2952.02,386.39 2915.59,407.11 2895.90,433.00
             2886.96,444.75 2880.43,458.81 2876.43,473.00
             2869.43,497.79 2870.00,529.25 2870.00,555.00
             2870.00,555.00 2870.00,663.00 2870.00,663.00
             2870.00,683.01 2871.36,717.71 2868.41,736.00
             2866.18,749.84 2861.20,761.40 2848.00,768.01
             2839.01,772.51 2824.05,773.98 2814.00,774.00
             2814.00,774.00 2773.00,774.00 2773.00,774.00
             2773.00,774.00 2763.00,773.09 2763.00,773.09
             2752.09,772.33 2740.70,771.37 2732.02,763.79
             2720.83,754.02 2719.02,734.04 2719.00,720.00
             2719.00,720.00 2719.00,468.00 2719.00,468.00
             2719.00,468.00 2719.00,353.00 2719.00,353.00
             2719.00,353.00 2718.00,338.00 2718.00,338.00
             2717.97,319.58 2717.36,300.97 2722.15,283.00
             2725.14,271.81 2730.45,262.12 2742.00,258.10
             2747.12,256.32 2751.66,256.01 2757.00,256.00
             2757.00,256.00 2829.00,256.00 2829.00,256.00
             2838.85,256.12 2851.67,259.03 2858.82,266.18
             2867.16,274.53 2869.75,290.60 2870.00,302.00 Z
           M 1130.00,452.00
           C 1129.38,445.14 1125.89,436.54 1123.42,430.00
             1119.19,418.78 1113.54,407.16 1105.70,398.00
             1086.27,375.30 1055.12,365.95 1026.00,366.00
             977.11,366.08 934.54,404.75 925.00,452.00
             925.00,452.00 1130.00,452.00 1130.00,452.00 Z
           M 2514.00,452.00
           C 2513.36,444.43 2510.74,437.16 2508.33,430.00
             2503.99,417.12 2497.18,404.98 2487.83,395.04
             2460.68,366.18 2415.22,359.81 2379.00,372.70
             2354.54,381.40 2331.30,400.18 2320.31,424.00
             2315.63,434.15 2314.03,441.19 2312.00,452.00
             2312.00,452.00 2514.00,452.00 2514.00,452.00 Z
           M 1816.00,373.14
           C 1816.00,373.14 1803.00,374.44 1803.00,374.44
             1781.45,377.80 1758.89,387.54 1744.17,404.00
             1724.16,426.37 1718.90,456.12 1716.91,485.00
             1716.91,485.00 1716.00,497.00 1716.00,497.00
             1716.00,497.00 1716.00,526.00 1716.00,526.00
             1716.05,554.98 1726.11,591.45 1746.09,613.00
             1752.89,620.34 1757.69,624.50 1766.00,630.00
             1776.00,636.61 1785.69,640.64 1797.00,644.33
             1806.51,647.43 1823.09,650.88 1833.00,651.00
             1842.10,651.10 1851.15,649.38 1860.00,647.35
             1915.30,634.67 1946.59,591.30 1954.13,537.00
             1954.13,537.00 1956.00,518.00 1956.00,518.00
             1956.47,477.54 1949.64,434.98 1919.83,405.17
             1899.64,384.98 1871.57,373.34 1843.00,373.14
             1843.00,373.14 1816.00,373.14 1816.00,373.14 Z`
      }
    )
  }
);
export {
  W as AdminActionType,
  ma as AdminApi,
  ua as AdminApiAxiosParamCreator,
  Ls as AdminApiFactory,
  se as AdminApiFp,
  xa as AdminContext,
  zs as AdminProvider,
  j as AppActionType,
  Ur as AppContext,
  Qs as AppProvider,
  hs as AuthenticatedUserRoleEnum,
  us as AuthenticatedUserStatusEnum,
  f as Color,
  oe as Configuration,
  P as ConvActionType,
  Ba as ConversationContext,
  Ws as ConversationProvider,
  Sa as ConversationsApi,
  Ra as ConversationsApiAxiosParamCreator,
  Ns as ConversationsApiFactory,
  G as ConversationsApiFp,
  ms as DeviceInfoDeviceTypeEnum,
  F as DocsActionType,
  Dr as DocumentsContext,
  Zs as DocumentsProvider,
  Rs as GetTrainingsFilterParameterStatusEnum,
  ys as HelperSkillHelperEnabledEnum,
  Ss as HelperStatusEnum,
  Es as HelperSummaryStatusEnum,
  Os as HelperViewStatusEnum,
  g as HelpersActionType,
  Ea as HelpersApi,
  ya as HelpersApiAxiosParamCreator,
  fs as HelpersApiFactory,
  $ as HelpersApiFp,
  Ma as HelpersContext,
  Ys as HelpersProvider,
  Ta as KnowledgebaseApi,
  Oa as KnowledgebaseApiAxiosParamCreator,
  Bs as KnowledgebaseApiFactory,
  q as KnowledgebaseApiFp,
  tn as Logo,
  an as LogoText,
  Ts as MessageRoleEnum,
  vs as MessageViewAllOfSenderRoleEnum,
  _s as MessageViewStatusEnum,
  va as RegistrationApi,
  _a as RegistrationApiAxiosParamCreator,
  Fs as RegistrationApiFactory,
  $e as RegistrationApiFp,
  Vs as SearchDocumentsFilterParameterQueryTypeEnum,
  Ha as SessionApi,
  Va as SessionApiAxiosParamCreator,
  ks as SessionApiFactory,
  ge as SessionApiFp,
  Hs as SignupRequestRoleEnum,
  gs as SignupRequestStatusEnum,
  Q as ToolsActionType,
  wa as ToolsApi,
  ga as ToolsApiAxiosParamCreator,
  Ms as ToolsApiFactory,
  ne as ToolsApiFp,
  qa as ToolsContext,
  rn as ToolsProvider,
  ws as TrainingSummaryStatusEnum,
  bs as TrainingViewStatusEnum,
  B as TrainingsActionType,
  Ia as TrainingsApi,
  ba as TrainingsApiAxiosParamCreator,
  js as TrainingsApiFactory,
  ee as TrainingsApiFp,
  Ga as TrainingsContext,
  en as TrainingsProvider,
  Is as TrainingsViewInnerStatusEnum,
  Cs as UserRegistrationRoleEnum,
  Us as UserRegistrationStatusEnum,
  Ps as UserRoleEnum,
  As as UserStatusEnum,
  Ds as UserViewRoleEnum,
  xs as UserViewStatusEnum,
  K as UsersActionType,
  Na as UsersContext,
  Js as UsersProvider,
  Aa as darkPalette,
  qs as elevation,
  U as getErrorMessage,
  Ks as getPalette,
  Ca as initialState,
  Pa as lightPalette,
  $s as spacing,
  Gs as typography,
  Xs as useDocuments,
  me as useSession
};
//# sourceMappingURL=common.js.map
